import { IconProps } from "@archetypes/generic";

export function ProfileSettingsIcon({ color, size }: { color?: string; size?: string }) {
  return (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={size || "50px"}
      height={size || "50px"}
      style={{
        width: "30px",
        height: "30px",
        padding: "5px",
      }}
    >
      <path
        fill={color || "currentColor"}
        d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"
      />
    </svg>
  );
}

export function DataModelIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.36997 9.50993C2.28997 9.79993 2.29997 15.7099 6.36997 15.9999H16.03C17.2 16.0099 18.33 15.5699 19.2 14.7799C22.06 12.2799 20.53 7.27991 16.76 6.79991C15.41 -1.34009 3.61998 1.74993 6.40998 9.50993"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V19"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21H14"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 21H6"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Cross({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={color}
        d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"
      />
    </svg>
  );
}

export function AddTopbarIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 29 29"
      width={size}
      height={size}
    >
      <path
        fill={color}
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M14.5 22V7M7 14.5h15"
      />
    </svg>
  );
}

export function NotificationIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fill={color} d="M0 0h24v24H0V0z" />
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z" />
    </svg>
  );
}

export function FileDownloadIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10H13L9 14L5 10H8V6H10V10ZM12 2H2V18H16V6H12V2ZM0 0.992C0 0.444 0.447 0 0.999 0H13L18 5V18.993C18.0009 19.1243 17.976 19.2545 17.9266 19.3762C17.8772 19.4979 17.8043 19.6087 17.7121 19.7022C17.6199 19.7957 17.5101 19.8701 17.3892 19.9212C17.2682 19.9723 17.1383 19.9991 17.007 20H0.993C0.730378 19.9982 0.479017 19.8931 0.293218 19.7075C0.107418 19.5219 0.00209465 19.2706 0 19.008V0.992Z"
        fill={color}
      />
    </svg>
  );
}

export function FileDeleteIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 2V0H15V2H20V4H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V4H0V2H5ZM4 4V18H16V4H4ZM7 7H9V15H7V7ZM11 7H13V15H11V7Z"
        fill={color}
      />
    </svg>
  );
}

export function EditIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.728 6.68601L11.314 5.27201L2 14.586V16H3.414L12.728 6.68601ZM14.142 5.27201L15.556 3.85801L14.142 2.44401L12.728 3.85801L14.142 5.27201ZM4.242 18H0V13.757L13.435 0.322007C13.6225 0.134536 13.8768 0.0292206 14.142 0.0292206C14.4072 0.0292206 14.6615 0.134536 14.849 0.322007L17.678 3.15101C17.8655 3.33853 17.9708 3.59284 17.9708 3.85801C17.9708 4.12317 17.8655 4.37748 17.678 4.56501L4.243 18H4.242Z"
        fill={color}
      />
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 471.2 471.2"
      style={{
        width: "30px",
        height: "30px",
        padding: "5px",
      }}
    >
      <g>
        <g>
          <path
            d="M227.619,444.2h-122.9c-33.4,0-60.5-27.2-60.5-60.5V87.5c0-33.4,27.2-60.5,60.5-60.5h124.9c7.5,0,13.5-6,13.5-13.5
			s-6-13.5-13.5-13.5h-124.9c-48.3,0-87.5,39.3-87.5,87.5v296.2c0,48.3,39.3,87.5,87.5,87.5h122.9c7.5,0,13.5-6,13.5-13.5
			S235.019,444.2,227.619,444.2z"
          />
          <path
            d="M450.019,226.1l-85.8-85.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1l62.8,62.8h-273.9c-7.5,0-13.5,6-13.5,13.5
			s6,13.5,13.5,13.5h273.9l-62.8,62.8c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8
			C455.319,239.9,455.319,231.3,450.019,226.1z"
          />
        </g>
      </g>
    </svg>
  );
}

export function AddDriverIcon({ width, height }: { width: number; height: number }) {
  return (
    <svg
      width={width ? width : "752pt"}
      height={height ? height : "752pt"}
      version="1.1"
      viewBox="0 0 752 752"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m522.81 516.13v-106.98c-0.066406-19.844-6.4297-39.152-18.176-55.145-11.746-15.992-28.266-27.844-47.18-33.84 6.4609-3.5469 11.852-8.7617 15.609-15.102 3.7578-6.3398 5.7422-13.57 5.75-20.941v-37.457c-0.011718-2.5938-0.26562-5.1758-0.75781-7.7227 1.4805-6.7617 0.55859-13.828-2.6055-19.984-12.172-22.258-89.98-35.234-98.695-36.652h-1.5156c-8.8086 1.4219-86.523 14.207-98.883 36.656v-0.003906c-3.0977 6.1797-3.9531 13.246-2.4141 19.984-0.49219 2.5469-0.74609 5.1289-0.75781 7.7227v37.457c0.007812 7.3711 1.9922 14.602 5.75 20.941s9.1484 11.555 15.609 15.102c-18.914 5.9961-35.438 17.848-47.18 33.84-11.746 15.992-18.109 35.301-18.176 55.145v106.98l-45.984 45.938c-1.3438 1.3633-1.7383 3.3984-0.99609 5.1641 0.72656 1.7656 2.4453 2.9258 4.3594 2.9336h378.86c1.9102-0.007813 3.6289-1.168 4.3555-2.9336 0.74219-1.7656 0.35156-3.8008-0.99219-5.1641zm-9.4727-106.98v102.29c-5.4453-1.7539-10.891-3.3633-16.34-4.7344 0.75781-11.223 1.2773-23.965 1.043-36.844v-0.003907c4.0117-1.3672 7.3438-4.2227 9.3086-7.9766 1.9648-3.7539 2.4141-8.1211 1.2539-12.195l-10.086-34.57h-0.003906c-0.92969-3.1562-2.7773-5.9609-5.3086-8.0586-2.5312-2.1016-5.6289-3.4023-8.8984-3.7344-12.703-22.625-28.766-43.191-47.641-61 2.3125-5.1641 4.2734-10.48 5.8711-15.91 19.695 3.1562 37.629 13.207 50.598 28.363 12.969 15.152 20.129 34.426 20.203 54.371zm-25.004 53.797-5.5898 1.6562-4.7344 1.375-2.2734 0.66406c-0.84375 0.16406-1.7148 0.16406-2.5586 0-2.8867-0.25-5.3281-2.2422-6.1562-5.0195l-10.133-34.57c-0.53516-1.8047-0.32812-3.7461 0.56641-5.3984 0.89844-1.6445 2.4141-2.8555 4.2148-3.3633l0.89844-0.28516 4.7344-1.3242 4.7344-1.375 7.1055-2.082 1.7539-0.47266v-0.003906c0.63281-0.1875 1.2852-0.28125 1.9414-0.28125 0.42578-0.046875 0.85547-0.046875 1.2812 0 2.5781 0.4375 4.707 2.2578 5.5391 4.7344l6.6289 22.684 3.457 11.887h0.003906c0.52734 1.7891 0.32422 3.7148-0.57031 5.3516-0.31641 0.53516-0.71484 1.0156-1.1836 1.4219-0.8125 0.92578-1.8594 1.6133-3.0312 1.9883l-1.6094 0.47266zm0 9.8047c0 10.891-0.33203 21.738-0.94531 31.445-3.9766-1.043-8.0039-1.9883-11.98-2.8906l-0.003906 0.003906c3.2969-8.5742 5.4805-17.535 6.4883-26.664zm-53.23-51.004c-0.80859-1.0703-2.0312-1.75-3.3672-1.8672-1.3359-0.11719-2.6602 0.33594-3.6445 1.25l-18.941 18.941v0.003906c-4.1992-2.7656-8.7344-4.9805-13.496-6.582l22.59-22.59c0.99609-0.99609 1.5-2.3867 1.3711-3.7891-0.13281-1.3984-0.87891-2.6641-2.0352-3.457-12.086-8.3828-26.445-12.875-41.156-12.875-14.707 0-29.066 4.4922-41.152 12.875-1.1406 0.80078-1.8672 2.0664-1.9883 3.457-0.12891 1.4023 0.375 2.793 1.3711 3.7891l22.402 22.777c-4.7695 1.5938-9.3047 3.8086-13.496 6.582l-18.941-18.941h-0.003906c-0.98828-1-2.3672-1.5078-3.7656-1.3867-1.3984 0.11719-2.6758 0.85156-3.4805 2-7.3203 10.566-11.695 22.895-12.668 35.715-0.97656 12.82 1.4844 25.668 7.1289 37.219-8.5703 1.2773-17.145 2.6992-25.715 4.7344-2.9336-7.3828-4.9531-15.098-6.0156-22.969 3.332-0.19531 6.5234-1.4258 9.1211-3.5234 2.5977-2.0977 4.4766-4.957 5.3711-8.1719l10.133-34.57v-0.003906c1.1523-3.9844 0.76172-8.2539-1.0859-11.965-1.8516-3.7109-5.0312-6.5898-8.9062-8.0664 3.7188-5.7188 8.0195-11.035 12.836-15.863 9-9.0078 19.684-16.152 31.445-21.027 1.7539-0.71094 3.5508-1.3242 5.3516-1.9414 1.8008-0.61719 3.9766-1.375 5.9688-1.8945h-0.003907c17.035-4.7852 35.059-4.7852 52.094 0 1.9883 0.56641 3.9766 1.2305 5.918 1.8945 1.9414 0.66406 3.5977 1.2305 5.3516 1.9414h0.003907c11.781 4.8828 22.484 12.043 31.492 21.074 4.8359 4.8086 9.1406 10.129 12.836 15.863-3.6562 1.3516-6.6992 3.9766-8.5742 7.3867-2.1211 3.8477-2.6172 8.3867-1.3711 12.598l10.133 34.57v0.003906c0.92188 3.1523 2.7695 5.957 5.3008 8.0508 2.5352 2.0938 5.6367 3.3789 8.9062 3.6914-1.1328 7.6953-3.168 15.23-6.0625 22.449-8.5703-1.8008-17.191-3.2188-25.762-4.7344 5.5938-11.516 8.0352-24.305 7.0703-37.066-0.96484-12.766-5.3008-25.043-12.562-35.582zm-109.26 67.91c0.13281-14.051 6.1836-27.395 16.672-36.75 1.1602-1.0742 2.3789-2.0859 3.6445-3.0312 1.3242-0.94531 2.6523-1.8477 4.0273-2.6992 4.3945-2.6836 9.1914-4.6523 14.207-5.8242 1.875-0.44531 3.7734-0.79297 5.6836-1.043 1.9414 0 3.8828-0.37891 5.8711-0.37891s3.9766 0 5.918 0.37891 3.7891 0.61719 5.6836 1.043h0.003906c5 1.2188 9.7891 3.1836 14.207 5.8242 1.4219 0.85156 2.7461 1.7539 4.0273 2.6992 1.2773 0.94531 2.5117 1.9883 3.6953 3.0312h-0.003906c10.457 9.3711 16.492 22.711 16.621 36.75 0.023437 0.14062 0.023437 0.28516 0 0.42578v2.6523l-3.8828-0.37891c-2.4609-0.28516-4.9727-0.56641-7.4336-0.75781-7.1992-0.66406-14.207-1.1367-21.5-1.4219h-13.688-6.9609-6.8203-6.8672c-7.1523 0.28516-14.207 0.75781-21.5 1.4219-2.4609 0-4.9727 0.47266-7.4844 0.75781l-3.8828 0.37891v-2.6523zm-8.9961-6.8672c-5.6758-16.812-3.957-35.246 4.7344-50.719l14.207 14.207c-10.426 9.5352-17.137 22.453-18.941 36.465zm28.414-74.164v0.003906c19.172-10.852 42.629-10.852 61.801 0l-22.543 22.496 0.003906-0.003906c-5.5547-0.88281-11.215-0.88281-16.766 0zm71.039 37.602 14.207-14.207v0.003906c8.6953 15.469 10.418 33.906 4.7344 50.719-1.7656-14.074-8.5195-27.043-19.039-36.559zm-139.75 20.414-2.5117-0.66406-4.7344-1.4219-5.6367-1.6094-4.7344-1.375-1.3281-0.32812c-1.1953-0.37891-2.2617-1.0859-3.0781-2.0352-0.45312-0.39063-0.83594-0.85547-1.1367-1.375-0.9375-1.6758-1.1289-3.6719-0.51953-5.4922l3.4102-11.746 6.6758-22.828c0.80078-2.4805 2.9219-4.3086 5.4961-4.7344 0.42188-0.046875 0.85156-0.046875 1.2773 0 0.67188 0 1.3438 0.097656 1.9883 0.28516l1.7031 0.47266 7.1055 2.082 4.7344 1.3242 4.7344 1.375 0.94531 0.28516h0.003906c3.707 1.1406 5.8125 5.0391 4.7383 8.7617l-10.133 34.57h-0.003906c-0.52344 1.793-1.7305 3.3086-3.3633 4.2148-1.6641 0.85547-3.5898 1.0586-5.3984 0.57031zm0 34.668c-4.0273 0.89844-8.0508 1.8477-12.027 2.8906-0.61719-9.4727-1.043-20.555-0.94531-31.445l6.4883 1.8945-0.003906-0.003906c1.0078 9.1289 3.1875 18.09 6.4883 26.664zm39.449-201.09c19.922 2.1914 39.957 3.2344 60 3.1289 20.887 0.34766 41.77-0.69922 62.516-3.1289-0.71094 4.7344-1.7031 10.23-2.9844 15.676v0.28516c-0.33203 1.4688-0.71094 2.9375-1.0898 4.4531v0.23828c-0.42578 1.4688-0.85156 2.9844-1.3242 4.5v-0.003906c-1.3086 4.5273-2.8906 8.9727-4.7383 13.309-0.75781 1.6094-1.5625 3.1719-2.3672 4.7344-0.80469 1.5625-1.7539 3.1719-2.6992 4.7344v0.003906c-2.6562 4.3945-5.8203 8.4648-9.4258 12.121-0.66406 0.71094-1.4219 1.3242-2.1328 1.9883h0.003906c-22.996-8.0469-48.043-8.0469-71.039 0l-2.1328-1.9414h0.003906c-3.4961-3.6914-6.5781-7.7578-9.1875-12.121-0.94531-1.5625-1.8477-3.125-2.6992-4.7344s-1.6094-3.125-2.3203-4.7344v-0.003906c-2.0117-4.3242-3.75-8.7695-5.2109-13.309-0.47266-1.5156-0.89844-3.0312-1.3242-4.5l-0.003906 0.003906c0.007812-0.082031 0.007812-0.16016 0-0.23828-0.42578-1.5156-0.75781-2.9844-1.1367-4.4531v-0.28516c-1.5117-5.6328-2.2695-10.984-3.2188-15.723zm-3.6484-9.9922-4.7344-0.80469c-1.8008-0.28516-3.457-0.61719-4.7344-0.94531h-0.003906c-2.1914-0.44922-4.3438-1.0664-6.4375-1.8477 1.6797-1.4922 3.4336-2.8984 5.2539-4.2148l0.75781-0.56641c1.375-0.94531 2.9375-1.9414 4.7344-2.9844l1.9883-1.1836 2.6992-1.4219 2.2266-1.1367c1.5156-0.75781 3.0781-1.4688 4.7344-2.1797h0.003906c8.8359-3.6719 18.07-6.3125 27.516-7.8594 9.7969-1.6172 19.715-2.3906 29.645-2.3203 10.113-0.054687 20.207 0.78516 30.168 2.5078 9.3125 1.5742 18.414 4.1953 27.137 7.8164l4.4062 1.9883 2.793 1.4219c0.89844 0.42578 1.7539 0.89844 2.5117 1.3242l2.1797 1.2773c1.7031 1.043 3.2695 2.0352 4.7344 2.9844l0.66406 0.47266h-0.003906c1.8516 1.3164 3.6211 2.7422 5.3047 4.2617-2.0898 0.74219-4.2266 1.3438-6.3945 1.8008-1.4219 0.33203-3.0781 0.66406-4.7344 0.94531l-4.7344 0.80469v0.003906c-21.242 2.5977-42.633 3.7695-64.031 3.5039-21.27 0.25391-42.535-0.91797-63.648-3.5039zm162.06 114.66-7.4336 2.1797v-0.003906c-4.2969-7.125-9.3945-13.738-15.203-19.699-8.8398-8.7969-19.164-15.965-30.496-21.168 4.2773-4.5625 8-9.6172 11.082-15.062 16.371 15.945 30.516 34.027 42.051 53.754zm-154.57-53.703c3.082 5.3984 6.7852 10.422 11.035 14.965-11.371 5.2109-21.742 12.379-30.645 21.168-5.8984 5.9453-11.066 12.574-15.391 19.746l-7.3867-2.1797v0.003906c11.609-19.754 25.871-37.82 42.387-53.703zm149.51-67.062c-0.011719 7.0078-2.3398 13.812-6.6211 19.352-4.2852 5.543-10.281 9.5117-17.059 11.289 1.2305-5.7773 2.1797-11.32 2.793-16.387 12.504-2.7461 18.941-6.582 18.941-11.555h0.003906c-0.015625-1.0508-0.38281-2.0664-1.043-2.8867-2.1602-2.5703-4.5898-4.9062-7.2461-6.9609 3.8242-4.9844 7.3047-10.223 10.422-15.676zm-186.21-56.164c0.3125-1.5273 0.82031-3.0078 1.5156-4.4062 3.5977-6.3945 17-12.645 33.531-18.043h-0.003907c18.926-5.9414 38.25-10.527 57.824-13.734 19.578 3.207 38.898 7.793 57.824 13.734 16.527 5.3984 29.93 11.648 33.531 18.043 0.69531 1.3984 1.2031 2.8789 1.5156 4.4062 0.66016 3.7461 0.5 7.5938-0.47266 11.27-3.5664 11.797-9.4258 22.773-17.238 32.301l-1.6094-0.94531-0.003906-0.003907c-2.5117-1.5078-5.1055-2.8828-7.7656-4.1211-10.707-5.0664-22.074-8.6055-33.766-10.512-7.8281-1.3516-15.738-2.1562-23.68-2.4141-2.7461 0-5.4453-0.23828-8.3359-0.23828s-5.5898 0-8.3359 0.23828h0.003907c-7.9414 0.25781-15.852 1.0625-23.68 2.4141-11.691 1.9062-23.059 5.4453-33.766 10.512-2.6602 1.2383-5.2539 2.6133-7.7695 4.1211l-1.6094 0.94531v0.003906c-7.8125-9.5273-13.672-20.504-17.238-32.301-0.97266-3.6758-1.1328-7.5234-0.47266-11.27zm-0.47266 56.168v-22.828c3.1133 5.4531 6.5938 10.691 10.418 15.676-2.5898 2.0664-4.9531 4.3984-7.0586 6.9609-0.65625 0.82031-1.0234 1.8359-1.0391 2.8867 0 5.5391 5.4922 9.0938 18.941 11.699 0.66406 5.0195 1.5625 10.512 2.793 16.242-6.8438-1.7031-12.926-5.6445-17.281-11.191-4.3594-5.5508-6.7422-12.391-6.7734-19.449zm-43.996 125.02c0.082032-19.98 7.2773-39.281 20.293-54.441 13.016-15.156 31.004-25.188 50.742-28.293 1.6211 5.4219 3.582 10.738 5.875 15.91-18.961 17.789-35.105 38.359-47.879 61-3.2734 0.33203-6.3711 1.6328-8.8984 3.7344-2.5312 2.0977-4.3789 4.9023-5.3125 8.0586l-10.086 34.57c-1.2305 4.0547-0.82813 8.4336 1.1172 12.199 1.9453 3.7695 5.2812 6.6289 9.3008 7.9727-0.23828 12.883 0.28516 25.668 1.043 36.891-5.4453 1.5156-10.891 3.125-16.34 4.7344zm284.15 151.55h-324.83l38.504-38.504 2.1797-0.66406c5.6836-1.8477 11.367-3.5977 17.051-5.2109l4.7344-1.2305 4.7344-1.2773c5.0664-1.3242 10.133-2.5586 15.25-3.6953l9.4688-2.0859c8.9492-1.8477 17.902-3.3164 26.852-4.7344h1.3242l4.7344-0.66406 4.1211-0.47266h0.61719c7.1523-0.80469 14.207-1.4219 21.406-1.8477l7.1523-0.47266h6.9609c8.7461-0.28516 17.508-0.28516 26.285 0h6.9609l7.1523 0.47266c7.1055 0.42578 14.207 1.043 21.359 1.8477h0.66406l4.0742 0.47266 4.7344 0.66406h1.3242c8.9492 1.2305 17.902 2.6992 26.852 4.7344l9.4688 2.0859c5.082 1.1367 10.152 2.3672 15.203 3.6953l4.7344 1.2773 4.7344 1.2305c5.6836 1.6094 11.367 3.3633 17.051 5.2109l2.1797 0.66406 7.293 7.293 30.879 31.211z" />
    </svg>
  );
}

export function AddDocumentIcon() {
  return (
    <svg
      width="752pt"
      height="752pt"
      version="1.1"
      viewBox="0 0 752 752"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m415.46 198.41h-157.86c-5.2344 0-10.25 2.0781-13.953 5.7773-3.6992 3.6992-5.7773 8.7188-5.7773 13.953v315.72c0 5.2305 2.0781 10.25 5.7773 13.953 3.7031 3.6992 8.7188 5.7773 13.953 5.7773h236.79c5.2305 0 10.25-2.0781 13.953-5.7773 3.6992-3.7031 5.7773-8.7227 5.7773-13.953v-236.79zm0 27.906 70.758 70.754h-70.758zm78.934 307.55h-236.79v-315.72h138.13v98.664h98.664zm-108.53-128.26h69.059v19.734l-69.062-0.003907v69.066h-19.734l0.003907-69.066h-69.066v-19.734h69.062l0.003907-69.062h19.734z" />
    </svg>
  );
}

export function AddTruckIcon({ width, height }: { width: number; height: number }) {
  return (
    <svg
      width={width ? width : "752pt"}
      height={height ? height : "752pt"}
      version="1.1"
      viewBox="0 0 752 752"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m595.03 389.32-42.918-57.719-14.059-35.52c-2.2188-5.918-7.3984-9.6211-14.059-9.6211h-37v-22.199c0-24.418-19.98-44.398-44.398-44.398l-214.59 0.003907c-24.418 0-44.398 19.98-44.398 44.398v22.199h-7.3984c-8.1406 0-14.801 6.6602-14.801 14.801s6.6602 14.801 14.801 14.801h66.598c8.1406 0 14.801-6.6602 14.801-14.801s-6.6602-14.801-14.801-14.801h-29.598v-22.199c0-8.1406 6.6602-14.801 14.801-14.801h214.59c8.1406 0 14.801 6.6602 14.801 14.801v163.54c0 8.1406-6.6602 14.801-14.801 14.801h-14.801l-199.79-0.003906c-8.1406 0-14.801-6.6602-14.801-14.801v-22.199h44.398c8.1406 0 14.801-6.6602 14.801-14.801s-6.6602-14.801-14.801-14.801h-44.398v-14.801h22.199c8.1406 0 14.801-6.6602 14.801-14.801s-6.6602-14.801-14.801-14.801l-73.996 0.007812c-8.1406 0-14.801 6.6602-14.801 14.801s6.6602 14.801 14.801 14.801h22.199v14.801l-7.3984-0.003906c-8.1406 0-14.801 6.6602-14.801 14.801s6.6602 14.801 14.801 14.801h7.3984v22.199c0 24.418 19.98 44.398 44.398 44.398h8.1406c3.6992 25.16 25.16 44.398 51.059 44.398 25.898 0 47.359-19.238 51.059-44.398h119.88c3.6992 25.16 25.16 44.398 51.059 44.398 25.898 0 47.359-19.238 51.059-44.398h22.934c8.1406 0 14.801-6.6602 14.801-14.801v-59.199c0-2.957-0.73828-6.6602-2.9609-8.8789zm-307.83 97.676c-9.6211 0-17.758-5.918-20.719-14.801h41.438c-2.957 8.8828-11.098 14.801-20.719 14.801zm221.99 0c-9.6211 0-17.758-5.918-20.719-14.801h41.438c-2.957 8.8828-11.098 14.801-20.719 14.801zm59.199-44.398h-84.359c1.4805-4.4414 2.9609-9.6211 2.9609-14.801v-110.99h26.641l11.098 27.379c0.73828 1.4805 1.4805 2.2188 2.2188 3.6992l41.438 55.496z" />
        <path d="m267.23 354.54c0.73828 0.73828 1.4805 1.4805 1.4805 2.2188 3.6992 2.9609 7.3984 4.4414 11.098 4.4414 3.6992 0 7.3984-1.4805 10.359-4.4414 0.73828-0.73828 1.4805-1.4805 1.4805-2.2188 0.73828-0.73828 0.73828-1.4805 1.4805-2.2188 0-0.73828 0.73828-1.4805 0.73828-2.9609v-2.9609c0-3.6992-1.4805-7.3984-4.4414-10.359-5.918-5.918-15.539-5.918-20.719 0-2.2188 2.9609-3.6953 6.6602-3.6953 10.359v2.9609c0 0.73828 0.73828 1.4805 0.73828 2.9609 0.73828 0.73828 1.4805 1.4766 1.4805 2.2188z" />
      </g>
    </svg>
  );
}

export function AddSubAccounts() {
  return (
    <svg
      width="752pt"
      height="752pt"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-150 -150 752 752"
    >
      <g>
        <g>
          <path
            d="M129.031,262.984h-10.72c-5.929,0-10.737,4.803-10.737,10.731V395.92
			c0,4.797-1.24,8.099-2.089,9.551H55.756c-0.848-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.803-10.731-10.737-10.731H31.014
			c-5.26,0-9.546-4.286-9.546-9.551V151.516c0-5.265,4.286-9.551,9.546-9.551h98.012c2.551-7.816,8.066-14.212,15.273-17.933
			c-4.242-2.17-8.98-3.53-14.076-3.53h-3.046c9.252-10.758,14.876-24.71,14.876-39.977c0-33.874-27.56-61.445-61.429-61.445
			c-33.88,0-61.44,27.571-61.44,61.445c0,15.267,5.629,29.219,14.876,39.977h-3.046C13.913,120.502,0,134.416,0,151.516v101.917
			c0,17.106,13.913,31.019,31.014,31.019h1.186v111.463c0,17.682,9.317,31.024,21.669,31.024h53.493
			c12.358,0,21.669-13.342,21.669-31.024V284.452h1.186c5.096,0,9.834-1.349,14.076-3.535
			C137.097,277.196,131.582,270.795,129.031,262.984z M80.629,40.548c22.039,0,39.966,17.938,39.966,39.983
			c0,22.05-17.927,39.977-39.966,39.977c-22.045,0-39.977-17.927-39.977-39.977C40.652,58.481,58.584,40.548,80.629,40.548z"
          />
          <path
            d="M415.006,120.502h-3.04c9.246-10.758,14.876-24.71,14.876-39.977
			c0-33.874-27.56-61.445-61.434-61.445c-33.88,0-61.44,27.571-61.44,61.445c0,15.267,5.635,29.219,14.881,39.977h-3.046
			c-5.379,0-10.378,1.501-14.794,3.927c6.875,3.769,12.113,10.019,14.577,17.585c0.082,0,0.136-0.049,0.218-0.049h99.203
			c5.265,0,9.551,4.286,9.551,9.551v101.917c0,5.265-4.286,9.551-9.551,9.551h-11.912c-5.929,0-10.737,4.803-10.737,10.731V395.92
			c0,4.797-1.235,8.099-2.083,9.551h-49.729c-0.854-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.797-10.731-10.731-10.731
			h-11.922c-0.082,0-0.136-0.043-0.218-0.049c-2.464,7.571-7.702,13.81-14.577,17.585c4.417,2.42,9.41,3.932,14.794,3.932h1.186
			v111.463c0,17.682,9.312,31.024,21.669,31.024h53.493c12.352,0,21.669-13.342,21.669-31.024V284.452h1.186
			c17.106,0,31.014-13.919,31.014-31.019V151.516C446.02,134.41,432.112,120.502,415.006,120.502z M365.407,120.502
			c-22.045,0-39.972-17.927-39.972-39.977c0-22.045,17.927-39.983,39.972-39.983c22.039,0,39.977,17.938,39.977,39.983
			C405.379,102.575,387.446,120.502,365.407,120.502z"
          />
          <path
            d="M302.918,253.433V151.516c0-3.329-0.669-6.489-1.643-9.502
			c-2.458-7.571-7.702-13.815-14.577-17.585c-4.422-2.42-9.41-3.927-14.794-3.927h-3.046c9.246-10.758,14.876-24.71,14.876-39.977
			c0-33.874-27.56-61.445-61.44-61.445c-33.874,0-61.434,27.571-61.434,61.445c0,15.267,5.629,29.219,14.876,39.977h-3.046
			c-5.096,0-9.839,1.36-14.082,3.53c-7.207,3.72-12.722,10.117-15.273,17.933c-0.99,3.024-1.664,6.201-1.664,9.551v101.917
			c0,3.356,0.674,6.527,1.664,9.551c2.551,7.81,8.061,14.212,15.273,17.933c4.242,2.187,8.985,3.535,14.082,3.535h1.186v111.463
			c0,17.682,9.312,31.024,21.669,31.024h53.499c12.352,0,21.669-13.342,21.669-31.024V284.452h1.186
			c5.385,0,10.378-1.507,14.794-3.932c6.875-3.775,12.118-10.019,14.577-17.585C302.249,259.922,302.918,256.773,302.918,253.433z
			 M222.295,40.548c22.045,0,39.977,17.938,39.977,39.983c0,22.05-17.927,39.977-39.977,39.977
			c-22.039,0-39.972-17.927-39.972-39.977C182.328,58.481,200.255,40.548,222.295,40.548z M281.444,253.433
			c0,5.189-4.166,9.377-9.323,9.502c-0.082,0.005-0.141,0.049-0.223,0.049h-11.912c-5.929,0-10.742,4.803-10.742,10.731V395.92
			c0,4.797-1.235,8.099-2.083,9.551h-49.729c-0.848-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.803-10.731-10.731-10.731
			h-10.726h-1.191c-5.265,0-9.546-4.286-9.546-9.551V151.516c0-5.265,4.281-9.551,9.546-9.551h1.191h98.012
			c0.082,0,0.141,0.049,0.223,0.049c5.156,0.136,9.323,4.313,9.323,9.502C281.444,151.516,281.444,253.433,281.444,253.433z"
          />
        </g>
      </g>
    </svg>
  );
}

export function RightExpand() {
  return (
    <svg
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="white" fillOpacity="0.01" />
      <path
        d="M19 12L31 24L19 36"
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M437.02,74.98C388.667,26.628,324.38,0,256,0S123.333,26.628,74.98,74.98C26.628,123.333,0,187.62,0,256
			s26.628,132.667,74.98,181.02C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.98
			C485.372,388.667,512,324.38,512,256S485.372,123.333,437.02,74.98z M256,478.609c-122.746,0-222.609-99.862-222.609-222.609
			S133.254,33.391,256,33.391S478.609,133.254,478.609,256S378.746,478.609,256,478.609z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="239.304" y="66.445" width="33.391" height="54.973" />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="144.041"
            y="97.397"
            transform="matrix(0.809 -0.5878 0.5878 0.809 -42.7066 118.3336)"
            width="33.391"
            height="54.973"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="85.16"
            y="178.422"
            transform="matrix(0.309 -0.9511 0.9511 0.309 -125.4502 239.1576)"
            width="33.392"
            height="54.975"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="74.387"
            y="289.382"
            transform="matrix(0.9511 -0.309 0.309 0.9511 -89.5896 46.456)"
            width="54.975"
            height="33.392"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="393.426"
            y="278.583"
            transform="matrix(0.309 -0.9511 0.9511 0.309 -7.6944 601.5519)"
            width="33.393"
            height="54.975"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="382.634"
            y="189.215"
            transform="matrix(0.9511 -0.309 0.309 0.9511 -43.5552 136.799)"
            width="54.975"
            height="33.393"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="323.78"
            y="108.202"
            transform="matrix(0.5878 -0.809 0.809 0.5878 43.7479 335.6581)"
            width="54.973"
            height="33.391"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M169.275,335.566v102.047h173.449V335.566H169.275z M309.333,404.222H202.666v-35.265h0h106.666V404.222z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M272.696,233.859v-82.237h-33.391v82.237c-15.303,6.516-26.06,21.704-26.06,39.359c0,23.575,19.18,42.755,42.755,42.755
			s42.755-19.18,42.755-42.755C298.755,255.564,287.999,240.376,272.696,233.859z M256,282.583c-5.163,0-9.364-4.201-9.364-9.364
			c0-5.163,4.201-9.364,9.364-9.364c5.163,0,9.364,4.201,9.364,9.364C265.364,278.382,261.163,282.583,256,282.583z"
          />
        </g>
      </g>
    </svg>
  );
}

export function AccountIcon() {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M16 7.992C16 3.58 12.416 0 8 0S0 3.58 0 7.992c0 2.43 1.104 4.62 2.832 6.09.016.016.032.016.032.032.144.112.288.224.448.336.08.048.144.111.224.175A7.98 7.98 0 0 0 8.016 16a7.98 7.98 0 0 0 4.48-1.375c.08-.048.144-.111.224-.16.144-.111.304-.223.448-.335.016-.016.032-.016.032-.032 1.696-1.487 2.8-3.676 2.8-6.106zm-8 7.001c-1.504 0-2.88-.48-4.016-1.279.016-.128.048-.255.08-.383a4.17 4.17 0 0 1 .416-.991c.176-.304.384-.576.64-.816.24-.24.528-.463.816-.639.304-.176.624-.304.976-.4A4.15 4.15 0 0 1 8 10.342a4.185 4.185 0 0 1 2.928 1.166c.368.368.656.8.864 1.295.112.288.192.592.24.911A7.03 7.03 0 0 1 8 14.993zm-2.448-7.4a2.49 2.49 0 0 1-.208-1.024c0-.351.064-.703.208-1.023.144-.32.336-.607.576-.847.24-.24.528-.431.848-.575.32-.144.672-.208 1.024-.208.368 0 .704.064 1.024.208.32.144.608.336.848.575.24.24.432.528.576.847.144.32.208.672.208 1.023 0 .368-.064.704-.208 1.023a2.84 2.84 0 0 1-.576.848 2.84 2.84 0 0 1-.848.575 2.715 2.715 0 0 1-2.064 0 2.84 2.84 0 0 1-.848-.575 2.526 2.526 0 0 1-.56-.848zm7.424 5.306c0-.032-.016-.048-.016-.08a5.22 5.22 0 0 0-.688-1.406 4.883 4.883 0 0 0-1.088-1.135 5.207 5.207 0 0 0-1.04-.608 2.82 2.82 0 0 0 .464-.383 4.2 4.2 0 0 0 .624-.784 3.624 3.624 0 0 0 .528-1.934 3.71 3.71 0 0 0-.288-1.47 3.799 3.799 0 0 0-.816-1.199 3.845 3.845 0 0 0-1.2-.8 3.72 3.72 0 0 0-1.472-.287 3.72 3.72 0 0 0-1.472.288 3.631 3.631 0 0 0-1.2.815 3.84 3.84 0 0 0-.8 1.199 3.71 3.71 0 0 0-.288 1.47c0 .352.048.688.144 1.007.096.336.224.64.4.927.16.288.384.544.624.784.144.144.304.271.48.383a5.12 5.12 0 0 0-1.04.624c-.416.32-.784.703-1.088 1.119a4.999 4.999 0 0 0-.688 1.406c-.016.032-.016.064-.016.08C1.776 11.636.992 9.91.992 7.992.992 4.14 4.144.991 8 .991s7.008 3.149 7.008 7.001a6.96 6.96 0 0 1-2.032 4.907z" />
    </svg>
  );
}

export function SubAccounts() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 446.02 446.02"
    >
      <g>
        <g>
          <path
            d="M129.031,262.984h-10.72c-5.929,0-10.737,4.803-10.737,10.731V395.92
			c0,4.797-1.24,8.099-2.089,9.551H55.756c-0.848-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.803-10.731-10.737-10.731H31.014
			c-5.26,0-9.546-4.286-9.546-9.551V151.516c0-5.265,4.286-9.551,9.546-9.551h98.012c2.551-7.816,8.066-14.212,15.273-17.933
			c-4.242-2.17-8.98-3.53-14.076-3.53h-3.046c9.252-10.758,14.876-24.71,14.876-39.977c0-33.874-27.56-61.445-61.429-61.445
			c-33.88,0-61.44,27.571-61.44,61.445c0,15.267,5.629,29.219,14.876,39.977h-3.046C13.913,120.502,0,134.416,0,151.516v101.917
			c0,17.106,13.913,31.019,31.014,31.019h1.186v111.463c0,17.682,9.317,31.024,21.669,31.024h53.493
			c12.358,0,21.669-13.342,21.669-31.024V284.452h1.186c5.096,0,9.834-1.349,14.076-3.535
			C137.097,277.196,131.582,270.795,129.031,262.984z M80.629,40.548c22.039,0,39.966,17.938,39.966,39.983
			c0,22.05-17.927,39.977-39.966,39.977c-22.045,0-39.977-17.927-39.977-39.977C40.652,58.481,58.584,40.548,80.629,40.548z"
          />
          <path
            d="M415.006,120.502h-3.04c9.246-10.758,14.876-24.71,14.876-39.977
			c0-33.874-27.56-61.445-61.434-61.445c-33.88,0-61.44,27.571-61.44,61.445c0,15.267,5.635,29.219,14.881,39.977h-3.046
			c-5.379,0-10.378,1.501-14.794,3.927c6.875,3.769,12.113,10.019,14.577,17.585c0.082,0,0.136-0.049,0.218-0.049h99.203
			c5.265,0,9.551,4.286,9.551,9.551v101.917c0,5.265-4.286,9.551-9.551,9.551h-11.912c-5.929,0-10.737,4.803-10.737,10.731V395.92
			c0,4.797-1.235,8.099-2.083,9.551h-49.729c-0.854-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.797-10.731-10.731-10.731
			h-11.922c-0.082,0-0.136-0.043-0.218-0.049c-2.464,7.571-7.702,13.81-14.577,17.585c4.417,2.42,9.41,3.932,14.794,3.932h1.186
			v111.463c0,17.682,9.312,31.024,21.669,31.024h53.493c12.352,0,21.669-13.342,21.669-31.024V284.452h1.186
			c17.106,0,31.014-13.919,31.014-31.019V151.516C446.02,134.41,432.112,120.502,415.006,120.502z M365.407,120.502
			c-22.045,0-39.972-17.927-39.972-39.977c0-22.045,17.927-39.983,39.972-39.983c22.039,0,39.977,17.938,39.977,39.983
			C405.379,102.575,387.446,120.502,365.407,120.502z"
          />
          <path
            d="M302.918,253.433V151.516c0-3.329-0.669-6.489-1.643-9.502
			c-2.458-7.571-7.702-13.815-14.577-17.585c-4.422-2.42-9.41-3.927-14.794-3.927h-3.046c9.246-10.758,14.876-24.71,14.876-39.977
			c0-33.874-27.56-61.445-61.44-61.445c-33.874,0-61.434,27.571-61.434,61.445c0,15.267,5.629,29.219,14.876,39.977h-3.046
			c-5.096,0-9.839,1.36-14.082,3.53c-7.207,3.72-12.722,10.117-15.273,17.933c-0.99,3.024-1.664,6.201-1.664,9.551v101.917
			c0,3.356,0.674,6.527,1.664,9.551c2.551,7.81,8.061,14.212,15.273,17.933c4.242,2.187,8.985,3.535,14.082,3.535h1.186v111.463
			c0,17.682,9.312,31.024,21.669,31.024h53.499c12.352,0,21.669-13.342,21.669-31.024V284.452h1.186
			c5.385,0,10.378-1.507,14.794-3.932c6.875-3.775,12.118-10.019,14.577-17.585C302.249,259.922,302.918,256.773,302.918,253.433z
			 M222.295,40.548c22.045,0,39.977,17.938,39.977,39.983c0,22.05-17.927,39.977-39.977,39.977
			c-22.039,0-39.972-17.927-39.972-39.977C182.328,58.481,200.255,40.548,222.295,40.548z M281.444,253.433
			c0,5.189-4.166,9.377-9.323,9.502c-0.082,0.005-0.141,0.049-0.223,0.049h-11.912c-5.929,0-10.742,4.803-10.742,10.731V395.92
			c0,4.797-1.235,8.099-2.083,9.551h-49.729c-0.848-1.452-2.089-4.754-2.089-9.551V273.715c0-5.929-4.803-10.731-10.731-10.731
			h-10.726h-1.191c-5.265,0-9.546-4.286-9.546-9.551V151.516c0-5.265,4.281-9.551,9.546-9.551h1.191h98.012
			c0.082,0,0.141,0.049,0.223,0.049c5.156,0.136,9.323,4.313,9.323,9.502C281.444,151.516,281.444,253.433,281.444,253.433z"
          />
        </g>
      </g>
    </svg>
  );
}

export function ReportIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 21H15M9 21V16M9 21H3.6C3.26863 21 3 20.7314 3 20.4V16.6C3 16.2686 3.26863 16 3.6 16H9M15 21V9M15 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H15.6C15.2686 3 15 3.26863 15 3.6V9M15 9H9.6C9.26863 9 9 9.26863 9 9.6V16"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function PaymentsIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 457.223 457.223"
    >
      <g>
        <path
          d="M453.473,209.361L143.917,30.638c-2.32-1.34-5.18-1.34-7.5,0L3.768,107.223c-2.32,1.339-3.75,3.815-3.75,6.494L0,241.367
		c0,2.68,1.429,5.156,3.75,6.496l309.556,178.722c1.16,0.67,2.455,1.005,3.75,1.005s2.589-0.335,3.749-1.004l132.667-76.573
		c2.321-1.339,3.751-3.816,3.751-6.496V215.856C457.223,213.176,455.793,210.7,453.473,209.361z M110.742,292.314l-95.741-55.276
		l0.001-8.228l95.74,55.284V292.314z M110.742,266.774L15.004,211.49l0.001-8.198l95.737,55.283V266.774z M110.742,241.254
		l-95.734-55.281l0.001-8.208l95.733,55.281V241.254z M110.742,215.724l-95.731-55.279l0.001-8.209l95.73,55.279V215.724z
		 M110.742,190.193l-95.728-55.277l0.001-8.208l95.727,55.274V190.193z M22.517,113.719l117.65-67.926l95.526,55.152
		l-117.969,67.748L22.517,113.719z M199.003,343.272l-73.261-42.297V190.644l73.261,42.302V343.272z M132.744,177.366
		l117.969-67.749l73.334,42.34l-118.88,67.228L132.744,177.366z M309.556,407.1l-95.553-55.168v-8.215l95.553,55.18V407.1z
		 M309.556,381.575l-95.553-55.18v-8.2l95.553,55.171V381.575z M309.556,356.046l-95.553-55.171v-8.209l95.553,55.171V356.046z
		 M309.556,330.516l-95.553-55.171v-8.21l95.553,55.171V330.516z M309.556,304.986l-95.553-55.171v-8.208l95.553,55.174V304.986z
		 M317.056,283.791l-96.812-55.901l118.881-67.228l95.598,55.193L317.056,283.791z M442.223,339.186l-117.667,67.915v-8.208
		l117.667-67.938V339.186z M442.223,313.635l-117.667,67.938v-8.21l117.667-67.938V313.635z M442.223,288.104l-117.667,67.938
		v-8.209l117.667-67.929V288.104z M442.223,262.584l-117.667,67.929v-8.21l117.667-67.929V262.584z M442.223,237.055
		l-117.667,67.929v-8.202l117.667-67.935V237.055z"
        />
        <path
          d="M281.545,141.525c2.68-2.319,3.417-6.286,1.561-9.454c-2.095-3.575-6.689-4.774-10.263-2.68l-4.617,2.704
		c-14.975-5.933-32.1-4.763-46.199,3.495l-0.157,0.091c-6.053,3.546-9.64,9.851-9.596,16.866c0.024,3.834,1.137,7.439,3.131,10.49
		l-27.47,16.091c-0.929-1.06-1.06-2.292-1.062-2.873c-0.002-0.768,0.208-2.676,2.203-3.828c3.587-2.071,4.816-6.658,2.745-10.245
		c-2.071-3.587-6.659-4.815-10.245-2.745c-6.096,3.52-9.723,9.824-9.702,16.863c0.011,3.857,1.123,7.482,3.126,10.549
		c-2.712,2.314-3.467,6.303-1.602,9.487c1.396,2.383,3.903,3.71,6.478,3.71c1.288,0,2.593-0.332,3.784-1.03l4.668-2.734
		c6.248,2.474,12.865,3.722,19.486,3.722c9.251,0,18.502-2.414,26.724-7.234l0.145-0.084c6.051-3.548,9.637-9.853,9.591-16.867
		c-0.025-3.83-1.136-7.43-3.127-10.477l27.467-16.09c0.928,1.059,1.059,2.292,1.062,2.872c0.002,0.768-0.207,2.677-2.202,3.829
		l-4.733,2.733c-3.587,2.071-4.816,6.658-2.745,10.245c2.072,3.588,6.661,4.816,10.245,2.745l4.733-2.733
		c6.098-3.521,9.725-9.825,9.702-16.866C284.665,148.218,283.552,144.593,281.545,141.525z M227.274,152.452
		c-0.005-0.765,0.198-2.668,2.171-3.825l0.157-0.092c5.953-3.487,12.659-5.2,19.361-5.157l-20.531,12.027
		C227.429,154.33,227.278,153.048,227.274,152.452z M229.275,175.916c0.005,0.765-0.197,2.668-2.179,3.83l-0.145,0.084
		c-5.954,3.49-12.659,5.206-19.358,5.167l20.531-12.027C229.122,174.044,229.271,175.321,229.275,175.916z"
        />
      </g>
    </svg>
  );
}

export function SupportIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      id="_24x24_On_Light_Support"
      data-name="24x24/On Light/Support"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect id="view-box" width="24" height="24" fill="none" />
      <path
        id="Shape"
        d="M8,17.751a2.749,2.749,0,0,1,5.127-1.382C15.217,15.447,16,14,16,11.25v-3c0-3.992-2.251-6.75-5.75-6.75S4.5,4.259,4.5,8.25v3.5a.751.751,0,0,1-.75.75h-1A2.753,2.753,0,0,1,0,9.751v-1A2.754,2.754,0,0,1,2.75,6h.478c.757-3.571,3.348-6,7.022-6s6.264,2.429,7.021,6h.478a2.754,2.754,0,0,1,2.75,2.75v1a2.753,2.753,0,0,1-2.75,2.75H17.44A5.85,5.85,0,0,1,13.5,17.84,2.75,2.75,0,0,1,8,17.751Zm1.5,0a1.25,1.25,0,1,0,1.25-1.25A1.251,1.251,0,0,0,9.5,17.751Zm8-6.75h.249A1.251,1.251,0,0,0,19,9.751v-1A1.251,1.251,0,0,0,17.75,7.5H17.5Zm-16-2.25v1A1.251,1.251,0,0,0,2.75,11H3V7.5H2.75A1.251,1.251,0,0,0,1.5,8.751Z"
        transform="translate(1.75 2.25)"
        fill="#141124"
      />
    </svg>
  );
}

export function InfoIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 330 330"
      fill={color}
      height={size}
      width={size}
    >
      <g>
        <g>
          <g>
            <path
              d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992
				C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008
				s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z"
            />
            <path
              d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983
				C180,136.725,173.284,130.008,165,130.008z"
            />
            <path
              d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61
				c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61
				C172.81,71.61,168.95,70.011,165,70.011z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 485 485"
    >
      <g>
        <g>
          <path d="M426.5,458h-368C51,458,45,464,45,471.5S51,485,58.5,485h368c7.5,0,13.5-6,13.5-13.5S434,458,426.5,458z" />
          <path
            d="M233,378.7c2.5,2.5,6,4,9.5,4s7-1.4,9.5-4l107.5-107.5c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0L256,336.5v-323
			C256,6,250,0,242.5,0S229,6,229,13.5v323l-84.4-84.4c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1L233,378.7z"
          />
        </g>
      </g>
    </svg>
  );
}

export function DownIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="2"
        points="7.086 3.174 17.086 13.174 7.086 23.174"
        transform="scale(1 -1) rotate(-89 -1.32 0)"
      />
    </svg>
  );
}

export function UpIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 -6 524 524" xmlns="http://www.w3.org/2000/svg">
      <title>up</title>
      <path d="M460 321L426 355 262 192 98 355 64 321 262 125 460 321Z" stroke={color} />
    </svg>
  );
}

export function RightIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.91003 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91003 4.08008"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LeftIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 19.9201L8.47997 13.4001C7.70997 12.6301 7.70997 11.3701 8.47997 10.6001L15 4.08008"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FilterIcon() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 210.68 210.68"
    >
      <path
        d="M205.613,30.693c0-10.405-10.746-18.149-32.854-23.676C154.659,2.492,130.716,0,105.34,0
	C79.965,0,56.021,2.492,37.921,7.017C15.813,12.544,5.066,20.288,5.066,30.693c0,3.85,1.476,7.335,4.45,10.479l68.245,82.777v79.23
	c0,2.595,1.341,5.005,3.546,6.373c1.207,0.749,2.578,1.127,3.954,1.127c1.138,0,2.278-0.259,3.331-0.78l40.075-19.863
	c2.55-1.264,4.165-3.863,4.169-6.71l0.077-59.372l68.254-82.787C204.139,38.024,205.613,34.542,205.613,30.693z M44.94,20.767
	C61.467,17.048,82.917,15,105.34,15s43.874,2.048,60.399,5.767c18.25,4.107,23.38,8.521,24.607,9.926
	c-1.228,1.405-6.357,5.819-24.607,9.926c-16.525,3.719-37.977,5.767-60.399,5.767S61.467,44.338,44.94,40.62
	c-18.249-4.107-23.38-8.521-24.607-9.926C21.56,29.288,26.691,24.874,44.94,20.767z M119.631,116.486
	c-1.105,1.341-1.711,3.023-1.713,4.761l-0.075,57.413l-25.081,12.432v-69.835c0-1.741-0.605-3.428-1.713-4.771L40.306,54.938
	C58.1,59.1,81.058,61.387,105.34,61.387c24.283,0,47.24-2.287,65.034-6.449L119.631,116.486z"
      />
    </svg>
  );
}

export function PlusIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87524 4.37842V0.628418H5.12525V4.37842H8.87525V5.62842H5.12525V9.37842H3.87524V5.62842H0.125244V4.37842H3.87524Z"
        fill={color}
      />
    </svg>
  );
}

export function LoadIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 58 58"
    >
      <g>
        <polygon fill="#A98258" points="48,0 10,0 0,16 0,58 58,58 58,16 	" />
        <path
          fill="#5B4631;"
          d="M35,27H23c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2v0C37,26.1,36.1,27,35,27z"
        />
        <g>
          <path
            fill="#E8D5B2"
            d="M37,51H21c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1S37.552,51,37,51z"
          />
          <path
            fill="#E8D5B2"
            d="M21,43c0.256,0,0.512-0.098,0.707-0.293L23,41.414V48c0,0.553,0.448,1,1,1s1-0.447,1-1v-6.586
			l1.293,1.293C26.488,42.902,26.744,43,27,43s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-2.999-2.999
			c-0.092-0.093-0.203-0.166-0.326-0.217c-0.244-0.101-0.52-0.101-0.764,0c-0.123,0.051-0.233,0.124-0.326,0.217l-2.999,2.999
			c-0.391,0.391-0.391,1.023,0,1.414C20.488,42.902,20.744,43,21,43z"
          />
          <path
            fill="#E8D5B2"
            d="M31,43c0.256,0,0.512-0.098,0.707-0.293L33,41.414V48c0,0.553,0.448,1,1,1s1-0.447,1-1v-6.586
			l1.293,1.293C36.488,42.902,36.744,43,37,43s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-2.999-2.999
			c-0.092-0.093-0.203-0.166-0.326-0.217c-0.244-0.101-0.52-0.101-0.764,0c-0.123,0.051-0.233,0.124-0.326,0.217l-2.999,2.999
			c-0.391,0.391-0.391,1.023,0,1.414C30.488,42.902,30.744,43,31,43z"
          />
        </g>
        <polygon fill="#DAAE86" points="10,0 0,16 58,16 48,0 	" />
        <rect x="28" fill="#F4D5BD;" width="2" height="16" />
      </g>
    </svg>
  );
}
export function BackIcon({ color }: { color: string }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.52341 7.83333L7.99342 12.3033L6.81508 13.4817L0.333416 6.99999L6.81508 0.518326L7.99342 1.69666L3.52341 6.16666L13.6667 6.16666L13.6667 7.83333L3.52341 7.83333Z"
        fill={color}
      />
    </svg>
  );
}

export function VideoIcon({
  color,
  width,
  height,
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15Z"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.52002 7.11011H21.48"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52002 2.11011V6.97011"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.48 2.11011V6.52011"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 14.4501V13.2501C9.75 11.7101 10.84 11.0801 12.17 11.8501L13.21 12.4501L14.25 13.0501C15.58 13.8201 15.58 15.0801 14.25 15.8501L13.21 16.4501L12.17 17.0501C10.84 17.8201 9.75 17.1901 9.75 15.6501V14.4501V14.4501Z"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function OpenEyeIcon(props: { color: string }) {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00005 0.75C10.1454 0.75 12.7622 3.01333 13.3111 6C12.7628 8.98667 10.1454 11.25 7.00005 11.25C3.85472 11.25 1.23788 8.98667 0.688965 6C1.2373 3.01333 3.85472 0.75 7.00005 0.75ZM7.00005 10.0833C8.18974 10.0831 9.34411 9.67898 10.2742 8.93718C11.2043 8.19538 11.8551 7.15983 12.12 6C11.8541 4.84109 11.2029 3.80667 10.2729 3.06585C9.3429 2.32503 8.18906 1.92164 7.00005 1.92164C5.81104 1.92164 4.6572 2.32503 3.72718 3.06585C2.79717 3.80667 2.146 4.84109 1.88013 6C2.14502 7.15983 2.79577 8.19538 3.72588 8.93718C4.65599 9.67898 5.81036 10.0831 7.00005 10.0833ZM7.00005 8.625C6.30386 8.625 5.63618 8.34844 5.14389 7.85615C4.65161 7.36387 4.37505 6.69619 4.37505 6C4.37505 5.30381 4.65161 4.63613 5.14389 4.14384C5.63618 3.65156 6.30386 3.375 7.00005 3.375C7.69624 3.375 8.36392 3.65156 8.8562 4.14384C9.34849 4.63613 9.62505 5.30381 9.62505 6C9.62505 6.69619 9.34849 7.36387 8.8562 7.85615C8.36392 8.34844 7.69624 8.625 7.00005 8.625ZM7.00005 7.45833C7.38682 7.45833 7.75776 7.30469 8.03125 7.0312C8.30474 6.75771 8.45838 6.38677 8.45838 6C8.45838 5.61323 8.30474 5.24229 8.03125 4.9688C7.75776 4.69531 7.38682 4.54167 7.00005 4.54167C6.61327 4.54167 6.24234 4.69531 5.96885 4.9688C5.69536 5.24229 5.54172 5.61323 5.54172 6C5.54172 6.38677 5.69536 6.75771 5.96885 7.0312C6.24234 7.30469 6.61327 7.45833 7.00005 7.45833Z"
        fill={props.color ? props.color : "#0288FA"}
      />
    </svg>
  );
}
export function ClosedEye(props: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M4.4955 7.44088C3.54724 8.11787 2.77843 8.84176 2.1893 9.47978C0.857391 10.9222 0.857392 13.0778 2.1893 14.5202C3.9167 16.391 7.18879 19 12 19C13.2958 19 14.4799 18.8108 15.5523 18.4977L13.8895 16.8349C13.2936 16.9409 12.6638 17 12 17C7.9669 17 5.18832 14.82 3.65868 13.1634C3.03426 12.4872 3.03426 11.5128 3.65868 10.8366C4.23754 10.2097 4.99526 9.50784 5.93214 8.87753L4.4955 7.44088Z"
        fill={props.color ? props.color : "#0288FA"}
      />
      <path
        d="M8.53299 11.4784C8.50756 11.6486 8.49438 11.8227 8.49438 12C8.49438 13.933 10.0614 15.5 11.9944 15.5C12.1716 15.5 12.3458 15.4868 12.516 15.4614L8.53299 11.4784Z"
        fill={props.color ? props.color : "#0288FA"}
      />
      <path
        d="M15.4661 12.4471L11.5473 8.52829C11.6937 8.50962 11.8429 8.5 11.9944 8.5C13.9274 8.5 15.4944 10.067 15.4944 12C15.4944 12.1515 15.4848 12.3007 15.4661 12.4471Z"
        fill={props.color ? props.color : "#0288FA"}
      />
      <path
        d="M18.1118 15.0928C19.0284 14.4702 19.7715 13.7805 20.3413 13.1634C20.9657 12.4872 20.9657 11.5128 20.3413 10.8366C18.8117 9.18002 16.0331 7 12 7C11.3594 7 10.7505 7.05499 10.1732 7.15415L8.50482 5.48582C9.56209 5.1826 10.7272 5 12 5C16.8112 5 20.0833 7.60905 21.8107 9.47978C23.1426 10.9222 23.1426 13.0778 21.8107 14.5202C21.2305 15.1486 20.476 15.8603 19.5474 16.5284L18.1118 15.0928Z"
        fill={props.color ? props.color : "#0288FA"}
      />
      <path
        d="M2.00789 3.42207C1.61736 3.03155 1.61736 2.39838 2.00789 2.00786C2.39841 1.61733 3.03158 1.61733 3.4221 2.00786L22.0004 20.5862C22.391 20.9767 22.391 21.6099 22.0004 22.0004C21.6099 22.3909 20.9767 22.3909 20.5862 22.0004L2.00789 3.42207Z"
        fill={props.color ? props.color : "#0288FA"}
      />
    </svg>
  );
}
export function CloseIcon({
  size,
  color,
  strokeWidth = 1.5,
}: {
  color?: string;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 21L21 1"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21L1 1"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CloseCircleIcon({ size, color }: { color?: string; size?: number }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16998 14.83L14.83 9.17004"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.83 14.83L9.16998 9.17004"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DownloadPDFIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 58 58"
    >
      <g>
        <path
          d="M50.95,12.187l-0.771-0.771L40.084,1.321L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963C7.777,0,6.5,0.916,6.5,2.926V39
		v16.537V56c0,0.837,0.842,1.653,1.838,1.91c0.05,0.013,0.098,0.032,0.15,0.042C8.644,57.983,8.803,58,8.963,58h40.074
		c0.16,0,0.319-0.017,0.475-0.048c0.052-0.01,0.1-0.029,0.15-0.042C50.658,57.653,51.5,56.837,51.5,56v-0.463V39V13.978
		C51.5,13.211,51.408,12.645,50.95,12.187z M47.935,12H39.5V3.565L47.935,12z M8.963,56c-0.071,0-0.135-0.026-0.198-0.049
		C8.609,55.877,8.5,55.721,8.5,55.537V41h41v14.537c0,0.184-0.109,0.339-0.265,0.414C49.172,55.974,49.108,56,49.037,56H8.963z
		 M8.5,39V2.926C8.5,2.709,8.533,2,8.963,2h28.595C37.525,2.126,37.5,2.256,37.5,2.391V14h11.609c0.135,0,0.264-0.025,0.39-0.058
		c0,0.015,0.001,0.021,0.001,0.036V39H8.5z"
        />
        <path
          d="M22.042,44.744c-0.333-0.273-0.709-0.479-1.128-0.615c-0.419-0.137-0.843-0.205-1.271-0.205h-2.898V54h1.641v-3.637h1.217
		c0.528,0,1.012-0.077,1.449-0.232s0.811-0.374,1.121-0.656c0.31-0.282,0.551-0.631,0.725-1.046c0.173-0.415,0.26-0.877,0.26-1.388
		c0-0.483-0.103-0.918-0.308-1.306S22.375,45.018,22.042,44.744z M21.42,48.073c-0.101,0.278-0.232,0.494-0.396,0.649
		c-0.164,0.155-0.344,0.267-0.54,0.335c-0.196,0.068-0.395,0.103-0.595,0.103h-1.504v-3.992h1.23c0.419,0,0.756,0.066,1.012,0.198
		c0.255,0.132,0.453,0.296,0.595,0.492c0.141,0.196,0.234,0.401,0.28,0.615c0.045,0.214,0.068,0.403,0.068,0.567
		C21.57,47.451,21.52,47.795,21.42,48.073z"
        />
        <path
          d="M31.954,45.4c-0.424-0.446-0.957-0.805-1.6-1.073s-1.388-0.403-2.235-0.403h-3.035V54h3.814
		c0.127,0,0.323-0.016,0.588-0.048c0.264-0.032,0.556-0.104,0.875-0.219c0.319-0.114,0.649-0.285,0.991-0.513
		s0.649-0.54,0.923-0.937s0.499-0.889,0.677-1.477s0.267-1.297,0.267-2.126c0-0.602-0.105-1.188-0.314-1.757
		C32.694,46.355,32.378,45.847,31.954,45.4z M30.758,51.73c-0.492,0.711-1.294,1.066-2.406,1.066h-1.627v-7.629h0.957
		c0.784,0,1.422,0.103,1.914,0.308s0.882,0.474,1.169,0.807s0.48,0.704,0.581,1.114c0.1,0.41,0.15,0.825,0.15,1.244
		C31.496,49.989,31.25,51.02,30.758,51.73z"
        />
        <polygon
          points="35.598,54 37.266,54 37.266,49.461 41.477,49.461 41.477,48.34 37.266,48.34 37.266,45.168 41.9,45.168 
		41.9,43.924 35.598,43.924 	"
        />
        <path
          d="M38.428,22.961c-0.919,0-2.047,0.12-3.358,0.358c-1.83-1.942-3.74-4.778-5.088-7.562c1.337-5.629,0.668-6.426,0.373-6.802
		c-0.314-0.4-0.757-1.049-1.261-1.049c-0.211,0-0.787,0.096-1.016,0.172c-0.576,0.192-0.886,0.636-1.134,1.215
		c-0.707,1.653,0.263,4.471,1.261,6.643c-0.853,3.393-2.284,7.454-3.788,10.75c-3.79,1.736-5.803,3.441-5.985,5.068
		c-0.066,0.592,0.074,1.461,1.115,2.242c0.285,0.213,0.619,0.326,0.967,0.326h0c0.875,0,1.759-0.67,2.782-2.107
		c0.746-1.048,1.547-2.477,2.383-4.251c2.678-1.171,5.991-2.229,8.828-2.822c1.58,1.517,2.995,2.285,4.211,2.285
		c0.896,0,1.664-0.412,2.22-1.191c0.579-0.811,0.711-1.537,0.39-2.16C40.943,23.327,39.994,22.961,38.428,22.961z M20.536,32.634
		c-0.468-0.359-0.441-0.601-0.431-0.692c0.062-0.556,0.933-1.543,3.07-2.744C21.555,32.19,20.685,32.587,20.536,32.634z
		 M28.736,9.712c0.043-0.014,1.045,1.101,0.096,3.216C27.406,11.469,28.638,9.745,28.736,9.712z M26.669,25.738
		c1.015-2.419,1.959-5.09,2.674-7.564c1.123,2.018,2.472,3.976,3.822,5.544C31.031,24.219,28.759,24.926,26.669,25.738z
		 M39.57,25.259C39.262,25.69,38.594,25.7,38.36,25.7c-0.533,0-0.732-0.317-1.547-0.944c0.672-0.086,1.306-0.108,1.811-0.108
		c0.889,0,1.052,0.131,1.175,0.197C39.777,24.916,39.719,25.05,39.57,25.259z"
        />
      </g>
    </svg>
  );
}
export function MoreIcon() {
  return (
    <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM16 0C14.9 0 14 0.9 14 2C14 3.1 14.9 4 16 4C17.1 4 18 3.1 18 2C18 0.9 17.1 0 16 0ZM9 0C7.9 0 7 0.9 7 2C7 3.1 7.9 4 9 4C10.1 4 11 3.1 11 2C11 0.9 10.1 0 9 0Z"
        fill="#03053D"
      />
    </svg>
  );
}
export function MoneyIcon({ color }: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 11.4C8 12.17 8.6 12.8 9.33 12.8H10.83C11.47 12.8 11.99 12.25 11.99 11.58C11.99 10.85 11.67 10.59 11.2 10.42L8.8 9.57995C8.32 9.40995 8 9.14995 8 8.41995C8 7.74995 8.52 7.19995 9.16 7.19995H10.66C11.4 7.20995 12 7.82995 12 8.59995"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.8501V13.5901"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.40991V7.18991"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.98 19.88C13.88 21.15 15.35 21.98 17.03 21.98C19.76 21.98 21.98 19.76 21.98 17.03C21.98 15.37 21.16 13.9 19.91 13"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CopyIcon({ size = 24 }: IconProps) {
  return (
    <svg
      viewBox="0 0 800 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
    >
      <path
        d="M200 366.666C200 272.386 200 225.245 229.289 195.956C258.579 166.667 305.719 166.667 400 166.667H500C594.28 166.667 641.42 166.667 670.71 195.956C700 225.245 700 272.386 700 366.666V533.333C700 627.613 700 674.753 670.71 704.043C641.42 733.333 594.28 733.333 500 733.333H400C305.719 733.333 258.579 733.333 229.289 704.043C200 674.753 200 627.613 200 533.333V366.666Z"
        stroke="#1C274C"
        strokeWidth="50"
      />
      <path
        d="M200 633.333C144.772 633.333 100 588.563 100 533.333V333.333C100 207.625 100 144.772 139.052 105.719C178.105 66.6665 240.959 66.6665 366.667 66.6665H500C555.23 66.6665 600 111.438 600 166.667"
        stroke="#1C274C"
        strokeWidth="50"
      />
    </svg>
  );
}
export function DuplicateIcon({ size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11C6 8.17157 6 6.75734 6.87867 5.87867C7.75737 5 9.17157 5 12 5H15C17.8284 5 19.2426 5 20.1213 5.87867C21 6.75734 21 8.17157 21 11V16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H12C9.17157 22 7.75737 22 6.87867 21.1213C6 20.2426 6 18.8284 6 16V11Z"
        stroke="#1C274C"
      />
      <path
        d="M6 19C4.34316 19 3 17.6569 3 16V9.99999C3 6.22876 3 4.34317 4.17156 3.17158C5.34315 2 7.22877 2 11 2H15C16.6569 2 18 3.34315 18 5.00002"
        stroke="#1C274C"
      />
      <path
        d="M21 11.0001L16.4817 14.8037C13.6418 17.1943 12.2219 18.3896 10.6116 18.2674C9.00123 18.1452 7.8294 16.7532 5.48574 13.9691L2.99992 11.0162"
        stroke="#1C274C"
      />
    </svg>
  );
}
export function MoveFolderIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M22 14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2.51839 20.1752 2.22937 19.3001 2.10149 18M2 12V6.94975C2 6.06722 2 5.62595 2.06935 5.25839C2.37464 3.64031 3.64031 2.37464 5.25839 2.06935C5.62595 2 6.06722 2 6.94975 2C7.33642 2 7.52976 2 7.71557 2.01738C8.51665 2.09229 9.27652 2.40704 9.89594 2.92051C10.0396 3.03961 10.1763 3.17633 10.4497 3.44975L11 4C11.8158 4.81578 12.2237 5.22367 12.7121 5.49543C12.9804 5.64471 13.2651 5.7626 13.5604 5.84678C14.0979 6 14.6747 6 15.8284 6H16.2021C18.8345 6 20.1506 6 21.0062 6.76946C21.0849 6.84024 21.1598 6.91514 21.2305 6.99383C21.8004 7.62741 21.9482 8.51364 21.9866 10"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M2 15C8.44365 15 6.55635 15 13 15M13 15L8.875 12M13 15L8.875 18"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
}
export function TrashIcon({ color, size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17"
        stroke={color ? color : "#F21C1C"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Logo() {
  return (
    <svg
      width="131"
      height="88"
      viewBox="0 0 131 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.7142 58.6182L68.5838 54.1321L88.0717 41.4112V39.5749L65.7806 54.1321L63.2489 55.7845V54.1321V47.4878L80.9259 36.4496L63.2489 25.4115V17.1168L88.0717 33.3244V31.4881V4.48612H64.7832V8.01086e-05L57.9135 4.48612L38.4307 17.2065V19.0383L60.7168 4.48612L63.2489 2.83126V4.48612V11.1304L45.5764 22.1686L63.2489 33.2068V41.5035L38.4307 25.2939V27.1252V54.1321H61.7142V58.6182Z"
        fill="#262641"
      />
      <path
        d="M13.6186 63.5045H15.7401V75.1043C15.7401 76.3019 15.4578 77.3712 14.8932 78.3122C14.3343 79.2475 13.5444 79.986 12.5236 80.5278C11.5028 81.0638 10.3052 81.3319 8.93078 81.3319C7.55637 81.3319 6.35876 81.0638 5.33794 80.5278C4.31711 79.986 3.52441 79.2475 2.95982 78.3122C2.40093 77.3712 2.12149 76.3019 2.12149 75.1043V63.5045H4.24297V74.9332C4.24297 75.7886 4.43117 76.55 4.80756 77.2172C5.18396 77.8788 5.72003 78.4006 6.41579 78.7827C7.11725 79.1591 7.95558 79.3473 8.93078 79.3473C9.90598 79.3473 10.7443 79.1591 11.4458 78.7827C12.1472 78.4006 12.6833 77.8788 13.054 77.2172C13.4304 76.55 13.6186 75.7886 13.6186 74.9332V63.5045ZM33.8689 63.5045V81.0239H31.8159L22.2692 67.2685H22.0981V81.0239H19.9766V63.5045H22.0297L31.6106 77.2942H31.7817V63.5045H33.8689ZM40.2355 63.5045V81.0239H38.1141V63.5045H40.2355ZM44.4892 81.0239V63.5045H54.994V65.3865H46.6107V71.3061H54.207V73.1881H46.6107V81.0239H44.4892ZM57.1219 63.5045H59.5513L64.4102 71.6825H64.6155L69.4744 63.5045H71.9039L65.5736 73.804V81.0239H63.4521V73.804L57.1219 63.5045Z"
        fill="#262641"
      />
      <path
        d="M79.1858 81.0239V63.5045H82.8898V77.97H90.4006V81.0239H79.1858ZM96.5576 63.5045V81.0239H92.8535V63.5045H96.5576ZM109.109 68.5431C109.041 67.853 108.747 67.317 108.228 66.9349C107.709 66.5528 107.005 66.3617 106.115 66.3617C105.51 66.3617 105 66.4473 104.584 66.6183C104.167 66.7837 103.848 67.0147 103.626 67.3112C103.409 67.6078 103.301 67.9443 103.301 68.3207C103.289 68.6343 103.355 68.9081 103.497 69.1419C103.646 69.3757 103.848 69.5782 104.105 69.7492C104.361 69.9146 104.658 70.0601 104.994 70.1855C105.331 70.3053 105.69 70.4079 106.072 70.4935L107.646 70.8699C108.41 71.041 109.112 71.2691 109.751 71.5542C110.389 71.8394 110.942 72.1901 111.41 72.6064C111.878 73.0227 112.24 73.5132 112.497 74.0778C112.759 74.6424 112.893 75.2896 112.899 76.0196C112.893 77.0918 112.619 78.0213 112.077 78.8083C111.541 79.5896 110.766 80.197 109.751 80.6304C108.741 81.0581 107.524 81.272 106.098 81.272C104.684 81.272 103.452 81.0553 102.402 80.6219C101.359 80.1884 100.543 79.5469 99.9558 78.6971C99.3741 77.8417 99.069 76.7838 99.0405 75.5235H102.625C102.665 76.1109 102.833 76.6013 103.129 76.9948C103.432 77.3826 103.834 77.6763 104.336 77.8759C104.843 78.0698 105.416 78.1668 106.055 78.1668C106.682 78.1668 107.227 78.0755 107.689 77.893C108.157 77.7105 108.519 77.4567 108.775 77.1317C109.032 76.8066 109.16 76.4331 109.16 76.0111C109.16 75.6176 109.043 75.2868 108.81 75.0187C108.581 74.7507 108.245 74.5226 107.8 74.3344C107.361 74.1462 106.822 73.9751 106.183 73.8211L104.276 73.3421C102.799 72.9828 101.632 72.4211 100.777 71.6569C99.9216 70.8927 99.4967 69.8633 99.5024 68.5687C99.4967 67.508 99.779 66.5813 100.349 65.7886C100.925 64.9959 101.715 64.3771 102.719 63.9323C103.723 63.4874 104.863 63.265 106.141 63.265C107.441 63.265 108.576 63.4874 109.545 63.9323C110.52 64.3771 111.279 64.9959 111.821 65.7886C112.363 66.5813 112.642 67.4994 112.659 68.5431H109.109ZM114.723 66.5585V63.5045H129.111V66.5585H123.748V81.0239H120.086V66.5585H114.723Z"
        fill="#262641"
      />
    </svg>
  );
}
export function LogoIcon({
  width,
  color,
  height,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width ? width : "51"}
      height={height ? height : "59"}
      viewBox="0 0 51 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7145 58.6181L30.5841 54.1321L50.0719 41.4111V39.5749L27.7808 54.1321L25.2492 55.7844V54.1321V47.4877L42.9262 36.4496L25.2492 25.4115V17.1168L50.0719 33.3244V31.488V4.48606H26.7834V1.90735e-05L19.9138 4.48606L0.430908 17.2065V19.0383L22.7171 4.48606L25.2492 2.8312V4.48606V11.1304L7.57667 22.1685L25.2492 33.2067V41.5034L0.430908 25.2938V27.1251V54.1321H23.7145V58.6181Z"
        fill={color !== "" ? color : "#262641"}
      />
    </svg>
  );
}
export function BrandIcon({
  width = "77",
  // color,
  height = "83",
}: {
  // color?: string;
  width?: string;
  height?: string;
}) {
  return (
    // <svg width={width ? width : "77"} height={height ? height : "83"} viewBox="0 0 77 83">
    //   <path
    //     d="M41 6L6.00007 28.5L6 32L6.00007 34.5L41 57.5"
    //     fill="none"
    //     stroke={color !== "" ? color : "#262641"}
    //     strokeWidth="12px"
    //     strokeDasharray="100 100"
    //     className="path-1"
    //   />
    //   <path
    //     d="M36 77.5L70.9999 55L71 51.5L70.9999 49L36 26"
    //     fill="none"
    //     stroke={color !== "" ? color : "#262641"}
    //     strokeWidth="12px"
    //     strokeDasharray="100 100"
    //     className="path-2"
    //   />
    // </svg>
    <svg
      width={width}
      height={height}
      viewBox="0 0 77 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_2)">
        <path
          d="M41 6L6.00007 28.5L6 32L6.00007 34.5L41 57.5"
          stroke="url(#paint0_linear_1_2)"
          strokeWidth="12"
        />
        <path
          d="M36 77.5L70.9999 55L71 51.5L70.9999 49L36 26"
          stroke="url(#paint1_linear_1_2)"
          strokeWidth="12"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_2"
          x1="23.5"
          y1="6"
          x2="23.5"
          y2="57.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F005C" />
          <stop offset="0.2" stopColor="#5B0060" />
          <stop offset="0.4" stopColor="#870160" />
          <stop offset="0.6" stopColor="#AC255E" />
          <stop offset="0.8" stopColor="#CA485C" />
          <stop offset="1" stopColor="#E16B5C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_2"
          x1="53.5"
          y1="26"
          x2="53.5"
          y2="77.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#3D005E" />
          <stop offset="0.15" stopColor="#4C005F" />
          <stop offset="0.2" stopColor="#5B0060" />
          <stop offset="0.4" stopColor="#870160" />
          <stop offset="0.6" stopColor="#AC255E" />
          <stop offset="0.8" stopColor="#CA485C" />
          <stop offset="1" stopColor="#E16B5C" />
        </linearGradient>
        <clipPath id="clip0_1_2">
          <rect width="77" height="83" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function Google() {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.4236 7.53113H16.7799V7.5H9.58831V10.5H14.1042C13.4454 12.2464 11.6751 13.5 9.58831 13.5C6.94061 13.5 4.79392 11.4851 4.79392 9C4.79392 6.51488 6.94061 4.5 9.58831 4.5C10.8105 4.5 11.9224 4.93275 12.769 5.63963L15.0292 3.51825C13.602 2.26988 11.6931 1.5 9.58831 1.5C5.17547 1.5 1.59766 4.85813 1.59766 9C1.59766 13.1419 5.17547 16.5 9.58831 16.5C14.0012 16.5 17.579 13.1419 17.579 9C17.579 8.49713 17.5238 8.00625 17.4236 7.53113Z"
        fill="#FFC107"
      />
      <path
        d="M2.51953 5.50912L5.14486 7.31625C5.85523 5.6655 7.57562 4.5 9.58887 4.5C10.811 4.5 11.9229 4.93275 12.7695 5.63962L15.0297 3.51825C13.6026 2.26987 11.6936 1.5 9.58887 1.5C6.51965 1.5 3.85797 3.12637 2.51953 5.50912Z"
        fill="#FF3D00"
      />
      <path
        d="M9.58927 16.5C11.6533 16.5 13.5287 15.7586 14.9466 14.553L12.4735 12.5888C11.6443 13.1807 10.631 13.5008 9.58927 13.5C7.5109 13.5 5.74616 12.2561 5.08134 10.5203L2.47559 12.4046C3.79804 14.8335 6.4837 16.5 9.58927 16.5Z"
        fill="#4CAF50"
      />
      <path
        d="M17.4241 7.53113H16.7805V7.5H9.58887V10.5H14.1048C13.7896 11.3312 13.222 12.0574 12.4719 12.5891L12.4731 12.5884L14.9462 14.5526C14.7712 14.7019 17.5795 12.75 17.5795 9C17.5795 8.49712 17.5244 8.00625 17.4241 7.53113Z"
        fill="#1976D2"
      />
    </svg>
  );
}
export function Facebook() {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.477 0.679199H1.70199C1.16166 0.679199 0.723633 1.09033 0.723633 1.59748V16.4039C0.723633 16.911 1.16166 17.3222 1.70199 17.3222H17.477C18.0174 17.3222 18.4554 16.911 18.4554 16.4039V1.59748C18.4554 1.09033 18.0174 0.679199 17.477 0.679199Z"
        fill="#3D5A98"
      />
      <path
        d="M12.9569 17.3207V10.8759H15.2612L15.6058 8.36433H12.9569V6.76121C12.9569 6.03418 13.1726 5.53777 14.2828 5.53777H15.7001V3.28777C15.0138 3.22063 14.3241 3.18871 13.6341 3.19214C11.5935 3.19214 10.1881 4.35933 10.1881 6.5123V8.36433H7.88379V10.8759H10.1881V17.3207H12.9569Z"
        fill="white"
      />
    </svg>
  );
}
export function Email({ color }: IconProps) {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.417 1.68023C15.417 0.888234 14.742 0.240234 13.917 0.240234H1.91699C1.09199 0.240234 0.416992 0.888234 0.416992 1.68023V10.3202C0.416992 11.1122 1.09199 11.7602 1.91699 11.7602H13.917C14.742 11.7602 15.417 11.1122 15.417 10.3202V1.68023ZM13.917 1.68023L7.91699 5.28024L1.91699 1.68023H13.917ZM13.917 10.3202H1.91699V3.12024L7.91699 6.72024L13.917 3.12024V10.3202Z"
        fill={color || "#B4ADAD"}
      />
    </svg>
  );
}
export function Password({ color }: IconProps) {
  return (
    <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 16.5C1.0875 16.5 0.734251 16.353 0.440251 16.059C0.146251 15.765 -0.000498727 15.412 1.27335e-06 15V7.5C1.27335e-06 7.0875 0.147001 6.73425 0.441001 6.44025C0.735001 6.14625 1.088 5.9995 1.5 6H2.25V4.5C2.25 3.4625 2.61575 2.578 3.34725 1.8465C4.07875 1.115 4.963 0.749501 6 0.750001C7.0375 0.750001 7.922 1.11575 8.6535 1.84725C9.385 2.57875 9.7505 3.463 9.75 4.5V6H10.5C10.9125 6 11.2658 6.147 11.5598 6.441C11.8538 6.735 12.0005 7.088 12 7.5V15C12 15.4125 11.853 15.7657 11.559 16.0597C11.265 16.3537 10.912 16.5005 10.5 16.5H1.5ZM1.5 15H10.5V7.5H1.5V15ZM6 12.75C6.4125 12.75 6.76575 12.603 7.05975 12.309C7.35375 12.015 7.5005 11.662 7.5 11.25C7.5 10.8375 7.353 10.4842 7.059 10.1902C6.765 9.89625 6.412 9.7495 6 9.75C5.5875 9.75 5.23425 9.897 4.94025 10.191C4.64625 10.485 4.4995 10.838 4.5 11.25C4.5 11.6625 4.647 12.0157 4.941 12.3097C5.235 12.6037 5.588 12.7505 6 12.75ZM3.75 6H8.25V4.5C8.25 3.875 8.03125 3.34375 7.59375 2.90625C7.15625 2.46875 6.625 2.25 6 2.25C5.375 2.25 4.84375 2.46875 4.40625 2.90625C3.96875 3.34375 3.75 3.875 3.75 4.5V6Z"
        fill={color || "#B4ADAD"}
      />
    </svg>
  );
}
export function UserIcon({ color }: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
        stroke={color ? color : "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function UserCircleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.12 12.78C12.05 12.77 11.96 12.77 11.88 12.78C10.12 12.72 8.71997 11.28 8.71997 9.50998C8.71997 7.69998 10.18 6.22998 12 6.22998C13.81 6.22998 15.28 7.69998 15.28 9.50998C15.27 11.28 13.88 12.72 12.12 12.78Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.74 19.3801C16.96 21.0101 14.6 22.0001 12 22.0001C9.40001 22.0001 7.04001 21.0101 5.26001 19.3801C5.36001 18.4401 5.96001 17.5201 7.03001 16.8001C9.77001 14.9801 14.25 14.9801 16.97 16.8001C18.04 17.5201 18.64 18.4401 18.74 19.3801Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PenIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.11962 25.7527L12.0746 17.7977M22.0921 14.2602L19.7109 21.4039C19.6729 21.5184 19.6078 21.6221 19.5212 21.7061C19.4346 21.7901 19.329 21.8519 19.2134 21.8864L4.61587 26.2252C4.48436 26.2642 4.34465 26.2665 4.21196 26.2316C4.07926 26.1968 3.95866 26.1263 3.86328 26.0276C3.7679 25.929 3.70139 25.8062 3.67099 25.6724C3.64059 25.5386 3.64747 25.3991 3.69087 25.2689L8.43087 11.0514C8.46484 10.9493 8.52038 10.8558 8.59371 10.777C8.66704 10.6983 8.75645 10.6363 8.85587 10.5952L15.5896 7.82266C15.7265 7.76612 15.8771 7.75139 16.0224 7.7803C16.1676 7.80922 16.3011 7.88051 16.4059 7.98516L21.9109 13.4914C22.0096 13.59 22.0789 13.7142 22.1109 13.85C22.1429 13.9858 22.1364 14.1278 22.0921 14.2602Z"
        stroke="#00033e"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2399 13.8201L25.7749 10.2839C26.2436 9.81504 26.5069 9.17927 26.5069 8.51636C26.5069 7.85345 26.2436 7.21768 25.7749 6.74886L23.1249 4.09636C22.8928 3.86411 22.6171 3.67987 22.3137 3.55417C22.0104 3.42847 21.6852 3.36377 21.3568 3.36377C21.0284 3.36377 20.7032 3.42847 20.3999 3.55417C20.0965 3.67987 19.8208 3.86411 19.5887 4.09636L16.0537 7.63261M14.7262 15.1451C14.552 14.971 14.3453 14.833 14.1177 14.7388C13.8902 14.6446 13.6464 14.5961 13.4001 14.5962C13.1539 14.5963 12.91 14.6448 12.6825 14.7391C12.4551 14.8334 12.2484 14.9716 12.0743 15.1457C11.9002 15.3199 11.7621 15.5266 11.668 15.7542C11.5738 15.9817 11.5253 16.2256 11.5254 16.4718C11.5254 16.7181 11.574 16.9619 11.6683 17.1894C11.7626 17.4168 11.9008 17.6235 12.0749 17.7976C12.4267 18.1492 12.9037 18.3466 13.401 18.3465C13.8983 18.3464 14.3752 18.1487 14.7268 17.797C15.0784 17.4452 15.2758 16.9682 15.2757 16.4709C15.2756 15.9736 15.0779 15.4967 14.7262 15.1451Z"
        stroke="#00033e"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BlockIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2499 17.6787H2.14272C1.55098 17.6787 1.07129 18.1584 1.07129 18.7501V27.8573C1.07129 28.449 1.55098 28.9287 2.14272 28.9287H11.2499C11.8416 28.9287 12.3213 28.449 12.3213 27.8573V18.7501C12.3213 18.1584 11.8416 17.6787 11.2499 17.6787Z"
        stroke="#00033e"
        strokeWidth="2.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8573 17.6787H18.7501C18.1584 17.6787 17.6787 18.1584 17.6787 18.7501V27.8573C17.6787 28.449 18.1584 28.9287 18.7501 28.9287H27.8573C28.449 28.9287 28.9287 28.449 28.9287 27.8573V18.7501C28.9287 18.1584 28.449 17.6787 27.8573 17.6787Z"
        stroke="#00033e"
        strokeWidth="2.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5643 1.07153H10.4572C9.86544 1.07153 9.38574 1.55123 9.38574 2.14296V11.2501C9.38574 11.8418 9.86544 12.3215 10.4572 12.3215H19.5643C20.156 12.3215 20.6357 11.8418 20.6357 11.2501V2.14296C20.6357 1.55123 20.156 1.07153 19.5643 1.07153Z"
        stroke="#00033e"
        strokeWidth="2.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SystemIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 5C14.1713 5 13.4725 5.685 13.4725 6.5625C13.4725 7.44 14.1713 8.125 15 8.125C15.8287 8.125 16.5275 7.44 16.5275 6.5625C16.5275 5.685 15.8287 5 15 5ZM10.9725 6.5625C10.9725 4.33375 12.76 2.5 15 2.5C17.2388 2.5 19.0275 4.33375 19.0275 6.5625C19.0293 7.41655 18.7619 8.24945 18.2633 8.94285C17.7647 9.63624 17.0602 10.1549 16.25 10.425V11.47L21.0613 14.2825V19.8538L22.0837 20.3675C22.8128 19.7266 23.7506 19.3737 24.7213 19.375C26.9625 19.375 28.75 21.2087 28.75 23.4375C28.75 25.6663 26.9613 27.5 24.7225 27.5C22.4837 27.5 20.695 25.6663 20.695 23.4375C20.695 23.1225 20.73 22.815 20.7975 22.5187L19.8563 22.0462L15 24.885L10.1437 22.0475L9.2025 22.52C9.27 22.815 9.305 23.1225 9.305 23.4375C9.305 25.6663 7.5175 27.5 5.2775 27.5C3.03875 27.5 1.25 25.6663 1.25 23.4375C1.25 21.2087 3.03875 19.375 5.2775 19.375C6.29 19.375 7.2125 19.75 7.9175 20.3687L8.93875 19.855V14.2825L13.75 11.47V10.4262C12.9396 10.156 12.235 9.63724 11.7364 8.94359C11.2377 8.24995 10.9704 7.41677 10.9725 6.5625ZM15 13.635L11.4388 15.7175V19.9075L15 21.99L18.5613 19.9075V15.7175L15 13.635ZM6.53125 22.5425C6.39226 22.3377 6.20545 22.1699 5.98698 22.0536C5.76852 21.9373 5.52499 21.876 5.2775 21.875C4.45 21.875 3.75 22.56 3.75 23.4375C3.75 24.315 4.44875 25 5.2775 25C6.1075 25 6.805 24.315 6.805 23.4375C6.805 23.255 6.775 23.08 6.72 22.9175L6.53125 22.5425ZM23.28 22.9212C23.2234 23.0875 23.1947 23.2619 23.195 23.4375C23.195 24.315 23.8925 25 24.7225 25C25.5513 25 26.25 24.315 26.25 23.4375C26.25 22.56 25.5513 21.875 24.7225 21.875C24.21 21.875 23.7487 22.1363 23.47 22.5413L23.28 22.9212Z"
        fill="#00033e"
      />
    </svg>
  );
}
export function UpdateIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 20L20 15H16.25V3.75H13.75V15H10L15 20ZM26.25 3.75H18.75V6.2375H26.25V23.775H3.75V6.2375H11.25V3.75H3.75C2.375 3.75 1.25 4.875 1.25 6.25V23.75C1.25 25.125 2.375 26.25 3.75 26.25H26.25C27.625 26.25 28.75 25.125 28.75 23.75V6.25C28.75 4.875 27.625 3.75 26.25 3.75Z"
        fill="white"
      />
    </svg>
  );
}
export function SettingsIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 18.75C17.0711 18.75 18.75 17.0711 18.75 15C18.75 12.9289 17.0711 11.25 15 11.25C12.9289 11.25 11.25 12.9289 11.25 15C11.25 17.0711 12.9289 18.75 15 18.75Z"
        stroke="#00033e"
        strokeWidth="1.875"
      />
      <path
        d="M17.2063 2.69C16.7476 2.5 16.1651 2.5 15.0001 2.5C13.8351 2.5 13.2526 2.5 12.7938 2.69C12.4903 2.81564 12.2145 2.99987 11.9822 3.23215C11.7499 3.46444 11.5657 3.74023 11.4401 4.04375C11.3251 4.3225 11.2788 4.64875 11.2613 5.1225C11.2535 5.46499 11.1588 5.79987 10.9861 6.09571C10.8134 6.39155 10.5683 6.63863 10.2738 6.81375C9.97495 6.9813 9.63838 7.07013 9.29574 7.07188C8.95311 7.07363 8.61565 6.98824 8.31507 6.82375C7.89507 6.60125 7.59132 6.47875 7.29007 6.43875C6.63297 6.35234 5.96845 6.53038 5.44258 6.93375C5.05008 7.2375 4.75757 7.74125 4.17507 8.75C3.59257 9.75875 3.30007 10.2625 3.23632 10.7562C3.19337 11.0818 3.21497 11.4127 3.29991 11.7299C3.38484 12.0471 3.53144 12.3445 3.73132 12.605C3.91632 12.845 4.17507 13.0462 4.57632 13.2987C5.16757 13.67 5.54758 14.3025 5.54758 15C5.54758 15.6975 5.16757 16.33 4.57632 16.7C4.17507 16.9537 3.91507 17.155 3.73132 17.395C3.53144 17.6555 3.38484 17.9529 3.29991 18.2701C3.21497 18.5873 3.19337 18.9182 3.23632 19.2438C3.30132 19.7363 3.59257 20.2413 4.17382 21.25C4.75757 22.2587 5.04883 22.7625 5.44258 23.0662C5.70312 23.2661 6.00049 23.4127 6.31771 23.4977C6.63492 23.5826 6.96576 23.6042 7.29133 23.5613C7.59133 23.5213 7.89507 23.3988 8.31507 23.1763C8.61565 23.0118 8.95311 22.9264 9.29574 22.9281C9.63838 22.9299 9.97495 23.0187 10.2738 23.1862C10.8776 23.5362 11.2363 24.18 11.2613 24.8775C11.2788 25.3525 11.3238 25.6775 11.4401 25.9562C11.5657 26.2598 11.7499 26.5356 11.9822 26.7678C12.2145 27.0001 12.4903 27.1844 12.7938 27.31C13.2526 27.5 13.8351 27.5 15.0001 27.5C16.1651 27.5 16.7476 27.5 17.2063 27.31C17.5098 27.1844 17.7856 27.0001 18.0179 26.7678C18.2502 26.5356 18.4344 26.2598 18.5601 25.9562C18.6751 25.6775 18.7213 25.3525 18.7388 24.8775C18.7638 24.18 19.1226 23.535 19.7263 23.1862C20.0252 23.0187 20.3618 22.9299 20.7044 22.9281C21.047 22.9264 21.3845 23.0118 21.6851 23.1763C22.1051 23.3988 22.4088 23.5213 22.7088 23.5613C23.0344 23.6042 23.3652 23.5826 23.6824 23.4977C23.9997 23.4127 24.297 23.2661 24.5576 23.0662C24.9513 22.7637 25.2426 22.2587 25.8251 21.25C26.4076 20.2413 26.7001 19.7375 26.7638 19.2438C26.8068 18.9182 26.7852 18.5873 26.7002 18.2701C26.6153 17.9529 26.4687 17.6555 26.2688 17.395C26.0838 17.155 25.8251 16.9538 25.4238 16.7013C25.131 16.5233 24.8882 16.2737 24.7183 15.9762C24.5484 15.6786 24.457 15.3427 24.4526 15C24.4526 14.3025 24.8326 13.67 25.4238 13.3C25.8251 13.0463 26.0851 12.845 26.2688 12.605C26.4687 12.3445 26.6153 12.0471 26.7002 11.7299C26.7852 11.4127 26.8068 11.0818 26.7638 10.7562C26.6988 10.2637 26.4076 9.75875 25.8263 8.75C25.2426 7.74125 24.9513 7.2375 24.5576 6.93375C24.297 6.73386 23.9997 6.58727 23.6824 6.50233C23.3652 6.4174 23.0344 6.39579 22.7088 6.43875C22.4088 6.47875 22.1051 6.60125 21.6838 6.82375C21.3834 6.98802 21.0462 7.07328 20.7038 7.07153C20.3614 7.06978 20.0251 6.98108 19.7263 6.81375C19.4319 6.63863 19.1868 6.39155 19.0141 6.09571C18.8413 5.79987 18.7466 5.46499 18.7388 5.1225C18.7213 4.6475 18.6763 4.3225 18.5601 4.04375C18.4344 3.74023 18.2502 3.46444 18.0179 3.23215C17.7856 2.99987 17.5098 2.81564 17.2063 2.69Z"
        stroke="#00033e"
        strokeWidth="1.875"
      />
    </svg>
  );
}
export function EditLineIcon() {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99984 1.99996L9.99984 3.99996M6.6665 11.3333H11.9998M1.33317 8.66663L0.666504 11.3333L3.33317 10.6666L11.0572 2.94263C11.3071 2.69259 11.4476 2.35351 11.4476 1.99996C11.4476 1.64641 11.3071 1.30733 11.0572 1.05729L10.9425 0.942628C10.6925 0.692667 10.3534 0.552246 9.99984 0.552246C9.64628 0.552246 9.30721 0.692667 9.05717 0.942628L1.33317 8.66663Z"
        stroke="#363636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
// Playground
export function SingleLinetextIcon({ color, size }: { color?: string; size?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M2.22266 3.39689C2.22266 3.24955 2.28119 3.10824 2.38537 3.00406C2.48956 2.89987 2.63087 2.84134 2.77821 2.84134H9.44488C9.59222 2.84134 9.73353 2.89987 9.83772 3.00406C9.9419 3.10824 10.0004 3.24955 10.0004 3.39689V5.06356C10.0004 5.2109 9.9419 5.35221 9.83772 5.4564C9.73353 5.56059 9.59222 5.61912 9.44488 5.61912C9.29754 5.61912 9.15623 5.56059 9.05204 5.4564C8.94785 5.35221 8.88932 5.2109 8.88932 5.06356V3.95245H6.6671V10.6191H7.22266C7.37 10.6191 7.51131 10.6776 7.61549 10.7818C7.71968 10.886 7.77821 11.0273 7.77821 11.1747C7.77821 11.322 7.71968 11.4633 7.61549 11.5675C7.51131 11.6717 7.37 11.7302 7.22266 11.7302H5.00043C4.85309 11.7302 4.71178 11.6717 4.6076 11.5675C4.50341 11.4633 4.44488 11.322 4.44488 11.1747C4.44488 11.0273 4.50341 10.886 4.6076 10.7818C4.71178 10.6776 4.85309 10.6191 5.00043 10.6191H5.55599V3.95245H3.33377V5.06356C3.33377 5.2109 3.27524 5.35221 3.17105 5.4564C3.06686 5.56059 2.92555 5.61912 2.77821 5.61912C2.63087 5.61912 2.48956 5.56059 2.38537 5.4564C2.28119 5.35221 2.22266 5.2109 2.22266 5.06356V3.39689Z"
        fill={color || "#00033E"}
      />
    </svg>
  );
}
export function MultiLinetextIcon({ color, size }: { color?: string; size?: string }) {
  return (
    <svg
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5H3"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.5H3"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 14.5H3"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 19.5H3"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ButtonIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_824_3156)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.77778 4.53977H11.5556C11.7913 4.53977 12.0174 4.63342 12.1841 4.80012C12.3508 4.96682 12.4444 5.19291 12.4444 5.42866V8.09532C12.4444 8.33107 12.3508 8.55716 12.1841 8.72386C12.0174 8.89056 11.7913 8.98421 11.5556 8.98421H1.77778C1.54203 8.98421 1.31594 8.89056 1.14924 8.72386C0.982539 8.55716 0.888889 8.33107 0.888889 8.09532V5.42866C0.888889 5.19291 0.982539 4.96682 1.14924 4.80012C1.31594 4.63342 1.54203 4.53977 1.77778 4.53977ZM0 5.42866C0 4.95716 0.187301 4.50498 0.520699 4.17158C0.854097 3.83818 1.30628 3.65088 1.77778 3.65088H11.5556C12.0271 3.65088 12.4792 3.83818 12.8126 4.17158C13.146 4.50498 13.3333 4.95716 13.3333 5.42866V8.09532C13.3333 8.56682 13.146 9.019 12.8126 9.3524C12.4792 9.6858 12.0271 9.8731 11.5556 9.8731H1.77778C1.30628 9.8731 0.854097 9.6858 0.520699 9.3524C0.187301 9.019 0 8.56682 0 8.09532V5.42866ZM4 6.09532C3.82319 6.09532 3.65362 6.16556 3.5286 6.29059C3.40357 6.41561 3.33333 6.58518 3.33333 6.76199C3.33333 6.9388 3.40357 7.10837 3.5286 7.23339C3.65362 7.35842 3.82319 7.42866 4 7.42866C4.17681 7.42866 4.34638 7.35842 4.4714 7.23339C4.59643 7.10837 4.66667 6.9388 4.66667 6.76199C4.66667 6.58518 4.59643 6.41561 4.4714 6.29059C4.34638 6.16556 4.17681 6.09532 4 6.09532ZM6 6.76199C6 6.58518 6.07024 6.41561 6.19526 6.29059C6.32029 6.16556 6.48986 6.09532 6.66667 6.09532C6.84348 6.09532 7.01305 6.16556 7.13807 6.29059C7.2631 6.41561 7.33333 6.58518 7.33333 6.76199C7.33333 6.9388 7.2631 7.10837 7.13807 7.23339C7.01305 7.35842 6.84348 7.42866 6.66667 7.42866C6.48986 7.42866 6.32029 7.35842 6.19526 7.23339C6.07024 7.10837 6 6.9388 6 6.76199ZM9.33333 6.09532C9.15652 6.09532 8.98695 6.16556 8.86193 6.29059C8.73691 6.41561 8.66667 6.58518 8.66667 6.76199C8.66667 6.9388 8.73691 7.10837 8.86193 7.23339C8.98695 7.35842 9.15652 7.42866 9.33333 7.42866C9.51014 7.42866 9.67971 7.35842 9.80474 7.23339C9.92976 7.10837 10 6.9388 10 6.76199C10 6.58518 9.92976 6.41561 9.80474 6.29059C9.67971 6.16556 9.51014 6.09532 9.33333 6.09532Z"
          fill={color ? color : "#363636"}
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3156">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.0953217)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DateTimeIcon({ color, size }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.6669 3.11119H1.66688C1.36006 3.11119 1.11133 3.35992 1.11133 3.66675V10.889C1.11133 11.1958 1.36006 11.4445 1.66688 11.4445H11.6669C11.9737 11.4445 12.2224 11.1958 12.2224 10.889V3.66675C12.2224 3.35992 11.9737 3.11119 11.6669 3.11119Z"
        stroke={color || "#363636"}
        strokeWidth="1.11111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.88867 2.00008V4.2223M6.94423 6.7223H3.88867M9.44423 8.94452H3.88867M9.44423 2.00008V4.2223"
        stroke={color || "#363636"}
        strokeWidth="1.11111"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function DateRangeIcon({ color = "#292D32", size = "24" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="6" width="18" height="15" rx="2" stroke={color} />
      <path
        d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z"
        fill={color}
      />
      <path d="M7 3L7 6" stroke={color} strokeLinecap="round" />
      <path d="M17 3L17 6" stroke={color} strokeLinecap="round" />
      <rect x="7" y="12" width="4" height="2" rx="0.5" fill={color} />
      <rect x="7" y="16" width="4" height="2" rx="0.5" fill={color} />
      <rect x="13" y="12" width="4" height="2" rx="0.5" fill={color} />
      <rect x="13" y="16" width="4" height="2" rx="0.5" fill={color} />
    </svg>
  );
}

export function SearchIcon({ color, size }: { color?: "#363636"; size?: "14" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.8878 12.0173L9.21176 9.34129C9.97487 8.46371 10.3674 7.32411 10.3067 6.16273C10.246 5.00135 9.73669 3.90892 8.88621 3.11571C8.03573 2.3225 6.9105 1.89049 5.74771 1.91075C4.58492 1.931 3.47542 2.40193 2.65307 3.22427C1.83073 4.04661 1.3598 5.15612 1.33955 6.31891C1.3193 7.4817 1.75131 8.60693 2.54451 9.45741C3.33772 10.3079 4.43016 10.8172 5.59154 10.8779C6.75292 10.9386 7.89251 10.5461 8.77009 9.78296L11.4461 12.459C11.5054 12.5142 11.5837 12.5442 11.6647 12.5428C11.7456 12.5414 11.8229 12.5086 11.8801 12.4513C11.9374 12.3941 11.9702 12.3168 11.9716 12.2359C11.9731 12.1549 11.943 12.0766 11.8878 12.0173ZM1.97947 6.40483C1.97947 5.64255 2.20551 4.89739 2.62901 4.26357C3.05251 3.62976 3.65445 3.13576 4.35871 2.84405C5.06297 2.55233 5.83791 2.47601 6.58555 2.62472C7.33318 2.77344 8.01993 3.14051 8.55894 3.67952C9.09796 4.21854 9.46503 4.90529 9.61374 5.65292C9.76246 6.40056 9.68613 7.1755 9.39442 7.87976C9.10271 8.58401 8.60871 9.18595 7.97489 9.60945C7.34108 10.033 6.59592 10.259 5.83363 10.259C4.81183 10.2578 3.83222 9.8513 3.1097 9.12877C2.38717 8.40624 1.98071 7.42664 1.97947 6.40483Z"
        fill={color || "#363636"}
      />
    </svg>
  );
}
export function SideBarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <path
        d="M11.7456 4.30166V10.6509M1.58691 4.30166V10.6509M9.20596 4.30166H4.1266C3.78981 4.30166 3.46682 4.43545 3.22868 4.67359C2.99054 4.91173 2.85676 5.23472 2.85676 5.5715V9.38102C2.85676 9.71781 2.99054 10.0408 3.22868 10.2789C3.46682 10.5171 3.78981 10.6509 4.1266 10.6509H9.20596C9.54274 10.6509 9.86573 10.5171 10.1039 10.2789C10.342 10.0408 10.4758 9.71781 10.4758 9.38102V5.5715C10.4758 5.23472 10.342 4.91173 10.1039 4.67359C9.86573 4.43545 9.54274 4.30166 9.20596 4.30166Z"
        stroke="#363636"
        strokeWidth="0.634921"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SingleChoiceIcon({ color, size }: { color?: string; size?: string }) {
  return (
    <svg
      width={size || "18"}
      height={size || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={color || "black"}
      />
      <path
        d="M9 14.25C11.8995 14.25 14.25 11.8995 14.25 9C14.25 6.10051 11.8995 3.75 9 3.75C6.10051 3.75 3.75 6.10051 3.75 9C3.75 11.8995 6.10051 14.25 9 14.25Z"
        fill={color || "black"}
      />
    </svg>
  );
}
export function MultipleChoiceIcon({ color, size }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "18"}
      height={size || "18"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M5.55566 4.45245C5.55566 4.37878 5.58493 4.30813 5.63702 4.25603C5.68912 4.20394 5.75977 4.17467 5.83344 4.17467H8.05566C8.12934 4.17467 8.19999 4.20394 8.25208 4.25603C8.30418 4.30813 8.33344 4.37878 8.33344 4.45245C8.33344 4.52612 8.30418 4.59678 8.25208 4.64887C8.19999 4.70096 8.12934 4.73023 8.05566 4.73023H5.83344C5.75977 4.73023 5.68912 4.70096 5.63702 4.64887C5.58493 4.59678 5.55566 4.52612 5.55566 4.45245ZM5.83344 5.28578C5.75977 5.28578 5.68912 5.31505 5.63702 5.36714C5.58493 5.41924 5.55566 5.48989 5.55566 5.56356C5.55566 5.63723 5.58493 5.70789 5.63702 5.75998C5.68912 5.81207 5.75977 5.84134 5.83344 5.84134H8.05566C8.12934 5.84134 8.19999 5.81207 8.25208 5.75998C8.30418 5.70789 8.33344 5.63723 8.33344 5.56356C8.33344 5.48989 8.30418 5.41924 8.25208 5.36714C8.19999 5.31505 8.12934 5.28578 8.05566 5.28578H5.83344ZM5.55566 8.06356C5.55566 7.98989 5.58493 7.91924 5.63702 7.86714C5.68912 7.81505 5.75977 7.78578 5.83344 7.78578H8.05566C8.12934 7.78578 8.19999 7.81505 8.25208 7.86714C8.30418 7.91924 8.33344 7.98989 8.33344 8.06356C8.33344 8.13723 8.30418 8.20789 8.25208 8.25998C8.19999 8.31207 8.12934 8.34134 8.05566 8.34134H5.83344C5.75977 8.34134 5.68912 8.31207 5.63702 8.25998C5.58493 8.20789 5.55566 8.13723 5.55566 8.06356ZM5.83344 8.89689C5.75977 8.89689 5.68912 8.92616 5.63702 8.97825C5.58493 9.03035 5.55566 9.101 5.55566 9.17467C5.55566 9.24834 5.58493 9.319 5.63702 9.37109C5.68912 9.42318 5.75977 9.45245 5.83344 9.45245H8.05566C8.12934 9.45245 8.19999 9.42318 8.25208 9.37109C8.30418 9.319 8.33344 9.24834 8.33344 9.17467C8.33344 9.101 8.30418 9.03035 8.25208 8.97825C8.19999 8.92616 8.12934 8.89689 8.05566 8.89689H5.83344Z"
        fill={color || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77832 7.78578C2.77832 7.71211 2.80759 7.64146 2.85968 7.58937C2.91177 7.53727 2.98243 7.50801 3.0561 7.50801H4.44499C4.51866 7.50801 4.58931 7.53727 4.64141 7.58937C4.6935 7.64146 4.72276 7.71211 4.72276 7.78578V9.17467C4.72276 9.24834 4.6935 9.319 4.64141 9.37109C4.58931 9.42319 4.51866 9.45245 4.44499 9.45245H3.0561C2.98243 9.45245 2.91177 9.42319 2.85968 9.37109C2.80759 9.319 2.77832 9.24834 2.77832 9.17467V7.78578ZM3.33388 8.06356V8.8969H4.16721V8.06356H3.33388Z"
        fill={color || "black"}
      />
      <path
        d="M4.91867 4.64884C4.96927 4.59645 4.99727 4.52628 4.99664 4.45345C4.996 4.38062 4.96679 4.31095 4.91529 4.25945C4.86378 4.20794 4.79411 4.17873 4.72128 4.1781C4.64845 4.17746 4.57828 4.20546 4.52589 4.25606L3.61117 5.17079L3.252 4.81162C3.19961 4.76102 3.12945 4.73302 3.05661 4.73365C2.98378 4.73429 2.91411 4.7635 2.86261 4.815C2.81111 4.8665 2.78189 4.93617 2.78126 5.00901C2.78063 5.08184 2.80863 5.15201 2.85923 5.2044L3.61117 5.95634L4.91867 4.64884Z"
        fill={color || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7781 1.95245C2.48342 1.95245 2.2008 2.06951 1.99243 2.27789C1.78406 2.48626 1.66699 2.76888 1.66699 3.06356V10.8413C1.66699 11.136 1.78406 11.4186 1.99243 11.627C2.2008 11.8354 2.48342 11.9525 2.7781 11.9525H8.33366C8.62834 11.9525 8.91096 11.8354 9.11933 11.627C9.32771 11.4186 9.44477 11.136 9.44477 10.8413V3.06356C9.44477 2.76888 9.32771 2.48626 9.11933 2.27789C8.91096 2.06951 8.62834 1.95245 8.33366 1.95245H2.7781ZM2.22255 3.06356C2.22255 2.91622 2.28108 2.77491 2.38527 2.67073C2.48945 2.56654 2.63076 2.50801 2.7781 2.50801H8.33366C8.481 2.50801 8.62231 2.56654 8.7265 2.67073C8.83068 2.77491 8.88921 2.91622 8.88921 3.06356V10.8413C8.88921 10.9887 8.83068 11.13 8.7265 11.2342C8.62231 11.3384 8.481 11.3969 8.33366 11.3969H2.7781C2.63076 11.3969 2.48945 11.3384 2.38527 11.2342C2.28108 11.13 2.22255 10.9887 2.22255 10.8413V3.06356ZM10.0003 4.73023C10.0003 4.50922 10.0881 4.29725 10.2444 4.14097C10.4007 3.98469 10.6126 3.8969 10.8337 3.8969C11.0547 3.8969 11.2666 3.98469 11.4229 4.14097C11.5792 4.29725 11.667 4.50922 11.667 4.73023V10.37L10.8337 11.62L10.0003 10.37V4.73023ZM10.8337 4.45245C10.76 4.45245 10.6893 4.48172 10.6372 4.53381C10.5851 4.5859 10.5559 4.65656 10.5559 4.73023V5.28579H11.1114V4.73023C11.1114 4.65656 11.0822 4.5859 11.0301 4.53381C10.978 4.48172 10.9073 4.45245 10.8337 4.45245ZM10.8337 10.6183L10.5559 10.2016V5.84134H11.1114V10.2016L10.8337 10.6183Z"
        fill={color || "black"}
      />
    </svg>
  );
}
export function FileUploadIcon({ size = "14", color = "#363636" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_824_3189)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66656 1.21832C6.72672 1.21828 6.78618 1.23127 6.84084 1.2564C6.8955 1.28152 6.94408 1.31819 6.98322 1.36387L8.64989 3.30832C8.72179 3.3923 8.75739 3.50141 8.74885 3.61164C8.7403 3.72187 8.68832 3.82419 8.60434 3.8961C8.52035 3.968 8.41124 4.00359 8.30101 3.99505C8.19078 3.98651 8.08846 3.93453 8.01656 3.85054L7.08322 2.76165V8.85721C7.08322 8.96771 7.03933 9.07369 6.96119 9.15183C6.88305 9.22997 6.77706 9.27387 6.66656 9.27387C6.55605 9.27387 6.45007 9.22997 6.37193 9.15183C6.29379 9.07369 6.24989 8.96771 6.24989 8.85721V2.7611L5.31656 3.85054C5.28095 3.89213 5.23751 3.92629 5.1887 3.95109C5.1399 3.97588 5.08668 3.99082 5.0321 3.99505C4.97752 3.99928 4.92265 3.99272 4.8706 3.97574C4.81856 3.95876 4.77037 3.9317 4.72878 3.8961C4.68719 3.86049 4.65303 3.81705 4.62823 3.76824C4.60344 3.71944 4.5885 3.66622 4.58427 3.61164C4.58004 3.55706 4.5866 3.50218 4.60358 3.45014C4.62056 3.39809 4.64762 3.3499 4.68322 3.30832L6.34989 1.36387C6.38904 1.31819 6.43761 1.28152 6.49227 1.2564C6.54694 1.23127 6.6064 1.21828 6.66656 1.21832ZM3.88656 5.10832C3.99706 5.10773 4.10328 5.15106 4.18184 5.22879C4.26039 5.30651 4.30486 5.41226 4.30545 5.52276C4.30604 5.63327 4.2627 5.73949 4.18498 5.81804C4.10726 5.8966 4.00151 5.94106 3.891 5.94165C3.28378 5.94499 2.85322 5.96054 2.526 6.02054C2.21156 6.07887 2.02878 6.17165 1.89378 6.30665C1.73989 6.46054 1.63989 6.67665 1.58489 7.08443C1.52878 7.50387 1.52767 8.05999 1.52767 8.85721V9.41276C1.52767 10.2105 1.52878 10.7667 1.58489 11.1861C1.63989 11.5939 1.74045 11.8094 1.89378 11.9639C2.04767 12.1172 2.26322 12.2172 2.67156 12.2722C3.09045 12.3289 3.64711 12.3294 4.44434 12.3294H8.88878C9.686 12.3294 10.2421 12.3289 10.6621 12.2722C11.0699 12.2172 11.2854 12.1172 11.4393 11.9633C11.5932 11.8094 11.6932 11.5939 11.7482 11.1861C11.8043 10.7667 11.8054 10.2105 11.8054 9.41276V8.85721C11.8054 8.05999 11.8043 7.50387 11.7482 7.08387C11.6932 6.67665 11.5927 6.46054 11.4393 6.30665C11.3038 6.17165 11.1216 6.07887 10.8071 6.02054C10.4799 5.96054 10.0493 5.94499 9.44211 5.94165C9.3874 5.94136 9.33327 5.93029 9.28283 5.90908C9.23239 5.88788 9.18662 5.85694 9.14814 5.81804C9.10965 5.77914 9.0792 5.73305 9.05853 5.68238C9.03786 5.63172 9.02738 5.57748 9.02767 5.52276C9.02796 5.46805 9.03903 5.41392 9.06024 5.36348C9.08144 5.31304 9.11238 5.26727 9.15128 5.22879C9.19018 5.1903 9.23627 5.15986 9.28694 5.13919C9.3376 5.11852 9.39184 5.10803 9.44656 5.10832C10.0477 5.11165 10.5482 5.1261 10.9577 5.2011C11.3788 5.27887 11.7371 5.4261 12.0288 5.71776C12.3632 6.05165 12.5066 6.47332 12.5743 6.97332C12.6388 7.45443 12.6388 8.06721 12.6388 8.82665V9.44332C12.6388 10.2033 12.6388 10.8155 12.5743 11.2972C12.5066 11.7972 12.3632 12.2183 12.0288 12.5528C11.6943 12.8872 11.2732 13.0305 10.7732 13.0983C10.2916 13.1628 9.67878 13.1628 8.91934 13.1628H4.41378C3.65434 13.1628 3.04156 13.1628 2.55989 13.0983C2.05989 13.0311 1.63878 12.8872 1.30434 12.5528C0.969892 12.2183 0.826558 11.7972 0.759336 11.2972C0.694336 10.8155 0.694336 10.2028 0.694336 9.44332V8.82665C0.694336 8.06721 0.694336 7.45443 0.759336 6.97276C0.826003 6.47276 0.970447 6.05165 1.30434 5.71721C1.596 5.4261 1.95434 5.27832 2.37545 5.2011C2.78489 5.1261 3.28545 5.11165 3.88656 5.10832Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3189">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.523879)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function DropDownIcon({ color }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <path
        d="M6.47244 8.90087C6.52799 8.95643 6.59281 8.9842 6.66688 8.9842C6.74096 8.9842 6.80577 8.95643 6.86133 8.90087L8.41688 7.34532C8.50948 7.25272 8.53262 7.15087 8.48633 7.03976C8.44003 6.92865 8.35207 6.87309 8.22244 6.87309H5.11133C4.9817 6.87309 4.89374 6.92865 4.84744 7.03976C4.80114 7.15087 4.82429 7.25272 4.91688 7.34532L6.47244 8.90087ZM6.66688 12.9842C5.89837 12.9842 5.17614 12.8383 4.50022 12.5464C3.82429 12.2546 3.23633 11.8588 2.73633 11.3592C2.23633 10.8592 1.84059 10.2712 1.54911 9.59531C1.25762 8.91939 1.1117 8.19717 1.11133 7.42865C1.11133 6.66013 1.25725 5.93791 1.54911 5.26198C1.84096 4.58606 2.2367 3.99809 2.73633 3.49809C3.23633 2.99809 3.82429 2.60235 4.50022 2.31087C5.17614 2.01939 5.89837 1.87346 6.66688 1.87309C7.4354 1.87309 8.15762 2.01902 8.83355 2.31087C9.50948 2.60272 10.0974 2.99846 10.5974 3.49809C11.0974 3.99809 11.4934 4.58606 11.7852 5.26198C12.0771 5.93791 12.2228 6.66013 12.2224 7.42865C12.2224 8.19717 12.0765 8.91939 11.7847 9.59531C11.4928 10.2712 11.0971 10.8592 10.5974 11.3592C10.0974 11.8592 9.50948 12.2551 8.83355 12.547C8.15762 12.8388 7.4354 12.9846 6.66688 12.9842ZM6.66688 11.8731C7.90762 11.8731 8.95855 11.4425 9.81966 10.5814C10.6808 9.72031 11.1113 8.66939 11.1113 7.42865C11.1113 6.18791 10.6808 5.13698 9.81966 4.27587C8.95855 3.41476 7.90762 2.9842 6.66688 2.9842C5.42614 2.9842 4.37522 3.41476 3.51411 4.27587C2.65299 5.13698 2.22244 6.18791 2.22244 7.42865C2.22244 8.66939 2.65299 9.72031 3.51411 10.5814C4.37522 11.4425 5.42614 11.8731 6.66688 11.8731Z"
        fill={color || "#363636"}
      />
    </svg>
  );
}
export function QRCodeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M1.11133 3.88895V1.11118H3.88911V2.22229H2.22244V3.88895H1.11133ZM1.11133 12.2223V9.44451H2.22244V11.1112H3.88911V12.2223H1.11133ZM9.44466 12.2223V11.1112H11.1113V9.44451H12.2224V12.2223H9.44466ZM11.1113 3.88895V2.22229H9.44466V1.11118H12.2224V3.88895H11.1113ZM9.72244 9.72229H10.5558V10.5556H9.72244V9.72229ZM9.72244 8.05562H10.5558V8.88895H9.72244V8.05562ZM8.88911 8.88895H9.72244V9.72229H8.88911V8.88895ZM8.05577 9.72229H8.88911V10.5556H8.05577V9.72229ZM7.22244 8.88895H8.05577V9.72229H7.22244V8.88895ZM8.88911 7.22229H9.72244V8.05562H8.88911V7.22229ZM8.05577 8.05562H8.88911V8.88895H8.05577V8.05562ZM7.22244 7.22229H8.05577V8.05562H7.22244V7.22229ZM10.5558 2.77784V6.11118H7.22244V2.77784H10.5558ZM6.11133 7.22229V10.5556H2.77799V7.22229H6.11133ZM6.11133 2.77784V6.11118H2.77799V2.77784H6.11133ZM5.27799 9.72229V8.05562H3.61133V9.72229H5.27799ZM5.27799 5.27784V3.61118H3.61133V5.27784H5.27799ZM9.72244 5.27784V3.61118H8.05577V5.27784H9.72244Z"
        fill="#363636"
      />
    </svg>
  );
}
export function ColorPickerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_824_3204)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.40298 9.58997C4.60298 9.90638 3.21991 10.8064 2.97837 10.5643C2.82145 10.4079 3.14401 9.7715 3.47683 9.12586H5.86709L5.40298 9.58997Z"
          fill="#363636"
        />
        <path
          d="M9.64257 4.62535C9.73873 4.52912 9.86918 4.47504 10.0052 4.47499C10.1412 4.47494 10.2717 4.52893 10.368 4.62509C10.4642 4.72125 10.5183 4.85169 10.5183 4.98773C10.5184 5.12377 10.4644 5.25425 10.3682 5.35048L5.76565 9.95304C5.71597 10.0027 5.65663 10.0416 5.59129 10.0674C5.38821 10.1474 5.18103 10.2489 4.69232 10.5007C4.45129 10.6248 4.34411 10.6792 4.21385 10.7438C3.31744 11.1853 2.98052 11.2915 2.61591 10.9269C2.2518 10.5628 2.35744 10.2259 2.79591 9.33458C2.86103 9.20278 2.91591 9.09458 3.04206 8.84996C3.29385 8.36124 3.39539 8.15458 3.47539 7.95099C3.50123 7.88583 3.54015 7.82667 3.58975 7.77714L8.19232 3.17458C8.23962 3.1256 8.29621 3.08653 8.35877 3.05965C8.42134 3.03278 8.48863 3.01863 8.55673 3.01804C8.62482 3.01745 8.69235 3.03042 8.75537 3.05621C8.81839 3.08199 8.87565 3.12007 8.9238 3.16822C8.97195 3.21637 9.01003 3.27363 9.03581 3.33665C9.0616 3.39968 9.07457 3.46721 9.07398 3.5353C9.07339 3.60339 9.05924 3.67068 9.03237 3.73325C9.00549 3.79581 8.96642 3.8524 8.91744 3.89971L4.38821 8.42894C4.29898 8.64176 4.18668 8.86791 3.95385 9.31971C3.86035 9.49986 3.76889 9.68107 3.6795 9.8633L3.76052 9.82381C3.8836 9.76278 3.98667 9.71048 4.22309 9.58894C4.67437 9.35612 4.90052 9.24381 5.11334 9.15458L9.64257 4.62535Z"
          fill="#363636"
        />
        <path
          d="M8.91764 3.89972C8.82148 3.99594 8.69104 4.05003 8.555 4.05008C8.41897 4.05013 8.28848 3.99613 8.19226 3.89997C8.09603 3.80382 8.04195 3.67337 8.0419 3.53733C8.04185 3.4013 8.09584 3.27081 8.192 3.17459C8.48054 2.88605 8.87189 2.72395 9.27995 2.72395C9.68801 2.72395 10.0794 2.88605 10.3679 3.17459C10.6564 3.46313 10.8185 3.85448 10.8185 4.26254C10.8185 4.6706 10.6564 5.06194 10.3679 5.35049C10.2717 5.44671 10.1413 5.5008 10.0053 5.50085C9.86922 5.50089 9.73874 5.4469 9.64251 5.35074C9.54629 5.25458 9.4922 5.12414 9.49215 4.9881C9.49211 4.85207 9.5461 4.72158 9.64226 4.62536C9.73574 4.52871 9.78753 4.3992 9.78645 4.26474C9.78538 4.13028 9.73154 4.00162 9.63653 3.90647C9.54151 3.81132 9.41293 3.75729 9.27847 3.75603C9.144 3.75477 9.01443 3.80637 8.91764 3.89972ZM6.37764 4.26126C6.28149 4.16503 6.22749 4.03455 6.22754 3.89851C6.22756 3.83115 6.24085 3.76446 6.26665 3.70224C6.29245 3.64001 6.33025 3.58348 6.3779 3.53587C6.42555 3.48826 6.4821 3.4505 6.54434 3.42474C6.60658 3.39899 6.67329 3.38574 6.74064 3.38577C6.87668 3.38582 7.00713 3.4399 7.10328 3.53613L10.0038 6.43715C10.0972 6.53387 10.1489 6.66341 10.1477 6.79787C10.1466 6.93233 10.0926 7.06095 9.99755 7.15603C9.90247 7.25112 9.77385 7.30505 9.63939 7.30622C9.50493 7.30739 9.37539 7.2557 9.27867 7.16228L6.37764 4.26126Z"
          fill="#363636"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66667 12.5459C9.78205 12.5459 12.3077 10.0202 12.3077 6.90483C12.3077 3.78945 9.78205 1.26381 6.66667 1.26381C3.55128 1.26381 1.02564 3.78945 1.02564 6.90483C1.02564 10.0202 3.55128 12.5459 6.66667 12.5459ZM6.66667 13.5715C10.3487 13.5715 13.3333 10.5869 13.3333 6.90483C13.3333 3.22278 10.3487 0.238167 6.66667 0.238167C2.98462 0.238167 0 3.22278 0 6.90483C0 10.5869 2.98462 13.5715 6.66667 13.5715Z"
          fill="#363636"
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3204">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.238167)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function MultiSelectDropdownIcon({ color }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_824_3212)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66667 3.23181C6.57237 3.23181 6.48193 3.26927 6.41525 3.33595C6.34857 3.40263 6.31111 3.49307 6.31111 3.58737C6.31111 3.68167 6.34857 3.7721 6.41525 3.83878C6.48193 3.90546 6.57237 3.94292 6.66667 3.94292H12.8889C12.9832 3.94292 13.0736 3.90546 13.1403 3.83878C13.207 3.7721 13.2444 3.68167 13.2444 3.58737C13.2444 3.49307 13.207 3.40263 13.1403 3.33595C13.0736 3.26927 12.9832 3.23181 12.8889 3.23181H6.66667ZM6.66667 5.00959C6.61998 5.00959 6.57374 5.01879 6.5306 5.03665C6.48746 5.05452 6.44827 5.08071 6.41525 5.11373C6.38224 5.14675 6.35605 5.18594 6.33818 5.22908C6.32031 5.27222 6.31111 5.31845 6.31111 5.36515C6.31111 5.41184 6.32031 5.45807 6.33818 5.50121C6.35605 5.54435 6.38224 5.58354 6.41525 5.61656C6.44827 5.64958 6.48746 5.67577 6.5306 5.69364C6.57374 5.7115 6.61998 5.7207 6.66667 5.7207H12.8889C12.9832 5.7207 13.0736 5.68324 13.1403 5.61656C13.207 5.54988 13.2444 5.45944 13.2444 5.36515C13.2444 5.27085 13.207 5.18041 13.1403 5.11373C13.0736 5.04705 12.9832 5.00959 12.8889 5.00959H6.66667ZM6.31111 7.14292C6.31111 6.94737 6.47111 6.78737 6.66667 6.78737H12.8889C12.9832 6.78737 13.0736 6.82483 13.1403 6.89151C13.207 6.95819 13.2444 7.04862 13.2444 7.14292C13.2444 7.23722 13.207 7.32766 13.1403 7.39434C13.0736 7.46102 12.9832 7.49848 12.8889 7.49848H6.66667C6.61998 7.49848 6.57374 7.48928 6.5306 7.47141C6.48746 7.45355 6.44827 7.42736 6.41525 7.39434C6.38224 7.36132 6.35605 7.32213 6.33818 7.27899C6.32031 7.23585 6.31111 7.18962 6.31111 7.14292ZM6.66667 8.56515C6.57237 8.56515 6.48193 8.60261 6.41525 8.66929C6.34857 8.73596 6.31111 8.8264 6.31111 8.9207C6.31111 9.015 6.34857 9.10544 6.41525 9.17212C6.48193 9.2388 6.57237 9.27626 6.66667 9.27626H12.8889C12.9832 9.27626 13.0736 9.2388 13.1403 9.17212C13.207 9.10544 13.2444 9.015 13.2444 8.9207C13.2444 8.8264 13.207 8.73596 13.1403 8.66929C13.0736 8.60261 12.9832 8.56515 12.8889 8.56515H6.66667ZM6.31111 10.6985C6.31111 10.5029 6.47111 10.3429 6.66667 10.3429H12.8889C12.9832 10.3429 13.0736 10.3804 13.1403 10.4471C13.207 10.5137 13.2444 10.6042 13.2444 10.6985C13.2444 10.7928 13.207 10.8832 13.1403 10.9499C13.0736 11.0166 12.9832 11.054 12.8889 11.054H6.66667C6.57237 11.054 6.48193 11.0166 6.41525 10.9499C6.34857 10.8832 6.31111 10.7928 6.31111 10.6985ZM2.22222 8.69848L4.44444 5.80959H0L2.22222 8.69848Z"
          fill={color || "#363636"}
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3212">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.476257)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function LayoutAccordionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <g clipPath="url(#clip0_824_3218)">
        <path
          d="M12.2917 5.63102V3.62268L9.16667 2.79768L7.86667 3.21435L6.66667 2.80602L5.475 3.21435L4.16667 2.79768L1.81667 3.42268C1.59494 3.47993 1.39851 3.60921 1.25824 3.79021C1.11796 3.97122 1.04178 4.19369 1.04167 4.42268V5.63102C0.765399 5.63102 0.500448 5.74076 0.305097 5.93611C0.109747 6.13146 0 6.39642 0 6.67268L0 7.92268C0 8.19895 0.109747 8.4639 0.305097 8.65925C0.500448 8.8546 0.765399 8.96435 1.04167 8.96435V10.3394C1.04178 10.5683 1.11796 10.7908 1.25824 10.9718C1.39851 11.1528 1.59494 11.2821 1.81667 11.3394L4.16667 11.9644L5.475 11.5894L6.66667 11.956L7.85833 11.5894L9.16667 11.9644L12.2917 11.131V8.96435C12.5679 8.96435 12.8329 8.8546 13.0282 8.65925C13.2236 8.4639 13.3333 8.19895 13.3333 7.92268V6.67268C13.3333 6.39642 13.2236 6.13146 13.0282 5.93611C12.8329 5.74076 12.5679 5.63102 12.2917 5.63102ZM3.125 10.631L2.08333 10.3394V4.42268L3.125 4.14768V10.631ZM4.16667 10.881V3.88102L5 4.10602V10.656L4.16667 10.881ZM6.00833 10.6644V4.09768L6.66667 3.89768L7.325 4.09768V10.6644L6.66667 10.8644L6.00833 10.6644ZM8.375 10.6644V4.10602L9.16667 3.88102V10.881L8.375 10.6644ZM11.25 10.3477L10.2083 10.6227V4.14768L11.25 4.42268V10.3477Z"
          fill="#363636"
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3218">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.71434)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function LocationPickerIcon({ color = "#292D32" }: { color?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.25 11H14.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 13.75V8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M3.62001 8.49C5.59001 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.39001 20.54C5.63001 17.88 2.47001 13.57 3.62001 8.49Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}
export function SectionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M11.6669 1.30168H1.66688C1.51954 1.30168 1.37823 1.36021 1.27405 1.4644C1.16986 1.56859 1.11133 1.70989 1.11133 1.85724V11.8572C1.11133 12.0046 1.16986 12.1459 1.27405 12.2501C1.37823 12.3543 1.51954 12.4128 1.66688 12.4128H11.6669C11.8142 12.4128 11.9555 12.3543 12.0597 12.2501C12.1639 12.1459 12.2224 12.0046 12.2224 11.8572V1.85724C12.2224 1.70989 12.1639 1.56859 12.0597 1.4644C11.9555 1.36021 11.8142 1.30168 11.6669 1.30168ZM7.77799 11.3017H2.22244V2.41279H7.77799V11.3017ZM11.1113 11.3017H8.88911V2.41279H11.1113V11.3017Z"
        fill="#363636"
      />
    </svg>
  );
}
export function RatingIcon({ color, size }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_824_3234)">
        <path
          d="M7.13297 1.46677L8.64726 4.52391C8.6817 4.6015 8.73587 4.66872 8.80439 4.71885C8.8729 4.76898 8.95335 4.80028 9.03773 4.80962L12.3806 5.30486C12.4774 5.3173 12.5686 5.35703 12.6437 5.41939C12.7188 5.48176 12.7745 5.56419 12.8045 5.65706C12.8344 5.74994 12.8374 5.84942 12.8129 5.94389C12.7884 6.03836 12.7376 6.12392 12.6663 6.19058L10.2568 8.58105C10.1953 8.63851 10.1491 8.71043 10.1225 8.79027C10.0959 8.87011 10.0897 8.95533 10.1044 9.03819L10.6854 12.4001C10.7022 12.4967 10.6915 12.5961 10.6547 12.6869C10.6178 12.7778 10.5562 12.8565 10.4768 12.914C10.3974 12.9716 10.3034 13.0057 10.2056 13.0125C10.1078 13.0193 10.01 12.9985 9.92345 12.9525L6.91392 11.362C6.83686 11.3242 6.75215 11.3045 6.6663 11.3045C6.58045 11.3045 6.49575 11.3242 6.41868 11.362L3.40916 12.9525C3.32258 12.9985 3.22481 13.0193 3.12699 13.0125C3.02918 13.0057 2.93523 12.9716 2.85584 12.914C2.77645 12.8565 2.71482 12.7778 2.67794 12.6869C2.64107 12.5961 2.63043 12.4967 2.64726 12.4001L3.22821 9.0001C3.24293 8.91724 3.2367 8.83201 3.21009 8.75217C3.18348 8.67233 3.13732 8.60041 3.07583 8.54296L0.637732 6.19058C0.565601 6.1221 0.514874 6.03417 0.491697 5.93745C0.46852 5.84072 0.473887 5.73936 0.507148 5.64562C0.540408 5.55189 0.600135 5.46981 0.679094 5.40933C0.758053 5.34885 0.852855 5.31256 0.952017 5.30486L4.29488 4.80962C4.37925 4.80028 4.45971 4.76898 4.52822 4.71885C4.59673 4.66872 4.65091 4.6015 4.68535 4.52391L6.19964 1.46677C6.24087 1.37773 6.30672 1.30234 6.38941 1.24951C6.4721 1.19668 6.56818 1.16861 6.6663 1.16861C6.76443 1.16861 6.86051 1.19668 6.94319 1.24951C7.02588 1.30234 7.09173 1.37773 7.13297 1.46677Z"
          stroke={color || "#363636"}
          strokeWidth="0.952381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_824_3234">
          <rect width="13.3333" height="13.3333" fill="white" transform="translate(0 0.42865)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function HiddenFieldIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M6.66699 9.83365C5.29199 9.83365 4.16699 8.70865 4.16699 7.33365C4.16699 5.95865 5.29199 4.83365 6.66699 4.83365C8.04199 4.83365 9.16699 5.95865 9.16699 7.33365C9.16699 8.70865 8.04199 9.83365 6.66699 9.83365ZM6.66699 5.66698C5.75033 5.66698 5.00033 6.41698 5.00033 7.33365C5.00033 8.25032 5.75033 9.00032 6.66699 9.00032C7.58366 9.00032 8.33366 8.25032 8.33366 7.33365C8.33366 6.41698 7.58366 5.66698 6.66699 5.66698Z"
        fill="#363636"
      />
      <path
        d="M6.66632 11.5003C4.00799 11.5003 1.67465 9.88366 0.857988 7.46699C0.824681 7.38122 0.824681 7.28609 0.857988 7.20033C1.67465 4.79199 4.01632 3.16699 6.66632 3.16699C9.31632 3.16699 11.658 4.78366 12.4747 7.20033C12.508 7.28366 12.508 7.38366 12.4747 7.46699C11.658 9.87533 9.31632 11.5003 6.66632 11.5003ZM1.69132 7.33366C2.43299 9.33366 4.41632 10.667 6.66632 10.667C8.91632 10.667 10.8913 9.33366 11.6413 7.33366C10.8997 5.33366 8.91632 4.00033 6.66632 4.00033C4.41632 4.00033 2.44132 5.33366 1.69132 7.33366Z"
        fill="#363636"
      />
      <path
        d="M11.6667 12.7503C11.612 12.751 11.5578 12.7402 11.5076 12.7187C11.4574 12.6972 11.4122 12.6654 11.375 12.6253L1.375 2.62533C1.20833 2.45866 1.20833 2.20033 1.375 2.03366C1.54167 1.86699 1.8 1.86699 1.96667 2.03366L11.9583 12.042C12.125 12.2087 12.125 12.467 11.9583 12.6337C11.875 12.717 11.7667 12.7587 11.6667 12.7587V12.7503Z"
        fill="#363636"
      />
    </svg>
  );
}
export function ButtonLoadingIcon({
  height = 54,
  color = "#ffffff",
}: {
  height?: number;
  color?: string;
}) {
  return (
    <svg
      version="1.1"
      id="L4"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 150 100"
      enableBackground="new 0 0 0 0"
      xmlSpace="preserve"
      height={height}
    >
      <circle fill={color} stroke="none" cx="16" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill={color} stroke="none" cx="46" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill={color} stroke="none" cx="76" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
      <circle fill={color} stroke="none" cx="106" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.4"
        />
      </circle>
      <circle fill={color} stroke="none" cx="136" cy="50" r="10">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.5"
        />
      </circle>
    </svg>
  );
}
export function MobilePoIcon({ color }: IconProps) {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 0C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0L12 0ZM12.6 15.388H1.4V18C1.4 18.1591 1.46321 18.3117 1.57574 18.4243C1.68826 18.5368 1.84087 18.6 2 18.6H12C12.1591 18.6 12.3117 18.5368 12.4243 18.4243C12.5368 18.3117 12.6 18.1591 12.6 18V15.388ZM7 16C7.26522 16 7.51957 16.1054 7.70711 16.2929C7.89464 16.4804 8 16.7348 8 17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8946 7.26522 18 7 18C6.73478 18 6.48043 17.8946 6.29289 17.7071C6.10536 17.5196 6 17.2652 6 17C6 16.7348 6.10536 16.4804 6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16ZM12 1.4H2C1.84087 1.4 1.68826 1.46321 1.57574 1.57574C1.46321 1.68826 1.4 1.84087 1.4 2V13.988H12.6V2C12.6 1.84087 12.5368 1.68826 12.4243 1.57574C12.3117 1.46321 12.1591 1.4 12 1.4Z"
        fill={color || "#363636"}
      />
    </svg>
  );
}
export function MobileLaIcon() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585787C0.960859 0.210714 1.46957 0 2 0L18 0C18.5304 0 19.0391 0.210714 19.4142 0.585787C19.7893 0.960859 20 1.46957 20 2V12C20 12.5304 19.7893 13.0391 19.4142 13.4142C19.0391 13.7893 18.5304 14 18 14L2 14C1.46957 14 0.960859 13.7893 0.585786 13.4142C0.210714 13.0391 0 12.5304 0 12L0 2ZM15.388 1.4V12.6L18 12.6C18.1591 12.6 18.3117 12.5368 18.4243 12.4243C18.5368 12.3117 18.6 12.1591 18.6 12V2C18.6 1.84087 18.5368 1.68826 18.4243 1.57574C18.3117 1.46321 18.1591 1.4 18 1.4H15.388ZM16 7C16 6.73478 16.1054 6.48043 16.2929 6.29289C16.4804 6.10536 16.7348 6 17 6C17.2652 6 17.5196 6.10536 17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7C18 7.26522 17.8946 7.51957 17.7071 7.70711C17.5196 7.89464 17.2652 8 17 8C16.7348 8 16.4804 7.89464 16.2929 7.70711C16.1054 7.51957 16 7.26522 16 7ZM1.4 2L1.4 12C1.4 12.1591 1.46321 12.3117 1.57574 12.4243C1.68826 12.5368 1.84087 12.6 2 12.6H13.988V1.4H2C1.84087 1.4 1.68826 1.46321 1.57574 1.57574C1.46321 1.68826 1.4 1.84087 1.4 2Z"
        fill="#363636"
      />
    </svg>
  );
}
export function IpadPoIcon() {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 15.3337H11M2.33333 19.3337H15.6667C16.0203 19.3337 16.3594 19.1932 16.6095 18.9431C16.8595 18.6931 17 18.3539 17 18.0003V2.00033C17 1.6467 16.8595 1.30757 16.6095 1.05752C16.3594 0.807468 16.0203 0.666992 15.6667 0.666992H2.33333C1.97971 0.666992 1.64057 0.807468 1.39052 1.05752C1.14048 1.30757 1 1.6467 1 2.00033V18.0003C1 18.3539 1.14048 18.6931 1.39052 18.9431C1.64057 19.1932 1.97971 19.3337 2.33333 19.3337Z"
        stroke="#363636"
        strokeWidth="1.33333"
      />
    </svg>
  );
}
export function IpadLaIcon() {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3333 11.0003V7.00033M19.3333 15.667V2.33366C19.3333 1.98004 19.1929 1.6409 18.9428 1.39085C18.6928 1.1408 18.3536 1.00033 18 1.00033H2C1.64638 1.00033 1.30724 1.1408 1.05719 1.39085C0.807142 1.6409 0.666666 1.98004 0.666666 2.33366L0.666666 15.667C0.666666 16.0206 0.807142 16.3598 1.05719 16.6098C1.30724 16.8599 1.64638 17.0003 2 17.0003H18C18.3536 17.0003 18.6928 16.8599 18.9428 16.6098C19.1929 16.3598 19.3333 16.0206 19.3333 15.667Z"
        stroke="#363636"
        strokeWidth="1.33333"
      />
    </svg>
  );
}
export function DesktopIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 0.5C2.33696 0.5 1.70107 0.763392 1.23223 1.23223C0.763392 1.70107 0.5 2.33696 0.5 3V10.4963C0.5 11.1593 0.763392 11.7952 1.23223 12.264C1.70107 12.7329 2.33696 12.9963 3 12.9963H5.50625V14.26H3.6325C3.46674 14.26 3.30777 14.3258 3.19056 14.4431C3.07335 14.5603 3.0075 14.7192 3.0075 14.885C3.0075 15.0508 3.07335 15.2097 3.19056 15.3269C3.30777 15.4442 3.46674 15.51 3.6325 15.51H12.3775C12.5433 15.51 12.7022 15.4442 12.8194 15.3269C12.9367 15.2097 13.0025 15.0508 13.0025 14.885C13.0025 14.7192 12.9367 14.5603 12.8194 14.4431C12.7022 14.3258 12.5433 14.26 12.3775 14.26H10.5025V12.9975H13C13.663 12.9975 14.2989 12.7341 14.7678 12.2653C15.2366 11.7964 15.5 11.1605 15.5 10.4975V3C15.5 2.33696 15.2366 1.70107 14.7678 1.23223C14.2989 0.763392 13.663 0.5 13 0.5H3ZM9.25375 12.9963V14.26H6.75625V12.9975H9.25375V12.9963ZM1.75 3C1.75 2.66848 1.8817 2.35054 2.11612 2.11612C2.35054 1.8817 2.66848 1.75 3 1.75H13C13.3315 1.75 13.6495 1.8817 13.8839 2.11612C14.1183 2.35054 14.25 2.66848 14.25 3V10.4963C14.25 10.8278 14.1183 11.1457 13.8839 11.3801C13.6495 11.6146 13.3315 11.7463 13 11.7463H3C2.66848 11.7463 2.35054 11.6146 2.11612 11.3801C1.8817 11.1457 1.75 10.8278 1.75 10.4963V3Z"
        fill="#363636"
      />
    </svg>
  );
}
export function MinusIcon({ color = "#ffffff", size = "18" }: { color?: string; size?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.70163 0.118526 1.41548 0.329505 1.20451C0.540483 0.993527 0.826631 0.875 1.125 0.875H16.875C17.1734 0.875 17.4595 0.993527 17.6705 1.20451C17.8815 1.41548 18 1.70163 18 2C18 2.29837 17.8815 2.58452 17.6705 2.79549C17.4595 3.00647 17.1734 3.125 16.875 3.125H1.125C0.826631 3.125 0.540483 3.00647 0.329505 2.79549C0.118526 2.58452 0 2.29837 0 2Z"
        fill={color ? color : "#363636"}
      />
    </svg>
  );
}
export function MoveIcon({ color, size = 24 }: { color?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21V3M12 21L15 18M12 21L9 18M12 3L9 6M12 3L15 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FileIcon({ size = "48px" }: { size: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g opacity="0.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.23869 2 10.0298 2C10.6358 2 11.1214 2 11.53 2.01666C11.5166 2.09659 11.5095 2.17813 11.5092 2.26057L11.5 5.09497C11.4999 6.19207 11.4998 7.16164 11.6049 7.94316C11.7188 8.79028 11.9803 9.63726 12.6716 10.3285C13.3628 11.0198 14.2098 11.2813 15.0569 11.3952C15.8385 11.5003 16.808 11.5002 17.9051 11.5001L18 11.5001H21.9574C22 12.0344 22 12.6901 22 13.5629V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22Z"
            fill="#229fbf"
          ></path>
        </g>
        <path
          d="M11.5092 2.2601L11.5 5.0945C11.4999 6.1916 11.4998 7.16117 11.6049 7.94269C11.7188 8.78981 11.9803 9.6368 12.6716 10.3281C13.3629 11.0193 14.2098 11.2808 15.057 11.3947C15.8385 11.4998 16.808 11.4997 17.9051 11.4996L21.9574 11.4996C21.9698 11.6552 21.9786 11.821 21.9848 11.9995H22C22 11.732 22 11.5983 21.9901 11.4408C21.9335 10.5463 21.5617 9.52125 21.0315 8.79853C20.9382 8.6713 20.8743 8.59493 20.7467 8.44218C19.9542 7.49359 18.911 6.31193 18 5.49953C17.1892 4.77645 16.0787 3.98536 15.1101 3.3385C14.2781 2.78275 13.862 2.50487 13.2915 2.29834C13.1403 2.24359 12.9408 2.18311 12.7846 2.14466C12.4006 2.05013 12.0268 2.01725 11.5 2.00586L11.5092 2.2601Z"
          fill="#229fbf"
        ></path>
      </g>
    </svg>
  );
}
export function FileImageIcon({ size = "48px" }: { size: string }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4C6 1.79086 7.79086 0 10 0H29C36.1797 0 42 5.8203 42 13V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V4Z"
        fill="#D08A04"
      />
      <path
        d="M29 0V0C36.1797 0 42 5.8203 42 13V17H35C31.6863 17 29 14.3137 29 11V0Z"
        fill="#6F4900"
      />
      <path
        d="M6 37H42V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V37Z"
        fill="#6F4900"
      />
      <path d="M12 17.5H28" stroke="#6F4900" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 23.5H32" stroke="#6F4900" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 29.5H28" stroke="#6F4900" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M16.5327 40.49V44H15.6777V40.49H16.5327ZM21.1273 40.49V44H20.2723V41.895L19.4873 44H18.7973L18.0073 41.89V44H17.1523V40.49H18.1623L19.1473 42.92L20.1223 40.49H21.1273ZM23.9271 43.38H22.6171L22.4071 44H21.5121L22.7821 40.49H23.7721L25.0421 44H24.1371L23.9271 43.38ZM23.7071 42.72L23.2721 41.435L22.8421 42.72H23.7071ZM27.7587 41.6C27.6953 41.4833 27.6037 41.395 27.4837 41.335C27.367 41.2717 27.2287 41.24 27.0687 41.24C26.792 41.24 26.5703 41.3317 26.4037 41.515C26.237 41.695 26.1537 41.9367 26.1537 42.24C26.1537 42.5633 26.2403 42.8167 26.4137 43C26.5903 43.18 26.832 43.27 27.1387 43.27C27.3487 43.27 27.5253 43.2167 27.6687 43.11C27.8153 43.0033 27.922 42.85 27.9887 42.65H26.9037V42.02H28.7637V42.815C28.7003 43.0283 28.592 43.2267 28.4387 43.41C28.2887 43.5933 28.097 43.7417 27.8637 43.855C27.6303 43.9683 27.367 44.025 27.0737 44.025C26.727 44.025 26.417 43.95 26.1437 43.8C25.8737 43.6467 25.662 43.435 25.5087 43.165C25.3587 42.895 25.2837 42.5867 25.2837 42.24C25.2837 41.8933 25.3587 41.585 25.5087 41.315C25.662 41.0417 25.8737 40.83 26.1437 40.68C26.4137 40.5267 26.722 40.45 27.0687 40.45C27.4887 40.45 27.842 40.5517 28.1287 40.755C28.4187 40.9583 28.6103 41.24 28.7037 41.6H27.7587ZM30.0922 41.175V41.885H31.2372V42.545H30.0922V43.315H31.3872V44H29.2372V40.49H31.3872V41.175H30.0922Z"
        fill="white"
      />
    </svg>
  );
}
export function FileExcelIcon({ size = "48px" }: { size: string }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4C6 1.79086 7.79086 0 10 0H29C36.1797 0 42 5.8203 42 13V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V4Z"
        fill="#0E7841"
      />
      <path
        d="M6 37H42V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V37Z"
        fill="#185835"
      />
      <path
        d="M29 0V0C36.1797 0 42 5.8203 42 13V17H35C31.6863 17 29 14.3137 29 11V0Z"
        fill="#185835"
      />
      <path d="M12 17.5H28" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 23.5H32" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 29.5H28" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M17.0771 41.175V41.885H18.2221V42.545H17.0771V43.315H18.3721V44H16.2221V40.49H18.3721V41.175H17.0771ZM21.0772 44L20.3622 42.925L19.7322 44H18.7622L19.8872 42.215L18.7372 40.49H19.7322L20.4372 41.55L21.0572 40.49H22.0272L20.9122 42.26L22.0722 44H21.0772ZM22.3564 42.24C22.3564 41.8933 22.4314 41.585 22.5814 41.315C22.7314 41.0417 22.9397 40.83 23.2064 40.68C23.4764 40.5267 23.7814 40.45 24.1214 40.45C24.5381 40.45 24.8947 40.56 25.1914 40.78C25.4881 41 25.6864 41.3 25.7864 41.68H24.8464C24.7764 41.5333 24.6764 41.4217 24.5464 41.345C24.4197 41.2683 24.2747 41.23 24.1114 41.23C23.8481 41.23 23.6347 41.3217 23.4714 41.505C23.3081 41.6883 23.2264 41.9333 23.2264 42.24C23.2264 42.5467 23.3081 42.7917 23.4714 42.975C23.6347 43.1583 23.8481 43.25 24.1114 43.25C24.2747 43.25 24.4197 43.2117 24.5464 43.135C24.6764 43.0583 24.7764 42.9467 24.8464 42.8H25.7864C25.6864 43.18 25.4881 43.48 25.1914 43.7C24.8947 43.9167 24.5381 44.025 24.1214 44.025C23.7814 44.025 23.4764 43.95 23.2064 43.8C22.9397 43.6467 22.7314 43.435 22.5814 43.165C22.4314 42.895 22.3564 42.5867 22.3564 42.24ZM27.165 41.175V41.885H28.31V42.545H27.165V43.315H28.46V44H26.31V40.49H28.46V41.175H27.165ZM29.8701 43.34H30.9901V44H29.0151V40.49H29.8701V43.34Z"
        fill="white"
      />
    </svg>
  );
}
export function FileDocIcon({ size = "48px" }: { size: string }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4C6 1.79086 7.79086 0 10 0H29C36.1797 0 42 5.8203 42 13V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V4Z"
        fill="#0082F1"
      />
      <path
        d="M6 37H42V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V37Z"
        fill="#00033E"
      />
      <path
        d="M29 0V0C36.1797 0 42 5.8203 42 13V17H35C31.6863 17 29 14.3137 29 11V0Z"
        fill="#00033E"
      />
      <path d="M12 17.5H28" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 23.5H32" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 29.5H28" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M19.439 40.49C19.809 40.49 20.1323 40.5633 20.409 40.71C20.6856 40.8567 20.899 41.0633 21.049 41.33C21.2023 41.5933 21.279 41.8983 21.279 42.245C21.279 42.5883 21.2023 42.8933 21.049 43.16C20.899 43.4267 20.684 43.6333 20.404 43.78C20.1273 43.9267 19.8056 44 19.439 44H18.124V40.49H19.439ZM19.384 43.26C19.7073 43.26 19.959 43.1717 20.139 42.995C20.319 42.8183 20.409 42.5683 20.409 42.245C20.409 41.9217 20.319 41.67 20.139 41.49C19.959 41.31 19.7073 41.22 19.384 41.22H18.979V43.26H19.384ZM23.4168 44.035C23.0868 44.035 22.7834 43.9583 22.5068 43.805C22.2334 43.6517 22.0151 43.4383 21.8518 43.165C21.6918 42.8883 21.6118 42.5783 21.6118 42.235C21.6118 41.8917 21.6918 41.5833 21.8518 41.31C22.0151 41.0367 22.2334 40.8233 22.5068 40.67C22.7834 40.5167 23.0868 40.44 23.4168 40.44C23.7468 40.44 24.0484 40.5167 24.3218 40.67C24.5984 40.8233 24.8151 41.0367 24.9718 41.31C25.1318 41.5833 25.2118 41.8917 25.2118 42.235C25.2118 42.5783 25.1318 42.8883 24.9718 43.165C24.8118 43.4383 24.5951 43.6517 24.3218 43.805C24.0484 43.9583 23.7468 44.035 23.4168 44.035ZM23.4168 43.255C23.6968 43.255 23.9201 43.1617 24.0868 42.975C24.2568 42.7883 24.3418 42.5417 24.3418 42.235C24.3418 41.925 24.2568 41.6783 24.0868 41.495C23.9201 41.3083 23.6968 41.215 23.4168 41.215C23.1334 41.215 22.9068 41.3067 22.7368 41.49C22.5701 41.6733 22.4868 41.9217 22.4868 42.235C22.4868 42.545 22.5701 42.7933 22.7368 42.98C22.9068 43.1633 23.1334 43.255 23.4168 43.255ZM25.5424 42.24C25.5424 41.8933 25.6174 41.585 25.7674 41.315C25.9174 41.0417 26.1258 40.83 26.3924 40.68C26.6624 40.5267 26.9674 40.45 27.3074 40.45C27.7241 40.45 28.0808 40.56 28.3774 40.78C28.6741 41 28.8724 41.3 28.9724 41.68H28.0324C27.9624 41.5333 27.8624 41.4217 27.7324 41.345C27.6058 41.2683 27.4608 41.23 27.2974 41.23C27.0341 41.23 26.8208 41.3217 26.6574 41.505C26.4941 41.6883 26.4124 41.9333 26.4124 42.24C26.4124 42.5467 26.4941 42.7917 26.6574 42.975C26.8208 43.1583 27.0341 43.25 27.2974 43.25C27.4608 43.25 27.6058 43.2117 27.7324 43.135C27.8624 43.0583 27.9624 42.9467 28.0324 42.8H28.9724C28.8724 43.18 28.6741 43.48 28.3774 43.7C28.0808 43.9167 27.7241 44.025 27.3074 44.025C26.9674 44.025 26.6624 43.95 26.3924 43.8C26.1258 43.6467 25.9174 43.435 25.7674 43.165C25.6174 42.895 25.5424 42.5867 25.5424 42.24Z"
        fill="white"
      />
    </svg>
  );
}
export function FilePDFIcon({ size = "48px" }: { size: string }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.5H29C35.9036 0.5 41.5 6.09644 41.5 13V44C41.5 45.933 39.933 47.5 38 47.5H10C8.067 47.5 6.5 45.933 6.5 44V4C6.5 2.067 8.067 0.5 10 0.5Z"
        stroke="#F70000"
      />
      <path
        d="M6 37H42V44C42 46.2091 40.2091 48 38 48H10C7.79086 48 6 46.2091 6 44V37Z"
        fill="#F70000"
      />
      <path
        d="M29 0V0C36.1797 0 42 5.8203 42 13V17H35C31.6863 17 29 14.3137 29 11V0Z"
        fill="#F70000"
      />
      <path d="M12 17.5H28" stroke="#F70000" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 23.5H32" stroke="#F70000" strokeWidth="3" strokeLinecap="round" />
      <path d="M12 29.5H28" stroke="#F70000" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M21.7413 41.62C21.7413 41.8233 21.6947 42.01 21.6013 42.18C21.508 42.3467 21.3647 42.4817 21.1713 42.585C20.978 42.6883 20.738 42.74 20.4513 42.74H19.9213V44H19.0663V40.49H20.4513C20.7313 40.49 20.968 40.5383 21.1613 40.635C21.3547 40.7317 21.4997 40.865 21.5963 41.035C21.693 41.205 21.7413 41.4 21.7413 41.62ZM20.3863 42.06C20.5497 42.06 20.6713 42.0217 20.7513 41.945C20.8313 41.8683 20.8713 41.76 20.8713 41.62C20.8713 41.48 20.8313 41.3717 20.7513 41.295C20.6713 41.2183 20.5497 41.18 20.3863 41.18H19.9213V42.06H20.3863ZM23.5015 40.49C23.8715 40.49 24.1948 40.5633 24.4715 40.71C24.7481 40.8567 24.9615 41.0633 25.1115 41.33C25.2648 41.5933 25.3415 41.8983 25.3415 42.245C25.3415 42.5883 25.2648 42.8933 25.1115 43.16C24.9615 43.4267 24.7465 43.6333 24.4665 43.78C24.1898 43.9267 23.8681 44 23.5015 44H22.1865V40.49H23.5015ZM23.4465 43.26C23.7698 43.26 24.0215 43.1717 24.2015 42.995C24.3815 42.8183 24.4715 42.5683 24.4715 42.245C24.4715 41.9217 24.3815 41.67 24.2015 41.49C24.0215 41.31 23.7698 41.22 23.4465 41.22H23.0415V43.26H23.4465ZM28.1043 40.49V41.175H26.6743V41.915H27.7443V42.58H26.6743V44H25.8193V40.49H28.1043Z"
        fill="white"
      />
    </svg>
  );
}
export function MultiSelectIcon({ size = "19px", color }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 0.5C0.551088 0.5 0.360322 0.579018 0.21967 0.71967C0.0790175 0.860322 0 1.05109 0 1.25C0 1.44891 0.0790175 1.63968 0.21967 1.78033C0.360322 1.92098 0.551088 2 0.75 2H10.75C10.9489 2 11.1397 1.92098 11.2803 1.78033C11.421 1.63968 11.5 1.44891 11.5 1.25C11.5 1.05109 11.421 0.860322 11.2803 0.71967C11.1397 0.579018 10.9489 0.5 10.75 0.5H0.75ZM5.75 6.5C5.55109 6.5 5.36032 6.57902 5.21967 6.71967C5.07902 6.86032 5 7.05109 5 7.25C5 7.44891 5.07902 7.63968 5.21967 7.78033C5.36032 7.92098 5.55109 8 5.75 8H17.25C17.4489 8 17.6397 7.92098 17.7803 7.78033C17.921 7.63968 18 7.44891 18 7.25C18 7.05109 17.921 6.86032 17.7803 6.71967C17.6397 6.57902 17.4489 6.5 17.25 6.5H5.75ZM5.75 12.5C5.55109 12.5 5.36032 12.579 5.21967 12.7197C5.07902 12.8603 5 13.0511 5 13.25C5 13.4489 5.07902 13.6397 5.21967 13.7803C5.36032 13.921 5.55109 14 5.75 14H17.25C17.4489 14 17.6397 13.921 17.7803 13.7803C17.921 13.6397 18 13.4489 18 13.25C18 13.0511 17.921 12.8603 17.7803 12.7197C17.6397 12.579 17.4489 12.5 17.25 12.5H5.75ZM2 7C2 7.26522 1.89464 7.51957 1.70711 7.70711C1.51957 7.89464 1.26522 8 1 8C0.734784 8 0.48043 7.89464 0.292893 7.70711C0.105357 7.51957 0 7.26522 0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289C0.48043 6.10536 0.734784 6 1 6C1.26522 6 1.51957 6.10536 1.70711 6.29289C1.89464 6.48043 2 6.73478 2 7ZM1 14C1.26522 14 1.51957 13.8946 1.70711 13.7071C1.89464 13.5196 2 13.2652 2 13C2 12.7348 1.89464 12.4804 1.70711 12.2929C1.51957 12.1054 1.26522 12 1 12C0.734784 12 0.48043 12.1054 0.292893 12.2929C0.105357 12.4804 0 12.7348 0 13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14Z"
        fill={color || "black"}
      />
      <path
        d="M16.309 2.918L14.064 0.417C14.0317 0.38106 14.0106 0.336546 14.0031 0.288837C13.9956 0.241128 14.002 0.192267 14.0217 0.14816C14.0414 0.104054 14.0734 0.06659 14.1139 0.040297C14.1544 0.014004 14.2017 7.78815e-06 14.25 0H18.74C18.7882 0.000200244 18.8353 0.0143358 18.8757 0.0407038C18.9161 0.0670718 18.9479 0.104547 18.9675 0.148616C18.987 0.192684 18.9934 0.241466 18.9859 0.289083C18.9784 0.336701 18.9572 0.381124 18.925 0.417L16.681 2.917C16.6576 2.94311 16.6289 2.96398 16.5968 2.97828C16.5648 2.99257 16.5301 2.99996 16.495 2.99996C16.4599 2.99996 16.4252 2.99257 16.3932 2.97828C16.3611 2.96398 16.3324 2.94311 16.309 2.917V2.918Z"
        fill={color || "black"}
      />
    </svg>
  );
}
export function PlayIcon({ size }: { size?: string }) {
  return (
    <svg
      width={size || "21"}
      height={size || "22"}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4086 8.35258C20.5305 9.5065 20.5305 12.4935 18.4086 13.6474L5.59662 20.6145C3.53435 21.736 1 20.2763 1 17.9671V4.0329C1 1.72368 3.53435 0.26402 5.59661 1.38548L18.4086 8.35258Z"
        stroke="#1C274C"
        strokeWidth="1.5"
      />
    </svg>
  );
}
export function PublishIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12_5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.14286C0 2.30254 2.30253 -3.41982e-06 5.14286 -3.41982e-06H12C12.9468 -3.41982e-06 13.7142 -0.23249 13.7142 0.714291C13.7142 1.66105 12.9468 1.42858 12 1.42858H5.14286C3.5 1.42858 1.42858 2.5 1.42858 5.14286V18.8573C1.42858 22 4.19609 22.5715 5.14286 22.5715H18.8571C23.2858 22.6664 22.5714 20.5715 22.5714 18.8573C22.5714 17.9105 22.339 17.1429 23.2858 17.1429C24.2326 17.1429 24 17.9105 24 18.8573V20.5715C24 22.4651 22.4649 24 20.5714 24H5.14286C2.30253 24 0 21.6975 0 18.8573V5.14286Z"
          fill="#333333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7893 1.09081C15.0466 0.937609 15.352 0.980684 15.5748 1.20162L23.7214 9.27691C23.8975 9.45134 24 9.71576 24 9.99527C24 10.2748 23.8975 10.539 23.7214 10.7136L15.5748 18.7889C15.352 19.0099 15.0466 19.0529 14.7893 18.8997C14.5321 18.7466 14.3685 18.4242 14.3685 18.0705V13.9435H13.2213C10.4168 13.9435 7.85313 15.9068 6.59896 19.0147L6.40664 19.4912C6.25265 19.8729 5.90708 20.0733 5.57192 19.9754C5.23678 19.8773 5 19.5065 5 19.0798V16.701C5 10.817 8.84964 6.04702 13.5983 6.04702H14.3685V1.92003C14.3685 1.56637 14.5321 1.24401 14.7893 1.09081ZM15.8535 3.83426V6.96705C15.8535 7.47516 15.521 7.88708 15.111 7.88708H13.5983C9.89109 7.88708 6.8461 11.4013 6.5149 15.8879C8.17971 13.5169 10.6139 12.1034 13.2213 12.1034H15.111C15.521 12.1034 15.8535 12.5154 15.8535 13.0234V16.1563L22.0689 9.99527L15.8535 3.83426Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_12_5">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ShareIcon() {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3636 4C12.3636 1.79086 14.1626 0 16.3818 0C18.601 0 20.4 1.79086 20.4 4C20.4 6.20914 18.601 8 16.3818 8C15.2612 8 14.2486 7.54315 13.5205 6.80816L7.95804 10.5954C8.0094 10.851 8.0364 11.115 8.0364 11.3846C8.0364 11.9186 7.9308 12.4291 7.73951 12.8957L13.8388 16.903C14.531 16.3393 15.4168 16 16.3818 16C18.601 16 20.4 17.7908 20.4 20C20.4 22.2091 18.601 24 16.3818 24C14.1626 24 12.3636 22.2091 12.3636 20C12.3636 19.4214 12.4874 18.8706 12.71 18.3733L6.66008 14.3984C5.95435 15.0118 5.02992 15.3846 4.01818 15.3846C1.799 15.3846 0 13.5937 0 11.3846C0 9.17548 1.799 7.38462 4.01818 7.38462C5.29428 7.38462 6.43024 7.9767 7.16574 8.89822L12.5567 5.2277C12.4313 4.84031 12.3636 4.42752 12.3636 4Z"
        fill="#1C274C"
      />
    </svg>
  );
}
export function CheckFillIcon({
  color = "#000000",
  size = "20",
}: {
  color?: string;
  size?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 1.33989C16.5083 2.21075 17.7629 3.46042 18.6398 4.96519C19.5167 6.46997 19.9854 8.17766 19.9994 9.91923C20.0135 11.6608 19.5725 13.3758 18.72 14.8946C17.8676 16.4133 16.6332 17.6831 15.1392 18.5782C13.6452 19.4733 11.9434 19.9627 10.2021 19.998C8.46083 20.0332 6.74055 19.6131 5.21155 18.7791C3.68256 17.9452 2.39787 16.7264 1.48467 15.2434C0.571462 13.7604 0.0614093 12.0646 0.00500011 10.3239L0 9.99989L0.00500011 9.67589C0.0610032 7.94888 0.563548 6.26585 1.46364 4.79089C2.36373 3.31592 3.63065 2.09934 5.14089 1.25977C6.65113 0.420205 8.35315 -0.0137108 10.081 0.000330246C11.8089 0.0143713 13.5036 0.47589 15 1.33989ZM13.707 7.29289C13.5348 7.12072 13.3057 7.01729 13.0627 7.002C12.8197 6.98672 12.5794 7.06064 12.387 7.20989L12.293 7.29289L9 10.5849L7.707 9.29289L7.613 9.20989C7.42058 9.06075 7.18037 8.98692 6.9374 9.00225C6.69444 9.01757 6.46541 9.12101 6.29326 9.29315C6.12112 9.4653 6.01768 9.69433 6.00235 9.9373C5.98702 10.1803 6.06086 10.4205 6.21 10.6129L6.293 10.7069L8.293 12.7069L8.387 12.7899C8.56237 12.926 8.77803 12.9998 9 12.9998C9.22197 12.9998 9.43763 12.926 9.613 12.7899L9.707 12.7069L13.707 8.70689L13.79 8.61289C13.9393 8.42049 14.0132 8.18024 13.9979 7.93721C13.9826 7.69419 13.8792 7.46509 13.707 7.29289Z"
        fill={color}
      />
    </svg>
  );
}
export const CheckIcon = ({
  size = "24",
  color = "#292D32",
}: {
  size?: string;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8L7.65882 15L21 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export function RemoveFillIcon({
  color = "#000000",
  size = "16",
}: {
  color?: string;
  size?: string;
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
      <path
        fill={color}
        d="M2.93 17.07A10 10 0 1 1 17.07 2.93A10 10 0 0 1 2.93 17.07M11.4 10l2.83-2.83l-1.41-1.41L10 8.59L7.17 5.76L5.76 7.17L8.59 10l-2.83 2.83l1.41 1.41L10 11.41l2.83 2.83l1.41-1.41L11.41 10z"
      />
    </svg>
  );
}

export function StarIcon({ color = "#ED8A19", size = "20px" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      version="1.1"
      id="Capa_1"
      viewBox="0 0 47.94 47.94"
    >
      <path
        fill={color}
        d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757  c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042  c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685  c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528  c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956  C22.602,0.567,25.338,0.567,26.285,2.486z"
      />
    </svg>
  );
}
export function MarketplaceIcon({ color = "#ED8A19", size = "20px" }) {
  return (
    <svg
      fill={color}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g data-name="20 market" id="_20_market">
          <path d="M19.52,31H12.64a1,1,0,0,0-1,1v6.88a1,1,0,0,0,1,1h6.88a1,1,0,0,0,1-1V32A1,1,0,0,0,19.52,31Zm-1,6.88H13.64V33h4.88Z"></path>{" "}
          <path d="M53.07,50.83C55.43,46.97,58,41.92,58,39.04a10.006,10.006,0,0,0-9.98-10V20.21c0-.01-.01-.02-.01-.04a.829.829,0,0,0-.07-.34v-.01l-3.79-9.24a2.045,2.045,0,0,0-1.91-1.19h-.11V4.5a1,1,0,0,0-1-1H27.38a1,1,0,0,0-1,1V9.39H12.51a2.055,2.055,0,0,0-1.91,1.19L6.81,19.82v.01a1.032,1.032,0,0,0-.07.34c0,.02-.01.03-.01.04V50.64a1.987,1.987,0,0,0-1.96,1.98v4.92a1.985,1.985,0,0,0,1.98,1.98H41.24A22.813,22.813,0,0,0,48,60.5c5.45,0,11.23-1.78,11.23-5.09C59.23,53.35,56.91,51.65,53.07,50.83ZM48,31.04a8.011,8.011,0,0,1,8,8c0,2.58-2.88,8.09-5.39,11.99a.01.01,0,0,0-.01.01c-.77,1.19-1.5,2.24-2.1,3a.641.641,0,0,1-1,0c-.6-.76-1.33-1.81-2.1-3v-.01c-2.51-3.9-5.4-9.41-5.4-11.99A8.011,8.011,0,0,1,48,31.04Zm-9.93,6.84H36.23V33h3.82A9.915,9.915,0,0,0,38.07,37.88Zm7.95-13.7a2.9,2.9,0,0,1-2.9,2.89h-.06a2.9,2.9,0,0,1-2.9-2.89V21.21h5.86ZM42.24,11.39c.04,0,.07.01.07-.01l3.22,7.83H39.91l-2.35-7.82ZM32.3,21.21h5.86v2.97a2.9,2.9,0,0,1-2.89,2.89H35.2a2.9,2.9,0,0,1-2.9-2.89Zm-.09-2-.78-7.82h4.04l2.35,7.82ZM28.38,5.5H40.13V9.39H28.38Zm-3.05,5.89h4.09l.78,7.82H24.55Zm-.88,9.82H30.3v2.97a2.891,2.891,0,0,1-2.89,2.89h-.07a2.9,2.9,0,0,1-2.89-2.89Zm-1.13-9.82-.78,7.82H16.93l2.35-7.82Zm-.87,9.82v2.97a2.9,2.9,0,0,1-2.9,2.89h-.07a2.9,2.9,0,0,1-2.89-2.89V21.21ZM12.4,11.42a.178.178,0,0,1,.11-.03h4.68l-2.34,7.82H9.22ZM8.73,21.21h5.86v2.97a2.9,2.9,0,0,1-2.89,2.89h-.07a2.9,2.9,0,0,1-2.9-2.89Zm0,6.89a4.883,4.883,0,0,0,2.9.97h.07a4.876,4.876,0,0,0,3.89-1.96,4.876,4.876,0,0,0,3.89,1.96h.07a4.9,4.9,0,0,0,3.9-1.96,4.876,4.876,0,0,0,3.89,1.96h.07a4.862,4.862,0,0,0,3.89-1.96,4.9,4.9,0,0,0,3.9,1.96h.07a4.876,4.876,0,0,0,3.89-1.96,4.9,4.9,0,0,0,3.9,1.96h.06a4.86,4.86,0,0,0,2.9-.97v1.13A10.115,10.115,0,0,0,42.07,31H35.23a1,1,0,0,0-1,1v6.88a1,1,0,0,0,1,1h2.83c.4,2.9,2.64,7.28,4.75,10.76H32.3V41.79a4.925,4.925,0,0,0-9.85,0v8.85H8.73ZM30.3,41.79v8.85H24.45V41.79a2.925,2.925,0,0,1,5.85,0Zm6.47,13.62a3.056,3.056,0,0,0,.92,2.11l-30.92.02-.02-4.9H38.43A3.5,3.5,0,0,0,36.77,55.41ZM48,58.5c-5.63,0-9.23-1.83-9.23-3.09,0-.8,1.67-2.12,5.31-2.76.72,1.1,1.38,2.02,1.86,2.63a2.622,2.622,0,0,0,4.12,0c.48-.61,1.14-1.53,1.86-2.63,3.64.64,5.31,1.96,5.31,2.76C57.23,56.67,53.64,58.5,48,58.5Z"></path>{" "}
          <path d="M48,33.95a5.09,5.09,0,1,0,5.09,5.09A5.091,5.091,0,0,0,48,33.95Zm0,8.18a3.09,3.09,0,1,1,3.09-3.09A3.1,3.1,0,0,1,48,42.13Z"></path>{" "}
        </g>
      </g>
    </svg>
  );
}
export function EntityIcon({ color = "#292D32" }: { color?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 9C4.10457 9 5 8.10457 5 7C5 5.89543 4.10457 5 3 5C1.89543 5 1 5.89543 1 7C1 8.10457 1.89543 9 3 9Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 9C22.1046 9 23 8.10457 23 7C23 5.89543 22.1046 5 21 5C19.8954 5 19 5.89543 19 7C19 8.10457 19.8954 9 21 9Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 7H15"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7H5"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 16.5V18.5C7.5 19.11 7.13 19.64 6.61 19.86C6.42 19.95 6.22 20 6 20H4C3.17 20 2.5 19.33 2.5 18.5V16.5C2.5 15.67 3.17 15 4 15H6C6.83 15 7.5 15.67 7.5 16.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 16.5V18.5C21.5 19.33 20.83 20 20 20H18C17.78 20 17.58 19.95 17.39 19.86C16.87 19.64 16.5 19.11 16.5 18.5V16.5C16.5 15.67 17.17 15 18 15H20C20.83 15 21.5 15.67 21.5 16.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.5V8.5C15 9.32 14.32 10 13.5 10H10.5C9.68 10 9 9.32 9 8.5V5.5C9 4.68 9.68 4 10.5 4H13.5C14.32 4 15 4.68 15 5.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.72998C17.37 8.92998 19 11.51 19 14.5C19 14.67 18.99 14.83 18.97 15"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.03 15C5.01 14.83 5 14.67 5 14.5C5 11.51 6.63 8.92998 9 7.72998"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TextBlockIcon({ color = "#292D32" }: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 4.5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 19.5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 8.43V5.57C9.5 4.45 9.05 4 7.92 4H5.07C3.95 4 3.5 4.45 3.5 5.57V8.42C3.5 9.55 3.95 10 5.07 10H7.92C9.05 10 9.5 9.55 9.5 8.43Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RankingIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 22H22"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 4V22H14.25V4C14.25 2.9 13.8 2 12.45 2H11.55C10.2 2 9.75 2.9 9.75 4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10V22H7V10C7 8.9 6.6 8 5.4 8H4.6C3.4 8 3 8.9 3 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15V22H21V15C21 13.9 20.6 13 19.4 13H18.6C17.4 13 17 13.9 17 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RichTextIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00002 13C8.34002 13.33 7.79002 13.82 7.38002 14.43C7.15002 14.78 7.15002 15.22 7.38002 15.57C7.79002 16.18 8.34002 16.67 9.00002 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.21 13C15.87 13.33 16.42 13.82 16.83 14.43C17.06 14.78 17.06 15.22 16.83 15.57C16.42 16.18 15.87 16.67 15.21 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.22998 8.01L21.45 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SignatureIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3837 3.21284L2.92731 15.6664C2.43468 16.1589 1.97717 17.0736 1.87161 17.742L1.20303 22.4912C0.956717 24.215 2.15314 25.4112 3.87734 25.1649L8.62773 24.4965C9.2963 24.3909 10.2464 23.9335 10.7038 23.441L23.1603 10.9876C25.3068 8.84163 26.3272 6.34388 23.1603 3.17773C20.0286 0.0467613 17.5302 1.06689 15.3837 3.21284Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5898 5.00708C14.6455 8.80646 17.6013 11.7615 21.4016 12.8169"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TimeIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.71 15.18L12.61 13.33C12.07 13.01 11.63 12.24 11.63 11.61V7.51001"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SliderIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12H7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 12H22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function YesNoIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4H14C18.42 4 22 7.58 22 12C22 16.42 18.42 20 14 20H10C5.58 20 2 16.42 2 12C2 7.58 5.58 4 10 4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16C12.2091 16 14 14.2091 14 12C14 9.79086 12.2091 8 10 8C7.79086 8 6 9.79086 6 12C6 14.2091 7.79086 16 10 16Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LinkIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0601 10.9399C15.3101 13.1899 15.3101 16.8299 13.0601 19.0699C10.8101 21.3099 7.17009 21.3199 4.93009 19.0699C2.69009 16.8199 2.68009 13.1799 4.93009 10.9399"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.59 13.4099C8.24996 11.0699 8.24996 7.26988 10.59 4.91988C12.93 2.56988 16.73 2.57988 19.08 4.91988C21.43 7.25988 21.42 11.0599 19.08 13.4099"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddressIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2L13.95 22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.53 12.22L2 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SettingIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      fill={color || "#000000"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={size}
      height={size}
    >
      <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z" />
    </svg>
  );
}

export function HamburgerIcon({ size = "24", color = "#292D32" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const HomeIcon = ({ color, size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.02 2.84004L3.63 7.04004C2.73 7.74004 2 9.23004 2 10.36V17.77C2 20.09 3.89 21.99 6.21 21.99H17.79C20.11 21.99 22 20.09 22 17.78V10.5C22 9.29004 21.19 7.74004 20.2 7.05004L14.02 2.72004C12.62 1.74004 10.37 1.79004 9.02 2.84004Z"
        stroke={color || "#292D32"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.99V14.99"
        stroke={color || "#292D32"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FormIcon = ({ size, color = "#292D32" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7C4 5.11438 4 4.17157 4.58579 3.58579C5.17157 3 6.11438 3 8 3H16C17.8856 3 18.8284 3 19.4142 3.58579C20 4.17157 20 5.11438 20 7V15C20 17.8284 20 19.2426 19.1213 20.1213C18.2426 21 16.8284 21 14 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15V7Z"
        stroke={color}
      />
      <path d="M15 18L15 21M9 18L9 21" stroke={color} strokeLinecap="round" />
      <path d="M9 8L15 8" stroke={color} strokeLinecap="round" />
      <path d="M9 12L15 12" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const DownArrow = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UpArraow = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9201 15.0499L13.4001 8.52989C12.6301 7.75989 11.3701 7.75989 10.6001 8.52989L4.08008 15.0499"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PreviousArrow = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 12H9.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 9L8.5 12L11.5 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LayerIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.01 2.92007L18.91 5.54007C20.61 6.29007 20.61 7.53007 18.91 8.28007L13.01 10.9001C12.34 11.2001 11.24 11.2001 10.57 10.9001L4.67 8.28007C2.97 7.53007 2.97 6.29007 4.67 5.54007L10.57 2.92007C11.24 2.62007 12.34 2.62007 13.01 2.92007Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11C3 11.84 3.63 12.81 4.4 13.15L11.19 16.17C11.71 16.4 12.3 16.4 12.81 16.17L19.6 13.15C20.37 12.81 21 11.84 21 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16C3 16.93 3.55 17.77 4.4 18.15L11.19 21.17C11.71 21.4 12.3 21.4 12.81 21.17L19.6 18.15C20.45 17.77 21 16.93 21 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserGroupIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9699 14.44C18.3399 14.67 19.8499 14.43 20.9099 13.72C22.3199 12.78 22.3199 11.24 20.9099 10.3C19.8399 9.59004 18.3099 9.35003 16.9399 9.59003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99994 14.44C5.62994 14.67 4.11994 14.43 3.05994 13.72C1.64994 12.78 1.64994 11.24 3.05994 10.3C4.12994 9.59004 5.65994 9.35003 7.02994 9.59003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.63C11.94 14.62 11.87 14.62 11.81 14.63C10.43 14.58 9.32996 13.45 9.32996 12.05C9.32996 10.62 10.48 9.46997 11.91 9.46997C13.34 9.46997 14.49 10.63 14.49 12.05C14.48 13.45 13.38 14.59 12 14.63Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08997 17.78C7.67997 18.72 7.67997 20.26 9.08997 21.2C10.69 22.27 13.31 22.27 14.91 21.2C16.32 20.26 16.32 18.72 14.91 17.78C13.32 16.72 10.69 16.72 9.08997 17.78Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TermsConditionIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6601 10.44L20.6801 14.62C19.8401 18.23 18.1801 19.69 15.0601 19.39C14.5601 19.35 14.0201 19.26 13.4401 19.12L11.7601 18.72C7.59006 17.73 6.30006 15.67 7.28006 11.49L8.26006 7.30001C8.46006 6.45001 8.70006 5.71001 9.00006 5.10001C10.1701 2.68001 12.1601 2.03001 15.5001 2.82001L17.1701 3.21001C21.3601 4.19001 22.6401 6.26001 21.6601 10.44Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.06 19.39C14.44 19.81 13.66 20.16 12.71 20.47L11.13 20.99C7.15998 22.27 5.06997 21.2 3.77997 17.23L2.49997 13.28C1.21997 9.30998 2.27997 7.20998 6.24997 5.92998L7.82997 5.40998C8.23997 5.27998 8.62997 5.16998 8.99997 5.09998C8.69997 5.70998 8.45997 6.44998 8.25997 7.29998L7.27997 11.49C6.29997 15.67 7.58998 17.73 11.76 18.72L13.44 19.12C14.02 19.26 14.56 19.35 15.06 19.39Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.64 8.53003L17.49 9.76003"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.66 12.4L14.56 13.14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImageIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6799 16.9599L18.5499 9.64988C17.4899 7.16988 15.5399 7.06988 14.2299 9.42988L12.3399 12.8399C11.3799 14.5699 9.58993 14.7199 8.34993 13.1699L8.12993 12.8899C6.83993 11.2699 5.01993 11.4699 4.08993 13.3199L2.36993 16.7699C1.15993 19.1699 2.90993 21.9999 5.58993 21.9999H18.3499C20.9499 21.9999 22.6999 19.3499 21.6799 16.9599Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.96997 8C8.62682 8 9.96997 6.65685 9.96997 5C9.96997 3.34315 8.62682 2 6.96997 2C5.31312 2 3.96997 3.34315 3.96997 5C3.96997 6.65685 5.31312 8 6.96997 8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PageBreakIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UniqueIdIcon = ({ color = "#292D32", size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3L16.44 5.34003L8.48999 5.32001C4.91999 5.32001 1.98999 8.25003 1.98999 11.84C1.98999 13.63 2.71999 15.26 3.89999 16.44"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 21.0001L7.56006 18.66L15.5101 18.6801C19.0801 18.6801 22.0101 15.75 22.0101 12.16C22.0101 10.37 21.2801 8.74006 20.1001 7.56006"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 14.67V9.33008L10.75 11.0001"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadImageIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 8V2L20 4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 2L16 4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.67004 18.9501L7.60004 15.6401C8.39004 15.1101 9.53004 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CameraIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76005 22H17.24C20 22 21.1 20.31 21.23 18.25L21.75 9.99C21.89 7.83 20.17 6 18 6C17.39 6 16.83 5.65 16.55 5.11L15.83 3.66C15.37 2.75 14.17 2 13.15 2H10.86C9.83005 2 8.63005 2.75 8.17005 3.66L7.45005 5.11C7.17005 5.65 6.61005 6 6.00005 6C3.83005 6 2.11005 7.83 2.25005 9.99L2.77005 18.25C2.89005 20.31 4.00005 22 6.76005 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 8H13.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RefreshIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.89 5.0799C14.02 4.8199 13.06 4.6499 12 4.6499C7.20996 4.6499 3.32996 8.5299 3.32996 13.3199C3.32996 18.1199 7.20996 21.9999 12 21.9999C16.79 21.9999 20.67 18.1199 20.67 13.3299C20.67 11.5499 20.13 9.8899 19.21 8.5099"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.13 5.32L13.24 2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.13 5.32007L12.76 7.78007"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SwitchIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 3.11 16.44 3.11 16.44M3.11 16.44H7.63M3.11 16.44V21.44M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DotLoader = ({ color = "#ffffff" }: { color?: string }) => {
  return (
    <svg
      version="1.1"
      id="L4"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
      width="80"
    >
      <circle fill={color} stroke="none" cx="6" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill={color} stroke="none" cx="26" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill={color} stroke="none" cx="46" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );
};
// Editor Icons
export const BoldIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3151 19.5C15.4741 19.5 17.4331 17.8695 17.4331 15.2655C17.4331 13.3065 15.9571 11.841 13.9471 11.6865V11.604C14.7169 11.4881 15.4199 11.1009 15.9293 10.5123C16.4387 9.92368 16.7209 9.1724 16.7251 8.39398C16.7251 6.12898 14.9821 4.70398 12.2041 4.70398H5.76465V19.5H12.3151ZM8.86215 7.01098H11.4061C12.8506 7.01098 13.6816 7.68748 13.6816 8.87698C13.6816 10.128 12.7381 10.857 11.0866 10.857H8.86215V7.00948V7.01098ZM8.86215 17.193V12.897H11.4571C13.2826 12.897 14.2771 13.635 14.2771 15.0195C14.2771 16.434 13.3126 17.193 11.5291 17.193H8.86065H8.86215Z"
        fill={color}
      />
    </svg>
  );
};

export const ItalicIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9864 17.511L14.2949 6.68252C14.4794 5.79002 14.6639 5.61752 16.3154 5.47202L16.4804 4.69202H10.8164L10.6514 5.47202C12.2414 5.61602 12.3434 5.79002 12.1589 6.68252L9.8549 17.511C9.6704 18.4035 9.4859 18.576 7.8359 18.72L7.6709 19.5H13.3319L13.4969 18.72C11.9069 18.5775 11.8034 18.4035 11.9879 17.511H11.9864Z"
        fill={color}
      />
    </svg>
  );
};

export const UnderlineIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9695 4.70398H6.1245V14.31C6.1245 17.4675 8.3295 19.7445 12 19.7445C15.6705 19.7445 17.8755 17.4675 17.8755 14.31V4.70398H16.0305V14.1885C16.0305 16.4235 14.5635 18.0435 12 18.0435C9.4365 18.0435 7.9695 16.4235 7.9695 14.1885V4.70398ZM18.75 22.5H5.25V21H18.75V22.5Z"
        fill={color}
      />
    </svg>
  );
};

export const LineThroughIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.4995 8.52901C9.4995 8.99401 9.624 9.40051 9.9045 9.75001H7.749C7.64703 9.3787 7.59705 8.99505 7.6005 8.61001C7.6005 6.16951 9.7545 4.45801 12.8205 4.45801C15.774 4.45801 17.9055 6.22051 17.988 8.73301H16.143C15.978 7.11301 14.697 6.11851 12.768 6.11851C10.923 6.11851 9.498 7.02151 9.498 8.52901H9.4995ZM12.7905 19.746C9.561 19.746 7.407 18.0855 7.233 15.531H9.078C9.294 17.121 10.7715 18.0855 12.894 18.0855C14.904 18.0855 16.359 17.028 16.359 15.573C16.359 14.3325 15.5385 13.512 13.488 13.0605L12.069 12.75H1.5V11.25H22.5V12.75H17.244C17.946 13.4055 18.2565 14.241 18.2565 15.2955C18.2565 18.0345 16.1025 19.746 12.7905 19.746Z"
        fill={color}
      />
    </svg>
  );
};

export const H1Icon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9555 19.4999V5.50342H11.0685V11.4299H4.137V5.50492H2.25V19.4999H4.137V13.0919H11.067V19.4999H12.9555ZM20.949 19.4999V5.50342H19.083L15.75 7.97392V9.87142L18.99 7.52392H19.083V19.4999H20.949Z"
        fill={color}
      />
    </svg>
  );
};

export const H2Icon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.457 19.5V5.50354H9.57V11.43H2.6385V5.50504H0.75V19.5H2.637V13.092H9.567V19.5H11.4555H11.457ZM15.99 9.40054V9.32854C15.99 7.99504 16.935 6.82654 18.564 6.82654C19.9995 6.82654 21.0765 7.73854 21.0765 9.18454C21.0765 10.467 20.2455 11.4405 19.476 12.312L14.2065 18.3105V19.5H23.25V17.859H16.8825V17.7465L20.604 13.4805C21.9165 11.9835 22.983 10.8045 22.983 9.05104C22.983 6.85654 21.2505 5.21704 18.6045 5.21704C15.693 5.21704 14.1555 7.20604 14.1555 9.32704V9.40054H15.99Z"
        fill={color}
      />
    </svg>
  );
};

export const ParagraphIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 4C14.0609 4 15.0783 4.42143 15.8284 5.17157C16.5786 5.92172 17 6.93913 17 8C17 9.06087 16.5786 10.0783 15.8284 10.8284C15.0783 11.5786 14.0609 12 13 12H11V18H9V4H13ZM13 10C13.5304 10 14.0391 9.78929 14.4142 9.41421C14.7893 9.03914 15 8.53043 15 8C15 7.46957 14.7893 6.96086 14.4142 6.58579C14.0391 6.21071 13.5304 6 13 6H11V10H13Z"
        fill={color}
      />
    </svg>
  );
};

export const FormulaIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.97 15V9C21.97 4 19.97 2 14.97 2H8.96997C3.96997 2 1.96997 4 1.96997 9V15C1.96997 20 3.96997 22 8.96997 22H14.97C19.97 22 21.97 20 21.97 15Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.72 3.25L3.27002 19.7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0601 18V13"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 15.5H13.5"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 7.5H5.5"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ListIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.75V5.25H4.5V0.75H0ZM1.5 2.25H3V3.75H1.5V2.25ZM6 2.25V3.75H17.25V2.25H6ZM0 6.75V11.25H4.5V6.75H0ZM1.5 8.25H3V9.75H1.5V8.25ZM6 8.25V9.75H17.25V8.25H6ZM0 12.75V17.25H4.5V12.75H0ZM1.5 14.25H3V15.75H1.5V14.25ZM6 14.25V15.75H17.25V14.25H6Z"
        fill={color}
      />
    </svg>
  );
};

export const ListNumbarIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.47656 0.25L1.24219 0.507812C1.24219 0.507812 0.673828 1 0.304688 1V2.5C0.814453 2.5 1.16602 2.29199 1.5 2.10156V5.5H3V0.25H1.47656ZM5.25 2.5V4H18V2.5H5.25ZM1.875 7C0.837891 7 0 7.83789 0 8.875V9.25H1.5V8.875C1.5 8.71387 1.71387 8.5 1.875 8.5C2.03613 8.5 2.25 8.71387 2.25 8.875L2.17969 8.94531L0.234375 10.8203L0 11.0312V12.25H3.75V10.75H2.46094L3.11719 10.0938L3.21094 10.0234L3.1875 10C3.5625 9.69238 3.75 9.23535 3.75 8.875C3.75 7.83789 2.91211 7 1.875 7ZM5.25 9.25V10.75H18V9.25H5.25ZM0 13.75V15.25H1.03125L0.84375 15.5547L0.75 15.7188V16.75H1.875C2.03613 16.75 2.25 16.9639 2.25 17.125C2.25 17.2861 2.03613 17.5 1.875 17.5H0V19H1.875C2.91211 19 3.75 18.1621 3.75 17.125C3.75 16.3721 3.24023 15.8535 2.60156 15.5547L2.90625 15.0391L3 14.8516V13.75H0ZM5.25 16V17.5H18V16H5.25Z"
        fill={color}
      />
    </svg>
  );
};

export const Heading1Icon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9555 14.4999V0.503418H9.0685V6.42992H2.137V0.504918H0.25V14.4999H2.137V8.09192H9.067V14.4999H10.9555ZM18.949 14.4999V0.503418H17.083L13.75 2.97392V4.87142L16.99 2.52392H17.083V14.4999H18.949Z"
        fill={color}
      />
    </svg>
  );
};

export const Heading2Icon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.457 14.5V0.503541H9.57V6.43004H2.6385V0.505041H0.75V14.5H2.637V8.09204H9.567V14.5H11.4555H11.457ZM15.99 4.40054V4.32854C15.99 2.99504 16.935 1.82654 18.564 1.82654C19.9995 1.82654 21.0765 2.73854 21.0765 4.18454C21.0765 5.46704 20.2455 6.44054 19.476 7.31204L14.2065 13.3105V14.5H23.25V12.859H16.8825V12.7465L20.604 8.48054C21.9165 6.98354 22.983 5.80454 22.983 4.05104C22.983 1.85654 21.2505 0.217041 18.6045 0.217041C15.693 0.217041 14.1555 2.20604 14.1555 4.32704V4.40054H15.99Z"
        fill={color}
      />
    </svg>
  );
};

export const AlignCenterIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H18V2H0V0ZM4 4H14V6H4V4ZM0 8H18V10H0V8ZM4 12H14V14H4V12ZM0 16H18V18H0V16Z"
        fill={color}
      />
    </svg>
  );
};

export const AlignLeftIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H18V2H0V0ZM0 4H12V6H0V4ZM0 8H18V10H0V8ZM0 12H12V14H0V12ZM0 16H18V18H0V16Z"
        fill={color}
      />
    </svg>
  );
};

export const AlignRightIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H18V2H0V0ZM6 4H18V6H6V4ZM0 8H18V10H0V8ZM6 12H18V14H6V12ZM0 16H18V18H0V16Z"
        fill={color}
      />
    </svg>
  );
};

export const AlignJustifyIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H18V2H0V0ZM0 4H18V6H0V4ZM0 8H18V10H0V8ZM0 12H18V14H0V12ZM0 16H18V18H0V16Z"
        fill={color}
      />
    </svg>
  );
};

export const CodeIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6ZM9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6Z"
        fill={color}
      />
    </svg>
  );
};

export const QuoteIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.42665 0.557932C2.66135 2.97609 0.569566 5.79054 0.151281 9.00139C-0.499894 13.9999 3.9702 16.4466 6.23515 14.2483C8.5001 12.05 7.1424 9.25974 5.50235 8.49704C3.8623 7.73429 2.85935 7.99994 3.0343 6.98074C3.20925 5.96149 5.54255 3.13559 7.59245 1.81954C7.72845 1.70389 7.7802 1.47949 7.64925 1.30929C7.5631 1.19729 7.39415 0.977722 7.1424 0.650507C6.92225 0.364377 6.71135 0.375082 6.42665 0.557932Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3395 0.557932C12.5742 2.97609 10.4824 5.79054 10.0641 9.00139C9.41297 13.9999 13.8831 16.4466 16.148 14.2483C18.413 12.05 17.0553 9.25974 15.4152 8.49704C13.7752 7.73429 12.7722 7.99994 12.9472 6.98074C13.1221 5.96149 15.4554 3.13559 17.5053 1.81954C17.6413 1.70389 17.6931 1.47949 17.5621 1.30929C17.476 1.19729 17.307 0.977722 17.0553 0.650507C16.8351 0.364377 16.6242 0.375082 16.3395 0.557932Z"
        fill={color}
      />
    </svg>
  );
};

export const UnpublishIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_59161)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9458 1.02901C24.0003 0.892718 24.0137 0.743408 23.9842 0.599594C23.9547 0.455779 23.8836 0.323785 23.7798 0.219975C23.676 0.116166 23.544 0.0451054 23.4002 0.0156042C23.2564 -0.013897 23.1071 -0.000541715 22.9708 0.0540143L1.15029 8.78251C0.958125 8.85943 0.790906 8.98788 0.667038 9.15371C0.54317 9.31955 0.467454 9.51634 0.448225 9.72243C0.428996 9.92853 0.466998 10.1359 0.55805 10.3218C0.649101 10.5077 0.789672 10.6649 0.964291 10.776L8.45679 15.543L10.7533 19.152C10.8618 19.3158 11.0301 19.4304 11.2222 19.4714C11.4143 19.5123 11.6148 19.4763 11.7807 19.371C11.9465 19.2657 12.0643 19.0995 12.109 18.9083C12.1536 18.717 12.1214 18.5158 12.0193 18.348L9.95529 15.105L21.1963 3.86401L18.3538 10.971C18.3147 11.0629 18.2944 11.1616 18.294 11.2614C18.2936 11.3612 18.3131 11.4601 18.3514 11.5522C18.3897 11.6444 18.446 11.728 18.517 11.7981C18.588 11.8682 18.6723 11.9235 18.7649 11.9606C18.8576 11.9978 18.9567 12.016 19.0565 12.0144C19.1563 12.0127 19.2547 11.9912 19.3461 11.951C19.4374 11.9108 19.5198 11.8527 19.5885 11.7803C19.6571 11.7078 19.7106 11.6224 19.7458 11.529L23.9458 1.02901ZM20.1358 2.80351L8.89479 14.0445L2.38629 9.90301L20.1358 2.80351ZM23.9998 18.75C23.9998 20.1424 23.4467 21.4778 22.4621 22.4623C21.4775 23.4469 20.1422 24 18.7498 24C17.3574 24 16.022 23.4469 15.0375 22.4623C14.0529 21.4778 13.4998 20.1424 13.4998 18.75C13.4998 17.3576 14.0529 16.0223 15.0375 15.0377C16.022 14.0531 17.3574 13.5 18.7498 13.5C20.1422 13.5 21.4775 14.0531 22.4621 15.0377C23.4467 16.0223 23.9998 17.3576 23.9998 18.75ZM16.7188 16.719C16.7885 16.6492 16.8712 16.5938 16.9623 16.5559C17.0535 16.5181 17.1511 16.4987 17.2498 16.4987C17.3484 16.4987 17.4461 16.5181 17.5372 16.5559C17.6284 16.5938 17.7111 16.6492 17.7808 16.719L18.7498 17.6895L19.7188 16.719C19.8596 16.5782 20.0506 16.4991 20.2498 16.4991C20.449 16.4991 20.64 16.5782 20.7808 16.719C20.9216 16.8598 21.0007 17.0508 21.0007 17.25C21.0007 17.4492 20.9216 17.6402 20.7808 17.781L19.8103 18.75L20.7808 19.719C20.9216 19.8598 21.0007 20.0508 21.0007 20.25C21.0007 20.4492 20.9216 20.6402 20.7808 20.781C20.64 20.9218 20.449 21.001 20.2498 21.001C20.0506 21.001 19.8596 20.9218 19.7188 20.781L18.7498 19.8105L17.7808 20.781C17.64 20.9218 17.449 21.001 17.2498 21.001C17.0506 21.001 16.8596 20.9218 16.7188 20.781C16.578 20.6402 16.4988 20.4492 16.4988 20.25C16.4988 20.0508 16.578 19.8598 16.7188 19.719L17.6893 18.75L16.7188 17.781C16.6489 17.7113 16.5935 17.6286 16.5557 17.5375C16.5179 17.4463 16.4985 17.3487 16.4985 17.25C16.4985 17.1514 16.5179 17.0537 16.5557 16.9626C16.5935 16.8714 16.6489 16.7887 16.7188 16.719Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2_59161">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NumberIcon = ({ color = "#292D32", size = "24" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 11.5V28.5C27 29.554 26.9767 30.489 26.895 31.322C26.5567 35.793 25.11 37 21.1667 37H18.8333C14.89 37 13.4433 35.793 13.105 31.322C13.0233 30.489 13 29.554 13 28.5V11.5C13 10.446 13.0233 9.511 13.105 8.678C13.4433 4.207 14.89 3 18.8333 3H21.1667C25.11 3 26.5567 4.207 26.895 8.678C26.9767 9.511 27 10.446 27 11.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7579 28.9955C12.7579 30.1109 12.8117 31.1004 13 31.982C12.6235 32 12.2738 32 11.8704 32H10.956C3.80196 32 2 30.7946 2 25.991V14.009C2 9.2054 3.80196 8 10.956 8H11.8704C12.2738 8 12.6235 8 13 8.01799C12.8117 8.89955 12.7579 9.88906 12.7579 11.0045V28.9955Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 14.009V25.991C38 30.7946 36.198 32 29.044 32H28.1296C27.7262 32 27.3765 32 27 31.982C27.1883 31.1004 27.2421 30.1109 27.2421 28.9955V11.0045C27.2421 9.88906 27.1883 8.89955 27 8.01799C27.3765 8 27.7262 8 28.1296 8H29.044C36.198 8 38 9.2054 38 14.009Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50426 17.2727V26H7.65909V19.0241H7.60795L5.60938 20.277V18.6406L7.76989 17.2727H9.50426Z"
        fill={color}
      />
      <path
        d="M16.7074 26V24.6705L19.8139 21.794C20.0781 21.5384 20.2997 21.3082 20.4787 21.1037C20.6605 20.8991 20.7983 20.6989 20.892 20.5028C20.9858 20.304 21.0327 20.0895 21.0327 19.8594C21.0327 19.6037 20.9744 19.3835 20.858 19.1989C20.7415 19.0114 20.5824 18.8679 20.3807 18.7685C20.179 18.6662 19.9503 18.6151 19.6946 18.6151C19.4276 18.6151 19.1946 18.669 18.9957 18.777C18.7969 18.8849 18.6435 19.0398 18.5355 19.2415C18.4276 19.4432 18.3736 19.6832 18.3736 19.9616H16.6222C16.6222 19.3906 16.7514 18.8949 17.0099 18.4744C17.2685 18.054 17.6307 17.7287 18.0966 17.4986C18.5625 17.2685 19.0994 17.1534 19.7074 17.1534C20.3324 17.1534 20.8764 17.2642 21.3395 17.4858C21.8054 17.7045 22.1676 18.0085 22.4261 18.3977C22.6847 18.7869 22.8139 19.233 22.8139 19.7358C22.8139 20.0653 22.7486 20.3906 22.6179 20.7116C22.4901 21.0327 22.2614 21.3892 21.9318 21.7812C21.6023 22.1705 21.1378 22.6378 20.5384 23.1832L19.2642 24.4318V24.4915H22.929V26H16.7074Z"
        fill={color}
      />
      <path
        d="M32.9332 26.1193C32.2969 26.1193 31.7301 26.0099 31.233 25.7912C30.7386 25.5696 30.348 25.2656 30.0611 24.8793C29.777 24.4901 29.6307 24.0412 29.6222 23.5327H31.4801C31.4915 23.7457 31.5611 23.9332 31.6889 24.0952C31.8196 24.2543 31.9929 24.3778 32.2088 24.4659C32.4247 24.554 32.6676 24.598 32.9375 24.598C33.2188 24.598 33.4673 24.5483 33.6832 24.4489C33.8991 24.3494 34.0682 24.2116 34.1903 24.0355C34.3125 23.8594 34.3736 23.6562 34.3736 23.4261C34.3736 23.1932 34.3082 22.9872 34.1776 22.8082C34.0497 22.6264 33.8651 22.4844 33.6236 22.3821C33.3849 22.2798 33.1009 22.2287 32.7713 22.2287H31.9574V20.8736H32.7713C33.0497 20.8736 33.2955 20.8253 33.5085 20.7287C33.7244 20.6321 33.892 20.4986 34.0114 20.3281C34.1307 20.1548 34.1903 19.9531 34.1903 19.723C34.1903 19.5043 34.1378 19.3125 34.0327 19.1477C33.9304 18.9801 33.7855 18.8494 33.598 18.7557C33.4134 18.6619 33.1974 18.6151 32.9503 18.6151C32.7003 18.6151 32.4716 18.6605 32.2642 18.7514C32.0568 18.8395 31.8906 18.9659 31.7656 19.1307C31.6406 19.2955 31.5739 19.4886 31.5653 19.7102H29.7969C29.8054 19.2074 29.9489 18.7642 30.2273 18.3807C30.5057 17.9972 30.8807 17.6974 31.3523 17.4815C31.8267 17.2628 32.3622 17.1534 32.9588 17.1534C33.5611 17.1534 34.0881 17.2628 34.5398 17.4815C34.9915 17.7003 35.3423 17.9957 35.5923 18.3679C35.8452 18.7372 35.9702 19.152 35.9673 19.6122C35.9702 20.1009 35.8182 20.5085 35.5114 20.8352C35.2074 21.1619 34.8111 21.3693 34.3224 21.4574V21.5256C34.9645 21.608 35.4531 21.831 35.7884 22.1946C36.1264 22.5554 36.294 23.0071 36.2912 23.5497C36.294 24.0469 36.1506 24.4886 35.8608 24.875C35.5739 25.2614 35.1776 25.5653 34.6719 25.7869C34.1662 26.0085 33.5866 26.1193 32.9332 26.1193Z"
        fill={color}
      />
    </svg>
  );
};

export function FrequencyIcon({ color = "#292D32", size = "24" }: IconProps) {
  return (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 47"
      width={size}
      height={size}
      stroke={color}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M24.104,41.577c-0.025,0-0.053-0.001-0.078-0.001c-1.093-0.035-2.025-0.802-2.271-1.867l-5.46-23.659l-3.199,8.316 c-0.357,0.93-1.252,1.544-2.249,1.544H2.41c-1.331,0-2.41-1.079-2.41-2.41c0-1.331,1.079-2.41,2.41-2.41h6.78l5.433-14.122 c0.38-0.989,1.351-1.612,2.418-1.54c1.057,0.074,1.941,0.831,2.18,1.863l5.186,22.474l4.618-15.394 c0.276-0.923,1.078-1.592,2.035-1.702c0.953-0.107,1.889,0.36,2.365,1.198l4.127,7.222h7.037c1.331,0,2.41,1.079,2.41,2.41 c0,1.331-1.079,2.41-2.41,2.41h-8.436c-0.865,0-1.666-0.463-2.094-1.214l-2.033-3.559l-5.616,18.722 C26.104,40.88,25.164,41.577,24.104,41.577z"></path>{" "}
          </g>
        </g>
      </g>
    </svg>
  );
}

export const CalenderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"14"}
      height={"14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.6669 3.11119H1.66688C1.36006 3.11119 1.11133 3.35992 1.11133 3.66675V10.889C1.11133 11.1958 1.36006 11.4445 1.66688 11.4445H11.6669C11.9737 11.4445 12.2224 11.1958 12.2224 10.889V3.66675C12.2224 3.35992 11.9737 3.11119 11.6669 3.11119Z"
        stroke={"#363636"}
        strokeWidth="1.11111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.88867 2.00008V4.2223M6.94423 6.7223H3.88867M9.44423 8.94452H3.88867M9.44423 2.00008V4.2223"
        stroke={"#363636"}
        strokeWidth="1.11111"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const AggregatorIcon = ({
  color = "#222222",
  size = "24",
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="16" y="9" width="4" height="4" rx="2" transform="rotate(90 16 9)" stroke="#222222" />
      <rect x="20" y="17" width="4" height="4" rx="2" transform="rotate(90 20 17)" stroke={color} />
      <path
        d="M5 4V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H16"
        stroke={color}
      />
      <path
        d="M5 7V7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H12"
        stroke={color}
      />
    </svg>
  );
};
export const ManageAppsIcon = ({
  color = "#222222",
  size = "24",
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 305 305"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10"
        y="34.7705"
        width="108.429"
        height="108.429"
        rx="20"
        stroke={color}
        strokeWidth="19"
      />
      <rect
        x="10"
        y="186.571"
        width="108.429"
        height="108.429"
        rx="20"
        stroke={color}
        strokeWidth="19"
      />
      <rect
        x="162.885"
        y="186.571"
        width="108.429"
        height="108.429"
        rx="20"
        stroke={color}
        strokeWidth="19"
      />
      <rect
        x="162.885"
        y="10.916"
        width="130.115"
        height="130.115"
        rx="20"
        stroke={color}
        strokeWidth="19"
      />
    </svg>
  );
};
export const MenuIcon = () => {
  return (
    <svg
      width="175"
      height="105"
      viewBox="0 0 175 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="175" height="15" rx="7.5" fill="#333333" />
      <rect y="45" width="175" height="15" rx="7.5" fill="#333333" />
      <rect y="90" width="175" height="15" rx="7.5" fill="#333333" />
    </svg>
  );
};

export const UnifyListIconLoader = () => {
  return (
    <svg width="77" height="83" viewBox="0 0 77 83" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="logo-gradient" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="#1F005C">
            <animate
              attributeName="stop-color"
              values="#1F005C; #5B0060; #870160; #AC255E; #CA485C; #E16B5C; #1F005C"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>

          <stop offset="100%" stopColor="#5B0060">
            <animate
              attributeName="stop-color"
              values="#5B0060; #870160; #AC255E; #CA485C; #E16B5C; #1F005C; #5B0060"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>

        <linearGradient id="logo-gradient2" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="#1F005C">
            <animate
              attributeName="stop-color"
              values="#1F005C; #5B0060; #870160; #AC255E; #CA485C; #E16B5C; #1F005C"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>

          <stop offset="100%" stopColor="#5B0060">
            <animate
              attributeName="stop-color"
              values="#5B0060; #870160; #AC255E; #CA485C; #E16B5C; #1F005C; #5B0060"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>

      <g>
        <path
          d="M41 6L6.00007 28.5L6 32L6.00007 34.5L41 57.5"
          stroke="url(#logo-gradient)"
          strokeWidth="12"
          className="path-1"
        />
        <path
          d="M36 77.5L70.9999 55L71 51.5L70.9999 49L36 26"
          stroke="url(#logo-gradient2)"
          strokeWidth="12"
          className="path-2"
        />
      </g>
    </svg>
  );
};
export const SuccessIcon = ({ color = "#222", size = 24 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" fill="#7E869E40" stroke={color} strokeWidth="1.5" />
    <path d="M8 12L11 15L16 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const BarChartIcon = ({ color = "", size = "24" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={`${color ? color : "none"}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 20H3" stroke="#222222" strokeLinecap="round" />
    <path
      d="M10 16V10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10V16"
      stroke="#222222"
      strokeLinecap="round"
    />
    <path
      d="M18 16V6C18 4.89543 17.1046 4 16 4C14.8954 4 14 4.89543 14 6V16"
      stroke="#222222"
      strokeLinecap="round"
    />
  </svg>
);
export const PieChartIcon = ({ color = "", size = "24" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={`${color ? color : "none"}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" stroke="#33363F" strokeWidth="2" />
    <path d="M12 12H21" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M12 3V11.9379C12 11.9777 12.0158 12.0158 12.0439 12.0439L18 18"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LineChartIcon = ({ color = "", size = "24" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={`${color ? color : "none"}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" fill="#7E869E" fillOpacity="0.25" />
    <path
      d="M18 8L14.1047 12.8691C14.0488 12.9389 13.9447 12.9447 13.8815 12.8815L11.1161 10.1161C11.0538 10.0538 10.9513 10.0584 10.8948 10.1262L6 16"
      stroke="#222222"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TableIcon = ({ color = "", size = "24" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={`${color ? color : "none"}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 9H21V18C21 18.9428 21 19.4142 20.7071 19.7071C20.4142 20 19.9428 20 19 20H15V9Z"
      stroke="#222222"
      strokeLinecap="round"
    />
    <path
      d="M3 9H9V20H5C4.05719 20 3.58579 20 3.29289 19.7071C3 19.4142 3 18.9428 3 18V9Z"
      stroke="#222222"
      strokeLinecap="round"
    />
    <rect x="9" y="9" width="6" height="11" stroke="#222222" strokeLinecap="round" />
    <path
      d="M3 6C3 5.05719 3 4.58579 3.29289 4.29289C3.58579 4 4.05719 4 5 4H19C19.9428 4 20.4142 4 20.7071 4.29289C21 4.58579 21 5.05719 21 6V9H3V6Z"
      stroke="#222222"
      strokeLinecap="round"
    />
  </svg>
);
